angular.module("bm.practice.common.templates", ["bmp/bmp-additional-custom-options/bmp-additional-custom-options.html", "bmp/bmp-batch-process-dialog/bmp-batch-process-dialog.html", "bmp/bmp-batch-process-dialog/bmp-batch-process-error-dialog.html", "bmp/bmp-bento-datepicker-wrapper/bmp-bento-datepicker-wrapper.html", "bmp/bmp-carousel/bmp-carousel.html", "bmp/bmp-combobox/bmp-combobox.html", "bmp/bmp-confirmation-dialog/bmp-confirmation-dialog.html", "bmp/bmp-control-group/bmp-control-group.html", "bmp/bmp-custom-table/bmp-custom-table.html", "bmp/bmp-date-range-boxes/bmp-date-range-boxes.html", "bmp/bmp-date-range-selector/bmp-date-range-selector.html", "bmp/bmp-enum-control/bmp-enum-combo-multi-select.html", "bmp/bmp-enum-control/bmp-enum-combo.html", "bmp/bmp-enum-control/bmp-enum-dropdown.html", "bmp/bmp-enum-control/bmp-enum-radio-button-group.html", "bmp/bmp-enum-control/bmp-enum-radio-group.html", "bmp/bmp-enum-control/bmp-enum-radio.html", "bmp/bmp-filter-tree-component/bmp-filter-tree-component.html", "bmp/bmp-filter-tree-component/bmp-filter-tree-value-box.html", "bmp/bmp-grid-filter-panel/bmp-grid-filter-modal.html", "bmp/bmp-grid-filter-panel/bmp-grid-filter-panel.html", "bmp/bmp-grid/bmp-grid-import-modal.html", "bmp/bmp-grid/bmp-grid-with-optional-panel.html", "bmp/bmp-grid/bmp-grid.html", "bmp/bmp-group-sort/bmp-group-sort-item.html", "bmp/bmp-group-sort/bmp-group-sort.html", "bmp/bmp-iframe-carousel/bmp-iframe-carousel.html", "bmp/bmp-input-group-btn-dropdown/bmp-input-group-btn-dropdown.html", "bmp/bmp-master-detail/bmp-detail-tab-view.html", "bmp/bmp-master-detail/bmp-detail-view.html", "bmp/bmp-master-detail/bmp-master-view.html", "bmp/bmp-master-detail/bmp-modal-view.html", "bmp/bmp-master-detail/bmp-workspace-view.html", "bmp/bmp-message-dialog/bmp-message-dialog.html", "bmp/bmp-modal-wizard/bmp-modal-wizard.html", "bmp/bmp-modal/bmp-modal-button.html", "bmp/bmp-modal/bmp-modal.html", "bmp/bmp-multi-select-control/bmp-multi-select-control.html", "bmp/bmp-multi-select-tag-box/bmp-multi-select-tag-box.html", "bmp/bmp-page-header/bmp-page-header.html", "bmp/bmp-page-header/bmp-sub-page-header.html", "bmp/bmp-posted-and-approved-filters/bmp-posted-and-approved-filters.html", "bmp/bmp-radio-button-group/bmp-radio-button-group.html", "bmp/bmp-radio-circle-button-group/bmp-radio-circle-button-group.html", "bmp/bmp-routable-sidenav/bmp-routable-sidenav.html", "bmp/bmp-routable-tabset/bmp-routable-tabset.html", "bmp/bmp-select-control/bmp-filtered-select-combo.html", "bmp/bmp-select-control/bmp-select-combo-multi-select.html", "bmp/bmp-select-control/bmp-select-combo.html", "bmp/bmp-select-control/bmp-select-dropdown.html", "bmp/bmp-select-control/bmp-select-typeahead.html", "bmp/bmp-slideout-filter-panel/bmp-grid-slideout-filter.html", "bmp/bmp-slideout-filter-panel/bmp-slideout-filter-panel.html", "bmp/bmp-slideout-filter-panel/date/bmp-grid-date-filter-date-range-option.html", "bmp/bmp-slideout-filter-panel/enum/bmp-grid-slideout-enum-filter.html", "bmp/bmp-slideout-filter-panel/select/bmp-grid-slideout-select-filter.html", "bmp/bmp-table/bmp-table.html", "bmp/bmp-tabset/bmp-tabset.html", "bmp/bmp-toolbar/bmp-toolbar.html", "bmp/bmp-view-mode-tabset/bmp-view-mode-tabset.html", "bmp/bmp-wait/bmp-wait.html", "bmp/bmp-wijmo-table-hierarchy/bmp-wijmo-table-hierarchy.html", "bmp/bmp-wijmo-table/bmp-wijmo-table.html", "bmp/bmp-wijmo-table/cells/actions/bmp-actions-cell.html", "bmp/bmp-wijmo-table/cells/bmp-wijmo-table-custom-column-header.html", "bmp/bmp-wijmo-table/cells/bmp-wijmo-table-non-editable-cell.html", "bmp/bmp-wijmo-table/cells/display/bmo-wijmo-table-icon-cell.html", "bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-boolean-cell.html", "bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-button-cell.html", "bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-custom-cell.html", "bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-link-cell.html", "bmp/bmp-wijmo-table/cells/edit/bmp-editable-cell.html", "bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-bento-select.html", "bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-date.html", "bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-enum.html", "bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-number.html", "bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-select.html", "bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-text.html", "bmp/bmp-wijmo-table/cells/select/bmp-wijmo-table-select-row-header.html", "bmp/bmp-wijmo-table/cells/select/bmp-wijmo-table-select-top-left.html", "bmp/bmp-icons/svg/accounting.svg", "bmp/bmp-icons/svg/activity-statements.svg", "bmp/bmp-icons/svg/advisory.svg", "bmp/bmp-icons/svg/amnesty-forgiveness.svg", "bmp/bmp-icons/svg/ar-income-tax.svg", "bmp/bmp-icons/svg/checkpoint-engage.svg", "bmp/bmp-icons/svg/combined-shape.svg", "bmp/bmp-icons/svg/company-formations.svg", "bmp/bmp-icons/svg/cuentasde-inversion.svg", "bmp/bmp-icons/svg/fixed-assets.svg", "bmp/bmp-icons/svg/gross-income-tax.svg", "bmp/bmp-icons/svg/investment-accounts.svg", "bmp/bmp-icons/svg/no-app.svg", "bmp/bmp-icons/svg/onvio.svg", "bmp/bmp-icons/svg/secretarial.svg", "bmp/bmp-icons/svg/tax-amnesty.svg", "bmp/bmp-icons/svg/tax.svg", "bmp/bmp-icons/svg/trial-balance-estudio-contable.svg", "bmp/bmp-icons/svg/trial-balance.svg", "bmp/bmp-icons/svg/ultra-tax.svg", "bmp/bmp-icons/svg/vat.svg", "bmp/bmp-icons/svg/workpapers.svg"]);

angular.module("bmp/bmp-additional-custom-options/bmp-additional-custom-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-additional-custom-options/bmp-additional-custom-options.html",
    "<div class=\"form-group\">\n" +
    "    <div ng-if=\"vm.additionalOption.dataType === 'SELECT'\">\n" +
    "        <span id=\"{{::vm.additionalOption.id}}\" class=\"sr-only\">{{vm.additionalOption.name}}</span>\n" +
    "        <input type=\"checkbox\" class=\"interactiveElement\" data-ng-model=\"vm.ngModel.value\" aria-labelledby=\"{{vm.additionalOption.id}}\"  style=\"margin-right:4px;\" date-qe-id=\"{{::vm.additionalOption.id + '-checkbox'}}\">{{vm.additionalOption.name}}<br />\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.additionalOption.dataType === 'SINGLESELECTRADIO'\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"{{::vm.additionalOption.id}}\"\n" +
    "             data-bmp-control-group-label=\"{{vm.additionalOption.name}}\">\n" +
    "            <bmp-enum-radio-group\n" +
    "                                  enum=\"{{vm.additionalOption.listType}}\"\n" +
    "                                  name=\"{{::vm.additionalOption.id}}\"\n" +
    "                                  ng-model=\"vm.ngModel.value\"\n" +
    "                                  value-property=\"id\">\n" +
    "            </bmp-enum-radio-group>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.additionalOption.dataType === 'SINGLESELECTENUM'\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"{{::vm.additionalOption.id}}\"\n" +
    "             data-bmp-control-group-label=\"{{vm.additionalOption.name}}\">\n" +
    "            <bmp-enum-combo\n" +
    "                            enum=\"{{vm.additionalOption.listType}}\"\n" +
    "                            custom-url=\"vm.additionalOption.customUrl\"\n" +
    "                            name=\"{{::vm.additionalOption.id}}\"\n" +
    "                            ng-model=\"vm.ngModel.value\"\n" +
    "                            value-property=\"id\"\n" +
    "                            required=\"true\">\n" +
    "            </bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.additionalOption.dataType === 'LINK'\">\n" +
    "        <a ui-sref=\"{{::vm.additionalOption.id}}\" ui-sref-opts=\"{reload: true}\">{{vm.additionalOption.name}}</a> <br />\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-batch-process-dialog/bmp-batch-process-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-batch-process-dialog/bmp-batch-process-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\" data-ng-if=\"bmpBatchProcessDialog.showHeader()\">\n" +
    "        <span>{{bmpBatchProcessDialog.titleText()}}</span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body modal-confirm-body width-full\" ng-class=\"{'no-text': bmpBatchProcessDialog._hideProcessText}\" bento-busy-loader=\"bmpBatchProcessDialog.loading\">\n" +
    "        <i class=\"glyphicons warning_sign modal-confirm-icon display-inline-block\"></i>\n" +
    "        <span  data-ng-if=\"!bmpBatchProcessDialog._hideProcessText\" class=\"modal-confirm-message display-inline-block\">\n" +
    "            {{bmpBatchProcessDialog.progressText()}}\n" +
    "        </span>\n" +
    "        <div uib-progressbar\n" +
    "             value=\"bmpBatchProcessDialog.percentageProcessed()\"\n" +
    "             animate=\"true\"\n" +
    "             type=\"{{bmpBatchProcessDialog.progressBarType()}}\"\n" +
    "             class=\"generate-next-progressbar progress-striped progress active\"></div>\n" +
    "\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button id=\"bmpBatchProcessDialog.cancel\"\n" +
    "                class=\"btn btn-default\"\n" +
    "                data-ng-class=\"{disabled: bmpBatchProcessDialog.processesComplete()}\"\n" +
    "                data-ng-click=\"bmpBatchProcessDialog.onCancelProgress()\"\n" +
    "                data-ng-disabled=\"bmpBatchProcessDialog.processesComplete()\"\n" +
    "                formnovalidate>\n" +
    "            {{bmpBatchProcessDialog.cancelText()}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-batch-process-dialog/bmp-batch-process-error-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-batch-process-dialog/bmp-batch-process-error-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\" ng-if=\"bmpBatchProcessErrorDialog.showHeader()\">\n" +
    "        <i class=\"glyphicons warning_sign modal-confirm-icon display-inline\"></i> {{bmpBatchProcessErrorDialog.titleText()}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <ul>\n" +
    "            <li ng-repeat=\"error in bmpBatchProcessErrorDialog.errors() track by $index\"\n" +
    "                data-ng-bind-html=\"error.errorText\"></li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button id=\"bmpBatchProcessDialog.cancel\"\n" +
    "                class=\"btn btn-default\"\n" +
    "                data-ng-click=\"bmpBatchProcessErrorDialog.onClose()\"\n" +
    "                formnovalidate>{{bmpBatchProcessErrorDialog.closeText()}}</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-bento-datepicker-wrapper/bmp-bento-datepicker-wrapper.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-bento-datepicker-wrapper/bmp-bento-datepicker-wrapper.html",
    "<div class=\"input-group bmp-input-group-icon-only bmp-bento-datepicker-wrapper\" role=\"none\"\n" +
    "     ng-form=\"bmpDatepickerForm\">\n" +
    "    <label class=\"sr-only\" for=\"{{::vm.name}}\">\n" +
    "        {{ 'Bluemoon.Practice.Common.DateRangeSelector.SelectedDateLabel' | translate }}\n" +
    "    </label>\n" +
    "    <input autocomplete=\"off\" type=\"text\" class=\"form-control\"\n" +
    "           name=\"dateField\"\n" +
    "           data-qe-id=\"{{::vm.name+'-date'}}\"\n" +
    "           id=\"{{::vm.name}}\"\n" +
    "           ng-model=\"vm.value\"\n" +
    "           ng-model-options=\"vm.getModelOptions()\"\n" +
    "           ng-change=\"vm.change()\"\n" +
    "           ng-blur=\"vm.handleBlur()\"\n" +
    "           data-ng-disabled=\"vm.ngDisabled\"\n" +
    "           ng-required=\"vm.ngRequired\"\n" +
    "           ng-readonly=\"vm.ngReadonly\"\n" +
    "           bm-format-on-blur=\"\"\n" +
    "           bm-focus-on-event=\"vm.bmFocusOnEvent\"\n" +
    "           bm-focus-on-link=\"vm.bmFocusOnLink\"\n" +
    "           placeholder=\"{{vm.placeholder}}\"\n" +
    "           bmp-date=\"\"\n" +
    "           bmp-select-on-focus=\"vm.selectOnFocus\"\n" +
    "           data-fef-tab-stop=\"vm.tabStop()\"\n" +
    "           aria-labelledby=\"{{::vm.name+'-label'}}\"\n" +
    "           />\n" +
    "    <input autocomplete=\"off\" type=\"text\"\n" +
    "           uib-datepicker-popup=\"{{vm.format}}\"\n" +
    "           is-open=\"vm.opened\"\n" +
    "           datepicker-options=\"vm.dateOptions\"\n" +
    "           show-button-bar=\"false\"\n" +
    "           ng-model=\"vm.value\"\n" +
    "           style=\"width:0px;height:0px;margin:0px;padding:0px;border-width:0px;\"\n" +
    "           ng-change=\"vm.pickDate()\"\n" +
    "           data-ng-disabled=\"vm.ngDisabled\"\n" +
    "           ng-required=\"vm.ngRequired\"\n" +
    "           ng-blur=\"vm.handleBlur()\"\n" +
    "           datepicker-append-to-body=\"vm.appendToBody\"\n" +
    "           tabindex=\"-1\"\n" +
    "           aria-hidden=\"true\"\n" +
    "           bento-flex-grid-control\n" +
    "           on-open-focus=\"{{vm.onOpenFocus !== false}}\"/>\n" +
    "    <span class=\"input-group-btn\" ng-if=\"vm.showDatepickerButton()\">\n" +
    "        <button type=\"button\"\n" +
    "            style=\"z-index: 4\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            data-qe-id=\"{{::vm.name+'-date-picker'}}\"\n" +
    "            aria-label=\"Open calendar to select {{vm.name == 'reportDateRange-startDate' ? 'From Date' : ' To Date'}}\"\n" +
    "            ng-disabled=\"vm.ngDisabled || vm.ngReadonly\"\n" +
    "            ng-click=\"vm.open($event)\"\n" +
    "            data-fef-tab-stop=\"vm.tabStop()\">\n" +
    "            <span class=\"sr-only\">\n" +
    "                {{ 'Bluemoon.Practice.Common.DateRangeSelector.OpenDatePickerLabel' | translate }}\n" +
    "            </span>\n" +
    "            <i class=\"bento-icon-calendar\" style=\"margin-right:0px;\"></i>\n" +
    "        </button>\n" +
    "    </span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-carousel/bmp-carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-carousel/bmp-carousel.html",
    "<div bento-carousel\n" +
    "    arrow-offset=\"30px\"\n" +
    "    fade-color=\"#FFFAFAFA\"\n" +
    "    gutter-size=\"20px\">\n" +
    "    <ul role=\"radiogroup\">\n" +
    "        <li class=\"bento-carousel-card bmp-carousel-animation\" ng-repeat=\"card in vm.bmpCarouselCards\" role=\"presentation\">\n" +
    "            <div ng-click=\"vm.onCardClick(card)\"\n" +
    "                    role=\"radio\"\n" +
    "                    aria-labelledby=\"{{card.dataQeId}}\"\n" +
    "                    aria-checked=\"{{card.id === vm.ngModel.$viewValue.id}}\"\n" +
    "                    tabindex=\"0\"\n" +
    "                    ng-keydown=\"vm.handleKeydown($event, card)\"\n" +
    "                    class=\"bmp-carousel-card\"\n" +
    "                    ng-class=\"{'bmp-carousel-card-selected': card.id === vm.ngModel.$viewValue.id}\">\n" +
    "                <ng-include src=vm.bmpCarouselCardTemplateUrl></ng-include>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-combobox/bmp-combobox.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-combobox/bmp-combobox.html",
    "<div bento-combobox\n" +
    "     data=\"bmpCombobox.data\"\n" +
    "     headers=\"bmpCombobox.boundHeaders\"\n" +
    "     label-name=\"label\"\n" +
    "     value-name=\"value\"\n" +
    "     searchable=\"true\"\n" +
    "     use-server=\"true\"\n" +
    "     on-page-request=\"bmpCombobox.getPage(page, searchString)\"\n" +
    "     reset-list-on-select=\"true\"\n" +
    "     ng-model=\"bmpCombobox.value\"\n" +
    "     selected-index=\"bmpCombobox.selectedIndex\"\n" +
    "     role=\"combobox\"\n" +
    "     aria-labelledby=\"{{name}}-label\"\n" +
    "     bento-append-to-parent=\"{{bmpCombobox.boundAppendToParent}}\"\n" +
    "     on-change=\"bmpCombobox.onChange(value, label, item, index)\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-confirmation-dialog/bmp-confirmation-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-confirmation-dialog/bmp-confirmation-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\" ng-if=\"bmpConfirmationDialog.showHeader()\">\n" +
    "        <h2 role=\"presentation\" tabindex=\"0\" id=\"modal-title\">{{bmpConfirmationDialog.titleText()}}</h2>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body modal-confirm-body\">\n" +
    "        <i class=\"glyphicons warning_sign modal-confirm-icon\"></i>\n" +
    "        <span ng-if=\"!bmpConfirmationDialog.bodyTextIsArray()\" class=\"modal-confirm-message display-inline-block\">\n" +
    "            <span ng-if=\"bmpConfirmationDialog.bodyText()\">{{bmpConfirmationDialog.bodyText()}}</span>\n" +
    "            <br ng-if=\"bmpConfirmationDialog.bodyText() && bmpConfirmationDialog.additionalBodyText()\" />\n" +
    "            <br ng-if=\"bmpConfirmationDialog.bodyText() && bmpConfirmationDialog.additionalBodyText()\" />\n" +
    "            <span ng-if=\"bmpConfirmationDialog.additionalBodyText()\">{{bmpConfirmationDialog.additionalBodyText()}}</span>\n" +
    "        </span>\n" +
    "        <span ng-if=\"bmpConfirmationDialog.bodyTextIsArray()\" class=\"modal-confirm-message display-inline-block\">\n" +
    "            <div ng-repeat=\"text in bmpConfirmationDialog.bodyTextArray() track by $index\">\n" +
    "                <span>{{text}}</span>\n" +
    "                <br ng-if=\"!$last\">\n" +
    "            </div>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button id=\"bmpConfirmationDialog.ok\"\n" +
    "        class=\"btn btn-primary\"\n" +
    "        data-ng-click=\"bmpConfirmationDialog.onOk()\"\n" +
    "        data-qe-id=\"bm-confirmationDialog-ok-button\"\n" +
    "        data-ng-disabled=\"bmpConfirmationDialog.okDisabled()\">\n" +
    "            {{bmpConfirmationDialog.confirmText()}}\n" +
    "        </button>\n" +
    "        <!-- The Discard button only appears if the confirmation dialog is provided with discard text when implemented -->\n" +
    "        <button ng-if=\"bmpConfirmationDialog.hasDiscardText()\"\n" +
    "        id=\"bmpConfirmationDialog.discard\"\n" +
    "        class=\"btn btn-default\"\n" +
    "        data-qe-id=\"bm-confirmationDialog-discard-button\"\n" +
    "        data-ng-click=\"bmpConfirmationDialog.onDiscard()\">\n" +
    "            {{bmpConfirmationDialog.discardText()}}\n" +
    "        </button>\n" +
    "        <button id=\"bmpConfirmationDialog.cancel\"\n" +
    "        class=\"btn btn-default\"\n" +
    "        data-ng-click=\"bmpConfirmationDialog.onCancel()\"\n" +
    "        data-qe-id=\"bm-confirmationDialog-cancel-button\"\n" +
    "        formnovalidate>\n" +
    "            {{bmpConfirmationDialog.cancelText()}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-control-group/bmp-control-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-control-group/bmp-control-group.html",
    "<div id=\"form-group-{{bmpControlGroupFieldId}}\" data-ng-hide=\"bmpControlGroupHide()\" class=\"form-group bmp-control-group\" data-ng-class=\"classObj()\">\n" +
    "    <label class=\"control-label inline\"\n" +
    "           for=\"{{bmpControlGroupFieldId}}\"\n" +
    "           data-qe-id=\"{{::bmpControlGroupFieldId+'-label'}}\"\n" +
    "           id=\"{{::bmpControlGroupFieldId+'-label'}}\"\n" +
    "           data-ng-show=\"showLabel()\">{{bmpControlGroupCustomLabel || bmpControlGroupLabel}} <i class=\"bento-icon-question\"\n" +
    "                                                                                                ng-if=\"bmpControlGroupLabelTooltip\"\n" +
    "                                                                                                uib-tooltip=\"{{ bmpControlGroupLabelTooltip | translate }}\"\n" +
    "                                                                                                tooltip-trigger=\"mouseenter\"\n" +
    "                                                                                                tooltip-placement=\"right\"\n" +
    "                                                                                                tooltip-append-to-body=\"true\"></i></label>\n" +
    "    <div data-ng-transclude=\"\"></div>\n" +
    "    <span class=\"msg\" tabindex=\"-1\" data-ng-bind-html=\"validationError()\" id=\"{{::bmpControlGroupFieldId+'-error'}}\" data-qe-id=\"{{::bmpControlGroupFieldId+'-error'}}\" role=\"alert\"></span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-custom-table/bmp-custom-table.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-custom-table/bmp-custom-table.html",
    "<table class=\"bento-flex-grid bmp-custom-table no-footer\" id=\"bmp-custom-table_table_1\">\n" +
    "    <thead>\n" +
    "        <tr role=\"row\">\n" +
    "            <th data-ng-if=\"vm.selectionEnabled\" class=\"wj-cell wj-header bmp-custom-table-rowheaders\">\n" +
    "                <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                       class=\"form-input\"\n" +
    "                       data-ng-model=\"vm.selectionHeaderChecked\"\n" +
    "                       data-ng-change=\"vm.selectionHeaderCheckChanged()\" />\n" +
    "            </th>\n" +
    "            <th data-ng-repeat=\"header in vm.headerFields\"\n" +
    "                class=\"bmp-clickable wj-cell wj-header\"\n" +
    "                data-ng-style=\"vm.styleForHeader(header, true)\"\n" +
    "                data-ng-class=\"{sorting_asc: header.asc(), sorting_desc: header.desc()}\"\n" +
    "                data-ng-click=\"header.click()\"\n" +
    "                tabindex=\"0\"\n" +
    "                aria-controls=\"bmp-custom-table_table_1\"\n" +
    "                aria-label=\"{{vm.ariaLabelForHeader(header)}}\"\n" +
    "                aria-sort=\"ascending\">\n" +
    "                {{header.label}}\n" +
    "            </th>\n" +
    "        </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "        <tr data-ng-repeat=\"row in bmpCustomTableData\">\n" +
    "            <td data-ng-if=\"vm.selectionEnabled\" class=\"wj-cell bmp-custom-table-rowheaders\">\n" +
    "                <input autocomplete=\"off\" type=\"checkbox\" class=\"form-input\" data-ng-model=\"row._selected\" data-ng-change=\"bmpCustomTableSelectionChanged()\" />\n" +
    "            </td>\n" +
    "            <td data-ng-repeat=\"header in vm.headerFields\"\n" +
    "                class=\"wj-cell\"\n" +
    "                data-ng-style=\"vm.styleForHeader(header, false)\">\n" +
    "                <div data-ng-switch=\"header.cellType\">\n" +
    "                    <!-- Standard textual content -->\n" +
    "                    <span data-ng-switch-when=\"text\">{{header.value(row)}}</span>\n" +
    "                    <!-- Standard textual link -->\n" +
    "                    <a data-ng-switch-when=\"link\" data-ng-href=\"{{header.href(row)}}\" data-ng-click=\"header.cellClick(row)\" class=\"link-alt\" style=\"cursor: pointer;\">{{header.value(row)}}</a>\n" +
    "                    <!-- Button link containing text and optional icon -->\n" +
    "                    <div data-ng-switch-when=\"button\">\n" +
    "                        <a data-ng-if=\"header.cellVisible(row)\" class=\"btn btn-default\" data-ng-href=\"{{header.href(row)}}\" data-ng-click=\"header.cellClick(row)\" title=\"{{header.value(row)}}\">\n" +
    "                            <span data-ng-if=\"header.icon(row)\" class=\"glyphicon glyphicon-{{header.icon(row)}}\" style=\"margin-right: 0px;\"></span>\n" +
    "                            <span data-ng-if=\"!header.icon(row)\">{{header.value(row)}}</span>\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                    <!-- icon with hover text -->\n" +
    "                    <span data-ng-switch-when=\"icon\" class=\"glyphicon glyphicon-{{header.icon(row)}}\" title=\"{{header.value(row)}}\"></span>\n" +
    "                </div>\n" +
    "            </td>\n" +
    "        </tr>\n" +
    "    </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("bmp/bmp-date-range-boxes/bmp-date-range-boxes.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-date-range-boxes/bmp-date-range-boxes.html",
    "<div ng-class=\"{'has-error': vm.error}\">\n" +
    "    <div class=\"bmp-date-range-boxes\">\n" +
    "        <bmp-bento-datepicker-wrapper name=\"{{::vm.name}}-startDate\"\n" +
    "                                    ng-model=\"vm.value.startDate\"\n" +
    "                                    data-ng-disabled=\"vm.disabled\"\n" +
    "                                    data-ng-change=\"vm.internalDateChanged()\"\n" +
    "                                    bmp-bento-datepicker-wrapper-append-to-body=\"true\"\n" +
    "                                    ng-required=\"true\">\n" +
    "        </bmp-bento-datepicker-wrapper>\n" +
    "        <div class=\"bmp-date-range-boxes-to-label\">\n" +
    "            {{'Bluemoon.Practice.Common.DateRangeSelector.ToLabel' | translate }}\n" +
    "        </div>\n" +
    "        <bmp-bento-datepicker-wrapper name=\"{{::vm.name}}-endDate\"\n" +
    "                                    ng-model=\"vm.value.endDate\"\n" +
    "                                    data-ng-disabled=\"vm.disabled\"\n" +
    "                                    data-ng-change=\"vm.internalDateChanged()\"\n" +
    "                                    bmp-bento-datepicker-wrapper-append-to-body=\"true\"\n" +
    "                                    ng-required=\"true\">\n" +
    "        </bmp-bento-datepicker-wrapper>\n" +
    "    </div>\n" +
    "    <span class=\"msg\" data-ng-bind=\"vm.error\" data-qe-id=\"{{::vm.name}}-error\"></span>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-date-range-selector/bmp-date-range-selector.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-date-range-selector/bmp-date-range-selector.html",
    "<div class=\"form-group\">\n" +
    "    <label ng-if=\"vm.bmpDateRangeSelectorLabel!=='false'\">{{vm.bmpDateRangeSelectorLabel}}</label>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-5 col-sm-5 col-xs-12\">\n" +
    "            <span data-bento-select>\n" +
    "                <select id=\"{{vm.name}}-dropdown\"\n" +
    "                        aria-label=\"{{'Bluemoon.Practice.Common.DateRangeSelector.HeaderLabel' | translate}}-{{vm.name}}\"\n" +
    "                        data-ng-model=\"vm.dateRange.value\"\n" +
    "                        data-ng-change=\"vm.updateFilter()\"\n" +
    "                        data-ng-options=\"option as option.name for option in vm.dateRange.options track by option.id\"\n" +
    "                        bmp-ignore-dirty></select>\n" +
    "\n" +
    "            </span>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-7 col-sm-7 col-xs-12\" data-ng-if=\"vm.showStartDateBox() && vm.showEndDateBox()\">\n" +
    "            <bmp-date-range-boxes\n" +
    "                                name=\"{{vm.name}}\"\n" +
    "                                ng-model=\"vm\"\n" +
    "                                disabled=\"vm.areDatesDisabled()\"\n" +
    "                                date-changed=\"vm.onDateChanged()\" />\n" +
    "        </div>\n" +
    "        <div class=\"col-md-7 col-sm-7 col-xs-12\" data-ng-if=\"vm.showStartDateBox() && !vm.showEndDateBox()\">\n" +
    "            <div class=\"bmp-date-range-boxes\">\n" +
    "                <bmp-bento-datepicker-wrapper name=\"{{::vm.name}}-startDate\"\n" +
    "                                              ng-model=\"vm.startDate\"\n" +
    "                                              data-ng-disabled=\"vm.areDatesDisabled()\"\n" +
    "                                              data-ng-change=\"vm.onDateChanged()\"\n" +
    "                                              bmp-bento-datepicker-wrapper-append-to-body=\"true\"\n" +
    "                                              bmp-ignore-dirty>\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-enum-control/bmp-enum-combo-multi-select.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-enum-control/bmp-enum-combo-multi-select.html",
    "<div class=\"bmp-multi-select-main\">\n" +
    "    <bmp-enum-combo\n" +
    "        name=\"{{::name + '-enum-combo'}}\"\n" +
    "        class=\"bmp-multi-select-combo\"\n" +
    "        enum=\"{{enumType}}\"\n" +
    "        ng-model=\"inputModel\"\n" +
    "        custom-items=\"customItems\"\n" +
    "        data-enum-combo>\n" +
    "    </bmp-enum-combo>\n" +
    "    <bmp-multi-select-tag-box\n" +
    "        name=\"{{::name + '-tag-box'}}\"\n" +
    "        model=\"model\"\n" +
    "        input-model=\"inputModel\">\n" +
    "    </bmp-multi-select-tag-box>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-enum-control/bmp-enum-combo.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-enum-control/bmp-enum-combo.html",
    "<div bento-combobox=\"\" name=\"{{::name}}\" id=\"{{::name}}\"\n" +
    "     ng-model=\"ngModel\"\n" +
    "     ng-disabled=\"ngDisabled\"\n" +
    "     ng-readonly=\"ngReadonly\"\n" +
    "     ng-required=\"ngRequired\"\n" +
    "     searchable=\"true\"\n" +
    "     use-server=\"false\"\n" +
    "     get-data=\"ctrl.getEnumValuesForCombo(enumType)\"\n" +
    "     on-change=\"_onChange(item)\"\n" +
    "     label-name=\"name\"\n" +
    "     data-qe-id=\"{{::name}}-combo\"\n" +
    "     controller=\"control\"\n" +
    "     defer-load=\"deferLoad\"\n" +
    "     placeholder=\"{{placeholder}}\"\n" +
    "     role=\"combobox\"\n" +
    "     aria-labelledby=\"{{name}}-label\"\n" +
    "     bento-flex-grid-control\n" +
    "     container-visibility-changed=\"ctrl.onContainerVisibilityChanged(visibility)\"\n" +
    "     bmp-combobox-scroll-into-view>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-enum-control/bmp-enum-dropdown.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-enum-control/bmp-enum-dropdown.html",
    "<div class='bento-select'>\n" +
    "    <select class=\"form-control\" name=\"{{name}}\" id=\"{{name}}\"\n" +
    "            data-ng-model=\"ngModel\"\n" +
    "            data-ng-disabled=\"ngDisabled\"\n" +
    "            data-ng-options=\"option as option.name for option in ctrl.getEnumValues(enumType) track by option.id\"></select>\n" +
    "     <div class=\"btn\">\n" +
    "        <span class=\"bento-icon-carat-down\"></span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-enum-control/bmp-enum-radio-button-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-enum-control/bmp-enum-radio-button-group.html",
    "<bmp-radio-button-group name=\"{{::name}}\"\n" +
    "                    id=\"{{::name}}\"\n" +
    "                    data-bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                    data-ng-model=\"ngModel\"\n" +
    "                    data-ng-disabled=\"ngDisabled\"\n" +
    "                    data-bmp-radio-button-group-options=\"ctrl.getEnumValues(enumType)\">\n" +
    "</bmp-radio-button-group>\n" +
    "");
}]);

angular.module("bmp/bmp-enum-control/bmp-enum-radio-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-enum-control/bmp-enum-radio-group.html",
    "<div ng-repeat=\"option in ctrl.getEnumValues(enumType)\">\n" +
    "    <input autocomplete=\"off\" type=\"radio\" name=\"{{::name+'_'+option.id}}\" id=\"{{::name+'_'+option.id}}\"\n" +
    "           ng-model=\"$parent.ngModelInternal\"\n" +
    "           data-qe-id=\"{{::name+'-'+option.id}}-radio\"\n" +
    "           ng-disabled=\"$parent.ngDisabled\"\n" +
    "           ng-value=\"option.id\" />\n" +
    "    <label for=\"{{::name+'_'+option.id}}\">{{option.name}}</label>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-enum-control/bmp-enum-radio.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-enum-control/bmp-enum-radio.html",
    "<span>\n" +
    "    <input autocomplete=\"off\" type=\"radio\"\n" +
    "           name=\"{{::name}}\"\n" +
    "           id=\"{{::name}}\"\n" +
    "           data-qe-id=\"{{::name}}\"\n" +
    "           data-ng-model=\"ngModel\"\n" +
    "           data-ng-change=\"ngChange\"\n" +
    "           data-ng-disabled=\"ngDisabled()\"\n" +
    "           role=\"radio\"\n" +
    "           aria-labelledby=\"{{::value}}-label\"\n" +
    "           data-ng-value=\"ctrl.getEnumValue2(enumType, value, ngModel)\"/>\n" +
    "    <label id=\"{{::value}}-label\" for=\"{{::name}}\" aria-label=\"{{ctrl.getEnumValue2(enumType, value).name}}\">{{ctrl.getEnumValue2(enumType, value).name}}</label>\n" +
    "</span>\n" +
    "");
}]);

angular.module("bmp/bmp-filter-tree-component/bmp-filter-tree-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-filter-tree-component/bmp-filter-tree-component.html",
    "<div data-qe-id=\"{{vm.name + '_bmp-filter-tree'}}\" class=\"bmp-filter-tree form-inline\">\n" +
    "    <dl class=\"rules-group-container\">\n" +
    "        <dt class=\"rules-group-header\">\n" +
    "            <div class=\"btn-group group-conditions\">\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{ 'active': vm.operatorIsAnd() }\" ng-click=\"vm.andOperatorClicked()\"\n" +
    "                        ng-disabled=\"vm.filter.conditions.length + vm.filter.nestedFilters.length < 2\" aria-pressed=\"{{ vm.operatorIsAnd() }}\" translate=\"Bluemoon.Practice.Common.QueryBuilder.And\">\n" +
    "                </button>\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{ 'active': vm.operatorIsOr() }\" ng-click=\"vm.orOperatorClicked()\"\n" +
    "                        ng-disabled=\"vm.filter.conditions.length + vm.filter.nestedFilters.length < 2\" aria-pressed=\"{{ vm.operatorIsOr() }}\" translate=\"Bluemoon.Practice.Common.QueryBuilder.Or\">\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"btn-group group-add\">\n" +
    "                <button type=\"button\" class=\"btn btn-sm btn-link add-group-button\" ng-click=\"vm.addFilterCondition()\" ng-disabled=\"vm.maxFilterConditions && vm.filter.conditions.length + vm.filter.nestedFilters.length >= vm.maxFilterConditions\">\n" +
    "                    <i class=\"bento-icon-add\"></i> {{ \"Bluemoon.Practice.Common.QueryBuilder.AddRule\" | translate }}\n" +
    "                </button>\n" +
    "                <button type=\"button\" class=\"btn btn-sm btn-link\" ng-click=\"vm.addFilterGroup()\" ng-if=\"vm.enableGroupFiltering && vm.maxFilterGroupDepth && vm.maxFilterGroupDepth > 0\" ng-disabled=\"vm.maxFilterGroupDepth && vm.filter.conditions.length + vm.filter.nestedFilters.length >= vm.maxFilterConditions\">\n" +
    "                    <i class=\"bento-icon-add\"></i> {{ \"Bluemoon.Practice.Common.QueryBuilder.AddGroup\" | translate }}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"btn-group group-delete\" ng-if=\"vm.maps\">\n" +
    "                <button type=\"button\" class=\"btn btn-sm btn-link\" ng-click=\"vm.removeFilterGroup()\" ng-if=\"vm.parentFilter && vm.enableGroupFiltering\">\n" +
    "                    <i class=\"bento-icon-remove\"></i> {{ \"Bluemoon.Practice.Common.QueryBuilder.RemoveGroup\" | translate }}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"error-container\" data-toggle=\"tooltip\" data-original-title=\"\" title=\"\"><i class=\"bento-icon-warning\"></i></div>\n" +
    "        </dt>\n" +
    "        <dd class=\"rules-group-body\">\n" +
    "            <ul class=\"rules-list\" ng-if=\"vm.maps\">\n" +
    "                <li data-qe-id=\"{{vm.name + '_bmp-filter-tree_rule_' + $index}}\"\n" +
    "                    aria-label=\"{{vm.name}}\"\n" +
    "                    id=\"{{vm.name + '_filter-tree_rule_' + $index + '_field-parent'}}\"\n" +
    "                    class=\"rule-container form-group\"\n" +
    "                    ng-repeat=\"$condition in vm.filter.conditions\"\n" +
    "                    ng-class=\"{'has-error': vm.validate && vm.error[$index]}\">\n" +
    "                    <div class=\"rule-filter-wrapper\">\n" +
    "                        <div class=\"rule-filter-container\">\n" +
    "                            <bmp-enum-combo\n" +
    "                                    enum=\"custom\"\n" +
    "                                    name=\"{{vm.name + '_filter-tree_rule_' + $index + '_field-parent'}}\"\n" +
    "                                    ng-model=\"$condition.$fieldParent\"\n" +
    "                                    custom-items=\"vm.fields\"\n" +
    "                                    value-property=\"id\"\n" +
    "                                    on-change=\"vm.fieldParentChanged($condition)\">\n" +
    "                            </bmp-enum-combo>\n" +
    "                            <span class=\"hidden\" id=\"{{vm.name + '_filter-tree_rule_' + $index + '_field-parent-label'}}\">{{ \"Bluemoon.Practice.Common.Filter.Tree.FilterBy\" | translate }}</span>\n" +
    "                        </div>\n" +
    "                        <div class=\"rule-filter-container\"\n" +
    "                            ng-if=\"$condition.$fieldParent\n" +
    "                                && vm.maps.fieldsByParentFieldId[$condition.$fieldParent].properties\n" +
    "                                && (vm.maps.fieldsByParentFieldId[$condition.$fieldParent].properties.length > 1\n" +
    "                                    && vm.maps.fieldsByParentFieldId[$condition.$fieldParent].properties[0].name !== '')\">\n" +
    "                            <bmp-enum-combo\n" +
    "                                    enum=\"custom\"\n" +
    "                                    name=\"{{vm.name + '_filter-tree_rule_' + $index + '_field'}}\"\n" +
    "                                    ng-model=\"$condition.field\"\n" +
    "                                    custom-items=\"vm.maps.fieldsByParentFieldId[$condition.$fieldParent].properties\"\n" +
    "                                    value-property=\"path\"\n" +
    "                                    on-change=\"vm.fieldChanged($condition)\"\n" +
    "                                    bm-focus-on-event=\"vm.name + '_filter-tree_rule_' + $index + '_field'\"\n" +
    "                                    bm-focus-on-event-element-selector=\"'input'\">\n" +
    "                            </bmp-enum-combo>\n" +
    "                            <span class=\"hidden\" id=\"{{vm.name + '_filter-tree_rule_' + $index + '_field-label'}}\">{{ \"Bluemoon.Practice.Common.Filter.Tree.Attribute\" | translate }}</span>\n" +
    "                        </div>\n" +
    "                        <div class=\"rule-operator-container\" ng-if=\"$condition.field\">\n" +
    "                            <bmp-enum-combo\n" +
    "                                    enum=\"custom\"\n" +
    "                                    name=\"{{vm.name + '_filter-tree_rule_' + $index + '_operator'}}\"\n" +
    "                                    ng-model=\"$condition.$operator\"\n" +
    "                                    custom-items=\"vm.maps.propertiesByFieldId[$condition.field].operators\"\n" +
    "                                    value-property=\"id\"\n" +
    "                                    on-change=\"vm.operatorChanged($condition)\"\n" +
    "                                    bm-focus-on-event=\"vm.name + '_filter-tree_rule_' + $index + '_operator'\"\n" +
    "                                    bm-focus-on-event-element-selector=\"'input'\">\n" +
    "                            </bmp-enum-combo>\n" +
    "                            <span class=\"hidden\" id=\"{{vm.name + '_filter-tree_rule_' + $index + '_operator-label'}}\">{{ \"Bluemoon.Practice.Common.Filter.Tree.Operator\" | translate }}</span>\n" +
    "                        </div>\n" +
    "                        <div class=\"rule-value-container\">\n" +
    "                            <bmp-filter-tree-value-box\n" +
    "                                filter-condition=\"$condition\"\n" +
    "                                operator=\"vm.maps.propertiesByFieldIdAndOperator[$condition.field][$condition.operator]\"\n" +
    "                                name=\"{{vm.name + '_bmp-filter-tree_rule_' + $index + '_value'}}\"\n" +
    "                                data-qe-id=\"{{vm.name + '_bmp-filter-tree_rule_' + $index + '_value'}}\"\n" +
    "                                bm-focus-on-event=\"vm.name + '_filter-tree_rule_' + $index + '_value'\"\n" +
    "                                bm-focus-on-event-element-selector=\"'input'\"/>\n" +
    "                        </div>\n" +
    "                        <span class=\"hidden\" id=\"{{vm.name + '_bmp-filter-tree_rule_' + $index + '_value-label'}}\">{{ \"Bluemoon.Practice.Common.Filter.Tree.Selection\" | translate }}</span>\n" +
    "                    </div>\n" +
    "                    <div class=\"btn-group rule-actions\">\n" +
    "                        <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.deleteFilterCondition($condition)\" aria-label=\"{{ ('Bluemoon.Practice.Common.QueryBuilder.DeleteRule' | translate) + ' ' + ($index + 1) }}\">\n" +
    "                        <i class=\"bento-icon-remove\"></i>{{ \"Bluemoon.Practice.Common.QueryBuilder.DeleteRule\" | translate }}\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <span class=\"msg\" data-ng-bind=\"vm.error[$index]\" data-qe-id=\"{{::vm.name + '_bmp-filter-tree_rule_' + $index + '_error'}}\"></span>\n" +
    "                </li>\n" +
    "                <li ng-repeat=\"$group in vm.filter.nestedFilters\" class=\"nested-rules-group\">\n" +
    "                    <bmp-filter-tree-directive\n" +
    "                        ng-model=\"$group\"\n" +
    "                        fields=\"vm.fields\"\n" +
    "                        name=\"{{$index + 'nested'}}\"\n" +
    "                        max-filter-conditions=\"vm.maxFilterConditions\"\n" +
    "                        max-filter-group-depth=\"vm.maxFilterGroupDepth - 1\"\n" +
    "                        parent-filter=\"vm.filter\"\n" +
    "                        enable-group-filtering=\"true\">\n" +
    "                    </bmp-filter-tree-directive>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </dd>\n" +
    "    </dl>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-filter-tree-component/bmp-filter-tree-value-box.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-filter-tree-component/bmp-filter-tree-value-box.html",
    "<div ng-if=\"vm.operator\">\n" +
    "    <input ng-if=\"vm.operator.dataType === 'NUMBER' || vm.operator.dataType === 'NEGATIVENUMBER'\"\n" +
    "            class=\"form-control\"\n" +
    "            type=\"number\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            step=\"0.01\"\n" +
    "            ng-model=\"vm.filterCondition.value\">\n" +
    "    <input ng-if=\"vm.operator.dataType === 'TEXT'\"\n" +
    "            class=\"form-control\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            ng-model=\"vm.filterCondition.value\">\n" +
    "    <div class=\"bmp-date-range-boxes\" ng-if=\"vm.operator.dataType === 'DATE'\">\n" +
    "        <bmp-bento-datepicker-wrapper\n" +
    "                name=\"{{::vm.name}}\"\n" +
    "                ng-required=\"true\"\n" +
    "                bmp-bento-datepicker-wrapper-append-to-body=\"true\"\n" +
    "                ng-model=\"vm.filterCondition.value\">\n" +
    "        </bmp-bento-datepicker-wrapper>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.operator.dataType === 'DATERANGE'\">\n" +
    "        <bmp-date-range-boxes\n" +
    "                name={{::vm.name}}\n" +
    "                ng-model=\"vm.dateRangeBoundData\">\n" +
    "        </bmp-date-range-boxes>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.operator.dataType === 'NUMBERRANGE' || vm.operator.dataType === 'NEGATIVENUMBERRANGE'\">\n" +
    "        <input class=\"form-control\"\n" +
    "            type=\"number\"\n" +
    "            name=\"{{::vm.name + 'start'}}\"\n" +
    "            step=\"0.01\"\n" +
    "            ng-model=\"vm.numberRangeBoundData.start\"\n" +
    "            required>\n" +
    "        <input class=\"form-control\"\n" +
    "            type=\"number\"\n" +
    "            name=\"{{::vm.name + 'end'}}\"\n" +
    "            step=\"0.01\"\n" +
    "            ng-model=\"vm.numberRangeBoundData.end\"\n" +
    "            required>\n" +
    "    </div>\n" +
    "    <bmp-select-combo ng-if=\"vm.operator.dataType === 'SINGLESELECTLIST_CUSTOM' || vm.operator.dataType === 'SINGLESELECTLIST_CODE'\"\n" +
    "            list=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            ng-model=\"vm.filterCondition.value\"\n" +
    "            required=\"true\"\n" +
    "            custom-template=\"true\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-select-combo>\n" +
    "    <bmp-select-combo ng-if=\"vm.operator.dataType === 'SINGLESELECTLIST'\"\n" +
    "            list=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            ng-model=\"vm.filterCondition.value\"\n" +
    "            required=\"true\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-select-combo>\n" +
    "    <bmp-select-combo ng-if=\"vm.operator.dataType === 'SINGLESELECTLIST_NAMEONLY' ||vm.operator.dataType === 'SINGLESELECTLIST_ONECOLUMN'\"\n" +
    "            list=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            ng-model=\"vm.filterCondition.value\"\n" +
    "            required=\"true\"\n" +
    "            only-one-column=\"true\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-select-combo>\n" +
    "    <bmp-enum-combo ng-if=\"vm.operator.dataType === 'SINGLESELECTENUM'\"\n" +
    "            enum=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            ng-model=\"vm.filterCondition.value\"\n" +
    "            required=\"true\"\n" +
    "            custom-items=\"vm.operator.enumOptions\"\n" +
    "            custom-url=\"vm.operator.customUrl\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-enum-combo>\n" +
    "    <bmp-select-combo-multi-select ng-if=\"vm.operator.dataType === 'MULTISELECTLIST'\"\n" +
    "            list=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            model=\"vm.filterCondition.values\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-select-combo-multi-select>\n" +
    "    <bmp-filtered-select-combo ng-if=\"vm.operator.dataType === 'FILTEREDSINGLESELECTLIST_NAMEONLY'\"\n" +
    "            list-info=\"vm.operator.listType\"\n" +
    "            selection-data-type=\"vm.operator.dataType\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            model=\"vm.filterCondition.value\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-filtered-select-combo>\n" +
    "    <bmp-filtered-select-combo ng-if=\"vm.operator.dataType === 'FILTEREDMULTISELECTLIST_NAMEONLY'\"\n" +
    "            list-info=\"vm.operator.listType\"\n" +
    "            selection-data-type=\"vm.operator.dataType\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            model=\"vm.filterCondition.values\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-filtered-select-combo>\n" +
    "    <bmp-select-combo-multi-select ng-if=\"vm.operator.dataType === 'MULTISELECTLIST_CUSTOM' || vm.operator.dataType === 'MULTISELECTLIST_CODE'\"\n" +
    "            list=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            model=\"vm.filterCondition.values\"\n" +
    "            append-to-parent=\".modal-content\"\n" +
    "            tag-property-name=\"code\">\n" +
    "    </bmp-select-combo-multi-select>\n" +
    "    <bmp-select-combo-multi-select ng-if=\"vm.operator.dataType === 'MULTISELECTLIST_NAMEONLY' || vm.operator.dataType === 'MULTISELECTLIST_ONECOLUMN'\"\n" +
    "            list=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            model=\"vm.filterCondition.values\"\n" +
    "            append-to-parent=\".modal-content\"\n" +
    "            use-one-column=\"true\">\n" +
    "    </bmp-select-combo-multi-select>\n" +
    "    <bmp-enum-combo-multi-select ng-if=\"vm.operator.dataType === 'MULTISELECTENUM'\"\n" +
    "            enum=\"{{vm.operator.listType}}\"\n" +
    "            name=\"{{::vm.name}}\"\n" +
    "            model=\"vm.filterCondition.values\"\n" +
    "            custom-items=\"vm.operator.enumOptions\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-enum-combo-multi-select>\n" +
    "    <bmp-filter-tree-value-box-boolean-number ng-if=\"vm.operator.dataType === 'BOOLEANNUMBER'\"\n" +
    "           model=\"vm.filterCondition.value\" >\n" +
    "    </bmp-filter-tree-value-box-boolean-number>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-grid-filter-panel/bmp-grid-filter-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-grid-filter-panel/bmp-grid-filter-modal.html",
    "<div class=\"modal-container\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"bmp-modal-header\">\n" +
    "<button type=\"button\" class=\"close\" aria-label=\"Close dialog\" ng-click=\"gridFilterDialog.close()\">\n" +
    "    <i aria-hidden=\"true\" class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\" id=\"bmp-modal-header\">\n" +
    "    <span translate=\"Bluemoon.Practice.Common.GridFilterPanel.Filter\"></span>\n" +
    "    <span>{{gridFilterDialog.getHeaderText()}}</span>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <bmp-filter-tree-directive\n" +
    "        ng-model=\"gridFilterDialog.filter\"\n" +
    "        fields=\"gridFilterDialog.fields\"\n" +
    "        name=\"gridFilter\"\n" +
    "        max-filter-conditions=\"3\"\n" +
    "        max-filter-group-depth=\"2\"\n" +
    "        enable-group-filtering=\"true\"\n" +
    "        append-to-parent=\".modal-content\">\n" +
    "    </bmp-filter-tree-directive>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"gridFilterDialog.applyFilter()\" data-qe-id=\"bmp-gridFilterModal-apply-button\">\n" +
    "        <span translate=\"Bluemoon.Practice.Common.GridFilterModal.Apply\"></span>\n" +
    "    </button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"gridFilterDialog.clearFilter()\" data-qe-id=\"bmp-gridFilterModal-clear-button\">\n" +
    "        <span translate=\"Bluemoon.Practice.Common.GridFilterModal.Clear\"></span>\n" +
    "    </button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"gridFilterDialog.close()\" data-qe-id=\"bmp-gridFilterModal-cancel-button\">\n" +
    "        <span translate=\"Bluemoon.Practice.Common.Buttons.Cancel\"></span>\n" +
    "    </button>\n" +
    "</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-grid-filter-panel/bmp-grid-filter-panel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-grid-filter-panel/bmp-grid-filter-panel.html",
    "<div class=\"grid-filter-panel\">\n" +
    "    <div class=\"filter-list\">\n" +
    "        <div class=\"filter-label-container\">\n" +
    "            <span class=\"filter-label\" translate=\"Bluemoon.Practice.Common.GridFilterPanel.Filter\">Filter:</span>\n" +
    "            <span ng-if=\"!(filter.conditions.length > 0 || filter.nestedFilters.length > 0)\" translate=\"Bluemoon.Practice.Common.GridFilterPanel.NoFilter\" class=\"filter-none\">None</span>\n" +
    "        </div>\n" +
    "        <div class=\"filter-list-container\">\n" +
    "            <div ng-if=\"filter.conditions.length > 0 || filter.nestedFilters.length > 0\" ng-repeat=\"row in filterController.getFilterReadableRows() track by $index\" style=\"overflow: hidden;\">\n" +
    "                 <div class=\"filter-tag-container\" ng-repeat=\"item in row.items track by $index\">\n" +
    "                    <div class=\"filter-groupmarker\" ng-if=\"item.item.charAt(0) !== '%'\">\n" +
    "                        <span>{{item.item}}</span>\n" +
    "                        <a class=\"filter-remove\" ng-click=\"filterController.removeFilterCondition(item.condition)\">\n" +
    "                             <span class=\"bento-icon-close-circle\"></span>\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                    <span ng-if=\"item.item.charAt(0) === '%'\">{{item.item.replace('%','')}}</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <a class=\"open-filter-modal\" href=\"\" tabindex=\"0\" ng-click=\"filterController.openModal()\" role=\"button\"\n" +
    "        aria-label=\"{{'Bluemoon.Practice.Common.GridFilterPanel.OpenModal' | translate}}\" ng-keydown=\"filterController.focusWijmoGridWithTab($event)\" bm-focus-on-event=\"filterFocusEvent\">\n" +
    "        <span translate=\"Bluemoon.Practice.Common.GridFilterPanel.OpenModal\"></span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-grid/bmp-grid-import-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-grid/bmp-grid-import-modal.html",
    "<bmp-page-header\n" +
    "  is-ixed=\"true\"\n" +
    "  is-in-modal=\"true\"\n" +
    "  location=\"/setup/clients\"\n" +
    "  class=\"bmp-grid-import-modal-header\">\n" +
    "\n" +
    "  <bmp-page-header-left-content>\n" +
    "\n" +
    "    <bmp-page-header-left-content>\n" +
    "      <h1\n" +
    "        uib-tooltip=\"{{'Client Import'}}\"\n" +
    "        tooltip-trigger=\"mouseenter\"\n" +
    "        tooltip-placement=\"bottom\">\n" +
    "        {{'Client Import'}}\n" +
    "      </h1>\n" +
    "    </bmp-page-header-left-content>\n" +
    "\n" +
    "  </bmp-page-header-left-content>\n" +
    "\n" +
    "  <bmp-page-header-right-content>\n" +
    "\n" +
    "    <button\n" +
    "      id=\"cancel-client-import\"\n" +
    "      data-qe-id=\"cancel-client-import\"\n" +
    "      class=\"btn btn-default\"\n" +
    "      ng-click=\"vm.cancel()\"\n" +
    "      translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "  </bmp-page-header-right-content>\n" +
    "\n" +
    "</bmp-page-header>\n" +
    "\n" +
    "<div ng-if=\"!!vm.$scope.$parent.vm.definition.importDefinition.type\" class=\"ng-bento bmp-grid-import-wizard-container\">\n" +
    "  <import-wizard\n" +
    "    hide-title=\"true\"\n" +
    "    type=\"{{vm.$scope.$parent.vm.definition.importDefinition.type}}\"\n" +
    "    (finish-import)=\"vm.redirectToProgressPage()\"\n" +
    "  ></import-wizard>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("bmp/bmp-grid/bmp-grid-with-optional-panel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-grid/bmp-grid-with-optional-panel.html",
    "<div ng-if=\"vm.gridData.definition.slideoutFilterItemDefinitions\" id=\"bmp-grid-with-optional-filter-container\">\n" +
    "    <div bento-splitter-group\n" +
    "        left-width=\"300px\"\n" +
    "        left-max-width=\"300px\"\n" +
    "        resizable=\"false\"\n" +
    "        is-left-collapsed=\"true\"\n" +
    "        style=\"height: calc(100vh - 151px)\">\n" +
    "        <aside bento-splitter-group-left>\n" +
    "            <div>\n" +
    "                <h4 style=\"margin-left:17px; display: inline-block\">{{ 'Bluemoon.Practice.Common.Grid.Filters' | translate }}</h4>\n" +
    "                <div class=\"bento-expand-collapse-button-group\" style=\"float: right; margin-top:5px; margin-right: 5px\">\n" +
    "                    <button class=\"btn btn-default btn-xs btn-icon\"\n" +
    "                            ng-click=\"vm.expandAllFilters()\">\n" +
    "                    <i class=\"bento-expand-icon bento-icon-plus-plain\"></i>\n" +
    "                    </button>\n" +
    "                    <div class=\"bento-expand-divider\"></div>\n" +
    "                    <button class=\"btn btn-default btn-xs btn-icon\"\n" +
    "                            ng-click=\"vm.collapseAllFilters()\">\n" +
    "                    <i class=\"bento-collapse-icon bento-icon-minus-plain\"></i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <uib-accordion\n" +
    "                close-others=\"false\"\n" +
    "                class=\"bento-accordion bento-accordion-alternate\">\n" +
    "                <div ng-repeat=\"ctrl in vm.slideoutFilterControls\">\n" +
    "                    <bmp-grid-slideout-enum-filter ng-if=\"ctrl.dataType === 'SINGLESELECTENUM'\" definition=\"ctrl.definition\" option=\"ctrl.option\" filter=\"ctrl.filter\" is-open=\"ctrl.isOpen\"></bmp-grid-slideout-enum-filter>\n" +
    "                    <bmp-grid-slideout-select-filter ng-if=\"ctrl.dataType === 'SINGLESELECTLIST' || ctrl.dataType === 'SINGLESELECTLIST_NAMEONLY'\" definition=\"ctrl.definition\" option=\"ctrl.option\" filter=\"ctrl.filter\" is-open=\"ctrl.isOpen\"></bmp-grid-slideout-select-filter>\n" +
    "                    <bmp-grid-slideout-date-filter ng-if=\"ctrl.dataType === 'DATE'\" definition=\"ctrl.definition\" option=\"ctrl.option\" filter=\"ctrl.filter\" is-open=\"ctrl.isOpen\"></bmp-grid-slideout-date-filter>\n" +
    "                </div>\n" +
    "                <!-- TODO: !!!!!!TRANSLATE!!!!! -->\n" +
    "                <div uib-accordion-group\n" +
    "                    class=\"panel-default\"\n" +
    "                    heading=\"{{ 'Bluemoon.Practice.Common.Grid.Filters.AdvancedFilters' | translate }}\">\n" +
    "                    <div bento-busy-loader=\"vm.loading\">\n" +
    "                        <input type=\"checkbox\"\n" +
    "                                class=\"bento-checkbox\"\n" +
    "                                id=\"{{ vm.title + 'advanced-filter' }}\"\n" +
    "                                ng-model=\"vm.useAdvancedSlideoutFilter\">\n" +
    "                        <label for=\"{{ vm.title + 'advanced-filter' }}\">{{ 'Bluemoon.Practice.Common.Grid.Filters.CustomFilter' | translate }}<a style=\"margin-left: 5px\" ng-click=\"vm.openFilterDialog()\"><span class=\"bento-icon-edit\"></span></a></label>\n" +
    "                    </div>\n" +
    "                    <span ng-if=\"!(filter.conditions.length > 0 || filter.nestedFilters.length > 0)\" translate=\"Bluemoon.Practice.Common.GridFilterPanel.NoFilter\"></span>\n" +
    "                    <div ng-if=\"filter.conditions.length > 0 || filter.nestedFilters.length > 0\" ng-repeat=\"row in filterController.getFilterReadableRows() track by $index\" style=\"overflow: hidden;\">\n" +
    "                        <div class=\"filter-tag-container\" ng-repeat=\"item in row.items track by $index\">\n" +
    "                            <div class=\"filter-groupmarker\" ng-if=\"item.item.charAt(0) !== '%'\">\n" +
    "                                <span>{{item.item}}</span>\n" +
    "                                <a class=\"filter-remove\" ng-click=\"filterController.removeFilterCondition(item.condition)\">\n" +
    "                                    <span class=\"bento-icon-close-circle\"></span>\n" +
    "                                </a>\n" +
    "                            </div>\n" +
    "                            <span ng-if=\"item.item.charAt(0) === '%'\">{{item.item.replace('%','')}}</span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </uib-accordion>\n" +
    "        </aside>\n" +
    "        <section bento-splitter-group-main>\n" +
    "            <ng-include src=\"'bmp/bmp-grid/bmp-grid.html'\"></ng-include>\n" +
    "        </section>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-if=\"!vm.gridData.definition.slideoutFilterItemDefinitions\">\n" +
    "    <ng-include src=\"'bmp/bmp-grid/bmp-grid.html'\"></ng-include>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-grid/bmp-grid.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-grid/bmp-grid.html",
    "<div class=\"bmp-list\" data-qe-id=\"{{::vm.gridData.definition.gridName}}-grid\" ng-if=\"vm.definition\">\n" +
    "    <div class=\"bmp-list_wrapper\">\n" +
    "\n" +
    "        <!-- TOOLBAR -->\n" +
    "        <bmp-toolbar on-search=\"vm.gridData.changeSearch($searchTerm)\"\n" +
    "                    has-search=\"vm.gridData.definition.hasSearch\"\n" +
    "                    has-column-picker=\"vm.gridData.definition.hasColumnPicker\"\n" +
    "                    context-items=\"vm.gridData.selectedItems\"\n" +
    "                    bmp-toolbar-set-focus=\"!vm.gridData.definition.isEditable\"\n" +
    "                    search-focus-event-name=\"vm.toolbarSearchFocusEventName\"\n" +
    "                    search-tab-forward=\"vm.onSearchTabForward()\"\n" +
    "                    toolbar-buttons=\"vm.toolbarButtons\"\n" +
    "                    grid-data=\"vm.gridData\"\n" +
    "                    qe-id=\"{{::vm.gridData.definition.gridName}}\"\n" +
    "                    bmp-toolbar-filter-control=\"vm.gridData.definition.toolbarFilterControl\"\n" +
    "                    bmp-toolbar-grid-definition=\"vm.gridData.definition\"\n" +
    "                    bmp-toolbar-group-panel=\"vm.gridData.groupPanel\"\n" +
    "                    bmp-toolbar-group-panel-changed=\"vm.gridData.changeGroupPanel($groupPanel)\"\n" +
    "                    bmp-toolbar-group-panel-has-content=\"vm.gridData.grouping.length > 0\"\n" +
    "                    bmp-toolbar-filter-panel=\"vm.gridData.filterPanel\"\n" +
    "                    bmp-toolbar-filter-panel-changed=\"vm.gridData.changeFilterPanel($filterPanel)\"\n" +
    "                    bmp-toolbar-filter-panel-has-content=\"vm.gridData.filter.conditions.length > 0 || vm.gridData.filter.nestedFilters.length > 0\"\n" +
    "                    aria-controls=\"table1\">\n" +
    "        </bmp-toolbar>\n" +
    "\n" +
    "        <!-- LIST -->\n" +
    "        <bmp-wijmo-table\n" +
    "            data-bmp-wijmo-table-name=\"vm.gridData.definition.gridName\"\n" +
    "            data-bmp-wijmo-table-data=\"vm.gridData.data\"\n" +
    "            data-bmp-wijmo-table-list-mode=\"vm.gridData.definition.listMode\"\n" +
    "            data-bmp-wijmo-table-columns=\"vm.gridData.columns\"\n" +
    "            data-bmp-wijmo-table-sort=\"vm.gridData.sorting\"\n" +
    "            data-bmp-wijmo-table-sort-changed=\"vm.gridData.changeSortOnColumn($column)\"\n" +
    "            data-bmp-wijmo-table-search-string=\"vm.gridData.search.text\"\n" +
    "            data-bmp-wijmo-table-analytics-context=\"vm.gridData.definition.analyticsContext\"\n" +
    "            data-bmp-wijmo-table-group-panel-visible=\"vm.gridData.groupPanel\"\n" +
    "            data-bmp-wijmo-table-filter=\"vm.gridData.filter\"\n" +
    "            data-bmp-wijmo-table-filter-panel-visible=\"vm.gridData.filterPanel\"\n" +
    "            data-bmp-wijmo-table-filter-panel-options=\"vm.gridData.filterOptions\"\n" +
    "            data-bmp-wijmo-table-filter-modal-header-text=\"vm.gridData.definition.title\"\n" +
    "            data-bmp-wijmo-table-change-filter=\"vm.gridData.changeFilter($filter)\"\n" +
    "            data-bmp-wijmo-table-hierarchy=\"vm.gridData.definition.hierarchy\"\n" +
    "            data-bmp-wijmo-table-grouping=\"vm.gridData.grouping\"\n" +
    "            data-bmp-wijmo-table-grouping-changed=\"vm.gridData.changeGrouping($grouping)\"\n" +
    "            data-bmp-wijmo-table-column-layout-changed=\"vm.gridData.changeColumnLayout($layout)\"\n" +
    "            data-bmp-wijmo-table-display-hash-totals=\"vm.gridData.definition.displayHashTotals\"\n" +
    "            data-bmp-wijmo-table-load-more-data=\"vm.gridData.loadMoreData()\"\n" +
    "            data-bmp-wijmo-table-fill-vertical-height=\"vm.gridData.definition.fillVerticalHeight\"\n" +
    "            data-bmp-wijmo-table-fill-vertical-height-other-height=\"vm.gridData.fillVerticalHeightOtherHeight\"\n" +
    "            data-bmp-wijmo-table-set-height-max-height=\"vm.gridData.definition.maxHeight\"\n" +
    "            data-bmp-wijmo-table-editable=\"vm.gridData.definition.isEditable\"\n" +
    "            data-bmp-wijmo-table-editing-disabled=\"vm.gridData.definition.editingDisabled\"\n" +
    "            data-bmp-wijmo-table-save-edits=\"vm.gridData.definition.saveEdits\"\n" +
    "            data-bmp-wijmo-table-after-revert=\"vm.gridData.definition.afterRevert($item)\"\n" +
    "            data-bmp-wijmo-table-rendering=\"vm.isRendering\"\n" +
    "            data-bmp-wijmo-table-editable-freeze=\"vm.gridData.definition.freezeEditing\"\n" +
    "            data-bmp-wijmo-table-selectable=\"vm.gridData.definition.isSelectable\"\n" +
    "            data-bmp-wijmo-table-item-edit-beginning=\"vm.gridData.definition.itemEditBeginning($item)\"\n" +
    "            data-bmp-wijmo-table-item-edit-ending=\"vm.itemEditEnding($item)\"\n" +
    "            data-bmp-wijmo-table-new-item=\"vm.gridData.definition.newItem ? vm.gridData.definition.newItem() : undefined\"\n" +
    "            data-bmp-wijmo-table-refresh=\"vm.gridData.refresh()\"\n" +
    "            data-bmp-wijmo-table-row-deleted=\"vm.gridData.updatePagingTotalItemCount(-1)\"\n" +
    "            data-bmp-wijmo-table-actions-column-visible=\"vm.actionsColumnVisible\"\n" +
    "            data-bmp-wijmo-table-actions-column-icons=\"vm.actionsColumnIcons\"\n" +
    "            data-bmp-wijmo-table-actions-column-more-actions=\"vm.actionsColumnMoreActions\"\n" +
    "            data-bmp-wijmo-table-actions-column-icons-visible=\"vm.gridData.definition.actionsColumnIconsVisible\"\n" +
    "            data-bmp-wijmo-table-actions-column-more-actions-visible=\"vm.gridData.definition.actionsColumnMoreActionsVisible\"\n" +
    "            data-bmp-wijmo-table-row-detail-template-src=\"vm.gridData.definition.rowDetailTemplateSrc\"\n" +
    "            data-bmp-wijmo-table-selection-changed=\"vm.gridData.definition.selectionChanged(grid)\"\n" +
    "            data-bmp-wijmo-table-virtualization-threshold=\"vm.virtualizationThreshold\"\n" +
    "            data-bmp-wijmo-table-default-row-height=\"vm.gridData.definition.defaultRowHeight\"\n" +
    "            data-bmp-wijmo-table-append-to-parent=\"vm.gridData.definition.appendToParent\"\n" +
    "            data-bmp-wijmo-table-tab-out=\"vm.onGridTabOut(forward)\"\n" +
    "            data-bmp-wijmo-table-row-detail-formatter=\"vm.gridData.definition.rowDetailFormatter($row, $cell)\"\n" +
    "            data-bmp-wijmo-table-display-hierarchy-header-buttons=\"vm.gridData.definition.displayHierarchyHeaderIcons\"\n" +
    "            data-bmp-wijmo-table-hierarchy-default-level=\"vm.gridData.definition.hierarchyDefaultLevel\"\n" +
    "            data-bmp-wijmo-table-custom-detail-icon=\"vm.gridData.definition.customDetailIcon\"\n" +
    "            data-bmp-wijmo-table-caption=\"vm.gridData.definition.ariaLabel === undefined ? 'Bluemoon.Froala.Table' : vm.gridData.definition.ariaLabel\">\n" +
    "        </bmp-wijmo-table>\n" +
    "        <!--NO DATA IN TABLE-->\n" +
    "        <div data-ng-show=\"vm.gridData.definition.showNoItems && !vm.gridData.loading && vm.gridData.data && vm.gridData.data.length === 0\">\n" +
    "        <!-- NO-RESULTS WITHOUT SEARCH OR FILTER -->\n" +
    "            <div ng-if=\"!vm.gridData.searched && !vm.userFilterWithDataIsSet()\">\n" +
    "                <p ng-if=\"vm.gridData.errorMessage\" class=\"bmp-grid-view-centered-span no-entries\" tabindex=\"0\"\n" +
    "                    data-qe-id=\"{{vm.definition.gridName}}-none-message\">\n" +
    "                    {{vm.gridData.errorMessage}}\n" +
    "                </p>\n" +
    "				<p ng-if=\"!vm.gridData.errorMessage\" class=\"bmp-grid-view-centered-span no-entries\" tabindex=\"0\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.List.NoGridEntries\"\n" +
    "                    data-qe-id=\"{{vm.definition.gridName}}-none-message\">\n" +
    "                </p>\n" +
    "                <br>\n" +
    "                <p ng-if=\"vm.addButtonVisible()\" class=\"bmp-grid-blank-state-add\" role=\"button\" ng-click=\"vm.add($items)\">\n" +
    "                    <i class=\"bento-icon-add\" style=\"margin: 5px\"></i>\n" +
    "                    <span data-translate=\"Bluemoon.Practice.Common.Actions.Add\"></span>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "\n" +
    "        <!-- NO-RESULTS FOR SEARCH OR FILTER -->\n" +
    "            <div ng-if=\"vm.gridData.searched || vm.userFilterWithDataIsSet()\">\n" +
    "				<p ng-if=\"vm.gridData.errorMessage\" class=\"bmp-grid-view-centered-span no-entries\" tabindex=\"0\"\n" +
    "                    data-qe-id=\"{{vm.definition.gridName}}-none-message\">\n" +
    "                    {{vm.gridData.errorMessage}}\n" +
    "                </p>\n" +
    "				<p ng-if=\"!vm.gridData.errorMessage\" class=\"bmp-grid-view-centered-span no-entries\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.List.NoResults\"\n" +
    "                    data-qe-id=\"{{vm.definition.gridName}}-none-message\" role=\"alert\" aria-live=\"assertive\">\n" +
    "                </p>\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"bmp-grid-selected-count-label\">\n" +
    "            <span ng-if=\"vm.definition.showSelectedCount\">{{vm.gridData.definition.selectedLabel}}: {{vm.gridData.selectedItems.length}}</span>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"!vm.gridData.definition.hideFooter\" bento-busy-loader=\"vm.gridData.loading\" bento-busy-loader-size=\"small\">\n" +
    "            <!-- FOOTER -->\n" +
    "            <div class=\"bmp-grid-legend-container\" ng-if=\"vm.gridData.hasRequiredColumns\">\n" +
    "                <span data-qe-id=\"{{vm.definition.gridName}}-legend\">{{'Bluemoon.Practice.Common.Grid.RequiredItems' | translate}}</span>\n" +
    "            </div>\n" +
    "            <div class=\"bmp-grid-load-button-container\">\n" +
    "                <button class=\"btn btn-default\"\n" +
    "                        ng-if=\"!vm.gridData.allDataLoaded()\"\n" +
    "                        ng-disabled=\"!vm.gridData.canLoadMoreData()\"\n" +
    "                        ng-click=\"vm.loadMoreData()\"\n" +
    "                        data-qe-id=\"{{vm.definition.gridName}}-load-more-button\"\n" +
    "                        translate=\"Bluemoon.Practice.Common.Grid.LoadMoreData\"></button>\n" +
    "                <span bento-busy-loader=\"vm.gridData.countsLoading()\" bento-busy-loader-size=\"small\" data-qe-id=\"{{vm.definition.gridName}}-item-counter\" ng-if=\"vm.definition.showCount\">{{'Bluemoon.Practice.Common.Grid.ItemCounts' | translate:vm.getDataForItemCounts()}}</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-group-sort/bmp-group-sort-item.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-group-sort/bmp-group-sort-item.html",
    "<!-- Path -->\n" +
    "<div bmp-control-group=\"\" class=\"col-md-5 col-sm-5 col-xs-12\"\n" +
    "     bmp-control-group-field-id=\"{{::ctrl.name}}.path\"\n" +
    "     bmp-control-group-label=\"{{'Bluemoon.Practice.Common.GroupSort.Property' | translate}}\"\n" +
    "     bmp-control-group-label-hide=\"false\">\n" +
    "        <bmp-enum-combo enum=\"custom\" name=\"{{::ctrl.name}}.path\" id=\"{{::ctrl.name}}-path\"\n" +
    "                ng-model=\"ctrl.item[ctrl.bindings.path]\"\n" +
    "                ng-disabled=\"ctrl.options.length <= 1\"\n" +
    "                required=\"true\"\n" +
    "                custom-items=\"ctrl.options\"\n" +
    "                value-property=\"path\"\n" +
    "                placeholder=\"{{'Bluemoon.Practice.Common.GroupSort.Property' | translate}}\"\n" +
    "                on-change=\"ctrl.pathChanged()\">\n" +
    "        </bmp-enum-combo>\n" +
    "</div>\n" +
    "<!-- Property -->\n" +
    "<div bmp-control-group=\"\" class=\"col-md-4 col-sm-4 col-xs-12\"\n" +
    "     bmp-control-group-field-id=\"{{::ctrl.name}}.property\"\n" +
    "     bmp-control-group-label=\"{{'Bluemoon.Practice.Common.GroupSort.SortBy' | translate}}\"\n" +
    "     bmp-control-group-label-hide=\"false\">\n" +
    "        <bmp-enum-combo enum=\"custom\" name=\"{{::ctrl.name}}.property\" id=\"{{::ctrl.name}}-property\"\n" +
    "                ng-model=\"ctrl.item[ctrl.bindings.property]\"\n" +
    "                ng-disabled=\"ctrl.pathProperties().length <= 1\"\n" +
    "                required=\"true\"\n" +
    "                custom-items=\"ctrl.pathProperties()\"\n" +
    "                placeholder=\"{{'Bluemoon.Practice.Common.GroupSort.SortBy' | translate}}\"\n" +
    "                value-property=\"path\">\n" +
    "        </bmp-enum-combo>\n" +
    "</div>\n" +
    "<!-- Order -->\n" +
    "<div bmp-control-group=\"\" class=\"col-md-3 col-sm-3 col-xs-12\"\n" +
    "     bmp-control-group-field-id=\"{{::ctrl.name}}.order\"\n" +
    "     bmp-control-group-label=\"{{'Bluemoon.Practice.Common.GroupSort.Order' | translate}}\"\n" +
    "     bmp-control-group-label-hide=\"false\">\n" +
    "        <bmp-enum-combo enum=\"group-sort-direction\" name=\"{{::ctrl.name}}.order\" id=\"{{::ctrl.name}}-order\"\n" +
    "                ng-model=\"ctrl.item[ctrl.bindings.order]\"\n" +
    "                value-property=\"id\"\n" +
    "                placeholder=\"{{'Bluemoon.Practice.Common.GroupSort.Order' | translate}}\"\n" +
    "                required=\"true\">\n" +
    "        </bmp-enum-combo>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-group-sort/bmp-group-sort.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-group-sort/bmp-group-sort.html",
    "<div class=\"row bmp-group-sort-item\" ng-class=\"{'well bm-well': ctrl.additionalCustomOptions.length > 0}\" ng-repeat=\"item in ctrl.items\">\n" +
    "    <div class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "        <div class=\"row\">\n" +
    "            <bmp-group-sort-item name=\"{{::ctrl.name}}_KEY__{{$index}}\" item=\"item\" options=\"ctrl.options\" bindings=\"ctrl.bindings\" />\n" +
    "        </div>\n" +
    "        <div class=\"row bmp-group-sort-additional-options\" ng-if=\"!!ctrl.additionalCustomOptions\">\n" +
    "            <div ng-repeat=\"customOption in ctrl.additionalCustomOptions\" class=\"col-md-5 col-xs-12\">\n" +
    "                <bmp-additional-custom-options additional-option=\"customOption\" ng-model=\"item.customItems[customOption.id]\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-2 col-sm-2 col-xs-12\">\n" +
    "        <a href=\"\" class=\"btn btn-link bmp-group-sort-button\" role=\"button\" tabindex=\"0\" ng-click=\"ctrl.removeItem(item)\" data-qe-id=\"{{::ctrl.name}}_remove_KEY__{{$index}}\">\n" +
    "            <i class=\"glyphicon glyphicon-remove\"></i> <span translate=\"Bluemoon.Practice.Common.GroupSort.Remove\"></span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" ng-if=\"ctrl.canAddItem()\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <a href=\"\" class=\"btn btn-link bmp-group-sort-button\" role=\"button\" tabindex=\"0\" ng-click=\"ctrl.addItem()\" data-qe-id=\"{{::ctrl.name}}_add\">\n" +
    "            <i class=\"bento-icon-add\"></i> <span translate=\"Bluemoon.Practice.Common.GroupSort.Add\"></span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-iframe-carousel/bmp-iframe-carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-iframe-carousel/bmp-iframe-carousel.html",
    "<div ng-if=\"vm.tabs.length === 1\">\n" +
    "  <iframe ng-style=\"{ 'height': vm.getHeight() }\" src=\"{{vm.trustSrc(vm.tabs[0].url)}}\"></iframe>\n" +
    "</div>\n" +
    "<div ng-if=\"vm.tabs.length > 1\" class=\"bmp-iframe-carousel-with-arrows\">\n" +
    "  <uib-tabset type=\"pills\" active=\"vm.activeTabIndex\">\n" +
    "    <uib-tab ng-repeat=\"item in vm.tabs\" heading=\"{{item.name}}\" >\n" +
    "      <iframe ng-style=\"{ 'height': vm.getHeight() }\" src=\"{{vm.trustSrc(item.url)}}\"></iframe>\n" +
    "    </uib-tab>\n" +
    "  </uib-tabset>\n" +
    "  <div data-qe-id=\"carousel-left-button\"\n" +
    "       class=\"bento-carousel-left-arrow bento-carousel-arrow\" style=\"left:-15px\"\n" +
    "       ng-show=\"vm.showLeftArrow()\"\n" +
    "       ng-click=\"vm.arrowClicked(-1)\">\n" +
    "    <i class=\"bento-icon-chevron-left\"></i>\n" +
    "    </div>\n" +
    "  <div data-qe-id=\"carousel-right-button\"\n" +
    "       class=\"bento-carousel-right-arrow bento-carousel-arrow\" style=\"right:-15px\"\n" +
    "       ng-show=\"vm.showRightArrow()\"\n" +
    "       ng-click=\"vm.arrowClicked(1)\">\n" +
    "    <i class=\"bento-icon-chevron-right\"></i>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-input-group-btn-dropdown/bmp-input-group-btn-dropdown.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-input-group-btn-dropdown/bmp-input-group-btn-dropdown.html",
    "<div class=\"input-group-btn\" data-ng-class=\"{open: vm.menuOpen}\">\n" +
    "    <button type=\"button\"\n" +
    "            class=\"btn btn-default dropdown-toggle\"\n" +
    "            ng-style=\"{'background-color': '#ebebeb'}\"\n" +
    "            data-toggle=\"dropdown\"\n" +
    "            data-ng-disabled=\"disabled()\"\n" +
    "            data-ng-click=\"vm.clickDropdown()\">\n" +
    "        <span class=\"bento-icon-arrow-down\"></span>\n" +
    "    </button>\n" +
    "    <ul class=\"dropdown-menu pull-right\">\n" +
    "        <li data-ng-repeat=\"option in vm.cachedOptions\">\n" +
    "            <a class=\"bmp-clickable\" data-ng-click=\"vm.clickOption(option)\">{{vm.labelForOption(option)}}</a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-master-detail/bmp-detail-tab-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-master-detail/bmp-detail-tab-view.html",
    "<div class=\"container-fluid no-left-padding view-container\" ng-class=\"{'modal-workspace-no-bottom-margin': vm.inWorkspaceModal}\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\" ng-class=\"{'modal-workspace-margin-left': vm.inWorkspaceModal, 'modal-workspace-container': vm.inWorkspaceModal}\">\n" +
    "            <div ng-form name=\"detailTabForm\" autocomplete=\"off\">\n" +
    "                <bmp-page-header\n" +
    "                    is-in-modal=\"vm.inWorkspaceModal\"\n" +
    "                    ng-if=\"!vm.detailContext.detailContext\"\n" +
    "                    show-help=\"vm.detailContext.showTitleButtons()\"\n" +
    "                    location=\"{{vm.definition.fullUrl}}\">\n" +
    "                    <bmp-page-header-left-content>\n" +
    "                        <h1 data-qe-id=\"header-title\"\n" +
    "                            class=\"bmp-page-header-truncate\"\n" +
    "                            uib-tooltip=\"{{vm.setupListLabel()}}\"\n" +
    "                            tooltip-trigger=\"mouseenter\"\n" +
    "                            tooltip-placement=\"bottom\"\n" +
    "                            tooltip-append-to-body=\"true\">{{vm.setupListLabel()}}</h1>\n" +
    "                        <h1 ng-if=\"vm.detailContext.detail.isLoadingData() && vm.setupListLabel() === ''\"\n" +
    "                            class=\"bmp-page-header-truncate\">\n" +
    "                            {{vm.detailContext.detail.busyText}}\n" +
    "                        </h1>\n" +
    "                    </bmp-page-header-left-content>\n" +
    "                    <bmp-page-header-right-content data-ng-show=\"vm.detailContext.showTitleButtons()\">\n" +
    "                        <button type=\"button\" id=\"detailForm.customsave\" class=\"btn btn-primary\"\n" +
    "                                data-qe-id=\"header-custom{{vm.dataQeId}}-save-button\"\n" +
    "                                data-ng-if=\"vm.inWorkspaceModal && vm.definition.customSave && !vm.hideCustomSave\"\n" +
    "                                data-ng-click=\"console.log('customSave tab 1'); vm.definition.customSave(vm.detail, vm.data);vm.broadCastTaxYearChange();\"\n" +
    "                                data-translate=\"{{::vm.definition.customSaveText}}\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\" id=\"detailForm.save\" class=\"btn btn-primary\"\n" +
    "                                data-qe-id=\"header{{vm.dataQeId}}-save-button\"\n" +
    "                                data-ng-click=\"console.log('save tab 1'); vm.detailContext.detail.save();vm.broadCastTaxYearChange();\"\n" +
    "                                data-translate=\"{{vm.saveBtnText}}\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\" id=\"detailForm.cancel\"\n" +
    "                                data-qe-id=\"header{{vm.dataQeId}}-cancel-button\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-ng-click=\"vm.detailContext.detail.cancel()\"\n" +
    "                                data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                    </bmp-page-header-right-content>\n" +
    "                </bmp-page-header>\n" +
    "                <bmp-sub-page-header ng-if=\"vm.detailContext.detailContext\" ng-class=\"{loading: vm.detail.isLoadingData()}\" affix=\"!vm.inWorkspaceModal\">\n" +
    "                    <bmp-sub-page-header-left-content>\n" +
    "                        <h3 data-qe-id=\"header-title\">{{vm.setupListLabel()}}</h3>\n" +
    "                    </bmp-sub-page-header-left-content>\n" +
    "                    <bmp-sub-page-header-right-content data-ng-show=\"vm.detailContext.showTitleButtons()\">\n" +
    "                        <button type=\"button\" id=\"detailForm.customsave\" class=\"btn btn-primary\"\n" +
    "                            data-qe-id=\"header-custom{{vm.dataQeId}}-save-button\"\n" +
    "                            data-ng-if=\"vm.inWorkspaceModal && vm.definition.customSave\"\n" +
    "                            data-ng-click=\"console.log('customSave tab 1'); vm.definition.customSave(vm.detail, vm.data)\"\n" +
    "                            data-translate=\"{{::vm.definition.customSaveText}}\"\n" +
    "                            ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\" id=\"detailForm.save\" class=\"btn btn-primary\"\n" +
    "                                data-qe-id=\"header{{vm.dataQeId}}-save-button\"\n" +
    "                                data-ng-click=\"console.log('save tab 2'); vm.detailContext.detail.save()\"\n" +
    "                                data-translate=\"Bluemoon.Practice.Common.Actions.Save\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\" id=\"detailForm.cancel\"\n" +
    "                                data-qe-id=\"header{{vm.dataQeId}}-cancel-button\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-ng-click=\"vm.detailContext.detail.cancel()\"\n" +
    "                                data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                    </bmp-sub-page-header-right-content>\n" +
    "                </bmp-sub-page-header>\n" +
    "\n" +
    "                <div ng-class=\"{'modal-workspace-content-wrapper': vm.inWorkspaceModal}\">\n" +
    "                    <bmp-routable-tabset bmp-routable-tabset-orientation=\"{{vm.detailContext.detailContext ? 'top' : 'left'}}\"\n" +
    "                                        bmp-routable-tabset-tabs=\"vm.tabs\" bmp-modal-state-data=\"$modalUiView.modalStateData\">\n" +
    "                        <bmp-modal-routable-ui-view bento-busy-loader=\"vm.detailContext.detail.isLoadingData()\"></bmp-modal-routable-ui-view>\n" +
    "                        <!--<div ui-view class=\"enter-item-animation\"></div>-->\n" +
    "                    </bmp-routable-tabset>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-master-detail/bmp-detail-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-master-detail/bmp-detail-view.html",
    "<div class=\"container-fluid no-left-padding view-container\"\n" +
    "     ng-class=\"{'modal-workspace-no-bottom-margin': vm.inWorkspaceModal}\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\"\n" +
    "             ng-class=\"{'modal-workspace-margin-left': vm.inWorkspaceModal, 'modal-workspace-container': vm.inWorkspaceModal}\">\n" +
    "            <div ng-form\n" +
    "                 id=\"detailForm\"\n" +
    "                 name=\"detailForm\"\n" +
    "                 autocomplete=\"off\"\n" +
    "                 bmp-detail-view-default-focus=\"vm.data\"\n" +
    "                 data-ng-class=\"{ 'well bm-well': !vm.inWorkspaceModal && vm.parsedContext.parentContextId }\">\n" +
    "                <bmp-page-header is-in-modal=\"vm.inWorkspaceModal\"\n" +
    "                                 ng-if=\"vm.displayPageHeader()\"\n" +
    "                                 show-help=\"vm.detailContext.showTitleButtons()\"\n" +
    "                                 location=\"{{vm.definition.fullUrl}}\">\n" +
    "                    <bmp-page-header-left-content>\n" +
    "                        <h1 data-qe-id=\"header-title\"\n" +
    "                            class=\"bmp-page-header-truncate\"\n" +
    "                            uib-tooltip=\"{{vm.setupListLabel()}}\"\n" +
    "                            tooltip-trigger=\"mouseenter\"\n" +
    "                            tooltip-placement=\"bottom\"\n" +
    "                            tooltip-append-to-body=\"true\">{{vm.setupListLabel()}}</h1>\n" +
    "                        <h1 class=\"bmp-page-header-truncate\">\n" +
    "                            {{vm.data.$customTitleHtml}}\n" +
    "                        </h1>\n" +
    "                        <h1 ng-if=\"vm.detailContext.detail.isLoadingData() && vm.setupListLabel() === ''\"\n" +
    "                            class=\"bmp-page-header-truncate\">\n" +
    "                            {{vm.detailContext.detail.busyText}}\n" +
    "                        </h1>\n" +
    "                    </bmp-page-header-left-content>\n" +
    "                    <bmp-page-header-right-content ng-if=\"vm.detailContext.showTitleButtons()\">\n" +
    "                        <button type=\"button\" id=\"detailForm.customsave\" class=\"btn btn-primary\"\n" +
    "                            data-qe-id=\"header-custom{{vm.dataQeId}}-save-button\"\n" +
    "                            data-ng-if=\"vm.inWorkspaceModal && vm.definition.customSave\"\n" +
    "                            data-ng-click=\"console.log('customSave tab 1'); vm.definition.customSave(vm.detail, vm.data)\"\n" +
    "                            data-translate=\"{{::vm.definition.customSaveText}}\"\n" +
    "                            ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\"\n" +
    "                                id=\"detailForm.save\"\n" +
    "                                class=\"btn btn-primary\"\n" +
    "                                data-qe-id=\"header{{vm.dataQeId}}-save-button\"\n" +
    "                                data-ng-click=\"console.log(vm.detail); vm.detail.save()\"\n" +
    "                                data-translate=\"{{vm.saveBtnText}}\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\"\n" +
    "                                id=\"detailForm.cancel\"\n" +
    "                                data-qe-id=\"header{{vm.dataQeId}}-cancel-button\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-ng-click=\"vm.detail.cancel()\"\n" +
    "                                data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                    </bmp-page-header-right-content>\n" +
    "                </bmp-page-header>\n" +
    "                <bmp-sub-page-header ng-if=\"vm.displaySubPageHeader()\"\n" +
    "                                     ng-class=\"{loading: vm.detail.isLoadingData()}\"\n" +
    "                                     affix=\"!vm.inWorkspaceModal\">\n" +
    "                    <bmp-sub-page-header-left-content>\n" +
    "                        <h3 data-qe-id=\"header-title\">{{vm.setupListLabel()}}</h3>\n" +
    "                    </bmp-sub-page-header-left-content>\n" +
    "                    <bmp-sub-page-header-right-content>\n" +
    "                        <button type=\"button\" id=\"detailForm.customsave\" class=\"btn btn-primary\"\n" +
    "                            data-qe-id=\"header-custom-save-button\"\n" +
    "                            data-ng-if=\"vm.inWorkspaceModal && vm.definition.customSave\"\n" +
    "                            data-ng-click=\"console.log('customSave tab 1'); vm.definition.customSave(vm.detail, vm.data)\"\n" +
    "                            data-translate=\"{{::vm.definition.customSaveText}}\"\n" +
    "                            ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\"\n" +
    "                                id=\"detailForm.save\"\n" +
    "                                class=\"btn btn-primary\"\n" +
    "                                data-qe-id=\"header-save-button\"\n" +
    "                                data-ng-click=\"console.log(vm.detail); vm.detail.save()\"\n" +
    "                                data-translate=\"Bluemoon.Practice.Common.Actions.Save\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\"\n" +
    "                                id=\"detailForm.cancel\"\n" +
    "                                data-qe-id=\"header-cancel-button\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-ng-click=\"vm.detail.cancel()\"\n" +
    "                                data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                    </bmp-sub-page-header-right-content>\n" +
    "                </bmp-sub-page-header>\n" +
    "\n" +
    "                <div bento-busy-loader=\"vm.detail.isLoadingData() && vm.displayPageHeader()\"></div>\n" +
    "                <div ng-class=\"{'modal-workspace-custom-detail-screen': vm.useCustomDetailClass()}\"\n" +
    "                     ng-hide=\"vm.detail.isLoadingData()\">\n" +
    "                    <h3 class=\"no-top-margin\"\n" +
    "                        ng-if=\"vm.definition.tabs\">{{vm.definition.generalTab | translate}}</h3>\n" +
    "\n" +
    "                    <item ng-repeat=\"field in vm.definition.fields\"\n" +
    "                          ng-if=\"!vm.definition.replaceDefaultScreen\">\n" +
    "                        <div class=\"row\"\n" +
    "                             bm-if-perm-every=\"field.requiredPermissions\">\n" +
    "\n" +
    "                            <!-- Primary / Unique -->\n" +
    "                            <div ng-if=\"field.isPrimary\"\n" +
    "                                 data-bmp-control-group=\"\"\n" +
    "                                 data-bmp-control-group-field-id=\"{{field.data}}\"\n" +
    "                                 data-bmp-control-group-label=\"{{'Core.Captions.' + vm.definition.id + '.' + field.id | translate | bmRequiredMark}}\"\n" +
    "\n" +
    "                                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, field.data) || detailForm[field.data].errorMessage\"\n" +
    "\n" +
    "                                 class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <input autocomplete=\"off\"\n" +
    "                                       type=\"text\"\n" +
    "                                       id=\"{{field.data}}\"\n" +
    "                                       name=\"{{field.data}}\"\n" +
    "                                       data-qe-id=\"{{::field.data}}\"\n" +
    "                                       class=\"form-control\"\n" +
    "                                       data-ng-disabled=\"vm.data.systemId || vm.data.onlinePaymentProcessorTypeId\"\n" +
    "                                       data-ng-required=\"true\"\n" +
    "                                       data-ng-model=\"vm.data[field.data]\"\n" +
    "                                       data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                                       data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                       data-bmp-entity-code=\"\"\n" +
    "                                       data-bmp-entity-code-id=\"vm.id\"\n" +
    "                                       data-bmp-entity-code-type=\"{{vm.definition.code}}\"\n" +
    "                                       data-bmp-entity-code-company-id=\"vm.detail.getCurrentCompanyId()\"\n" +
    "                                       data-bm-focus-on-link=\"\"\n" +
    "                                       data-fef-maxlength=\"{{field.maxLength}}\"\n" +
    "                                       data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!-- Secondary / Other -->\n" +
    "                            <div ng-if=\"!field.isPrimary && field.visible\"\n" +
    "                                 data-bmp-control-group=\"\"\n" +
    "                                 data-bmp-control-group-field-id=\"{{field.data}}\"\n" +
    "                                 data-bmp-control-group-label=\"{{'Core.Captions.' + vm.definition.id + '.' + field.id | translate | bmRequiredMark:field.required || false}}\"\n" +
    "\n" +
    "                                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, field.data) || detailForm[field.data].errorMessage\"\n" +
    "\n" +
    "                                 class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                                <input autocomplete=\"off\"\n" +
    "                                       type=\"text\"\n" +
    "                                       ng-if=\"!field.multiline\"\n" +
    "                                       id=\"{{field.data}}\"\n" +
    "                                       name=\"{{field.data}}\"\n" +
    "                                       data-qe-id=\"{{::field.data}}\"\n" +
    "                                       class=\"form-control\"\n" +
    "                                       data-ng-required=\"{{field.required}}\"\n" +
    "                                       data-ng-disabled=\"vm.data.systemId || vm.data.onlinePaymentProcessorTypeId\"\n" +
    "                                       data-ng-model=\"vm.data[field.data]\"\n" +
    "                                       data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                       data-fef-maxlength=\"{{field.maxLength}}\"\n" +
    "                                       data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                                <textarea rows=\"3\"\n" +
    "                                          ng-if=\"field.multiline\"\n" +
    "                                          id=\"{{field.data}}\"\n" +
    "                                          name=\"{{field.data}}\"\n" +
    "                                          data-qe-id=\"{{::field.data}}\"\n" +
    "                                          class=\"form-control\"\n" +
    "                                          data-ng-required=\"{{field.required}}\"\n" +
    "                                          data-ng-disabled=\"vm.data.systemId || vm.data.onlinePaymentProcessorTypeId\"\n" +
    "                                          data-ng-model=\"vm.data[field.data]\"\n" +
    "                                          data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                          data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "                            </div>\n" +
    "\n" +
    "                        </div>\n" +
    "                    </item>\n" +
    "\n" +
    "                    <!-- System Defined -->\n" +
    "                    <div ng-if=\"!vm.definition.replaceDefaultScreen\"\n" +
    "                         class=\"row\"\n" +
    "                         ng-show=\"vm.data.systemId\">\n" +
    "                        <div class=\"col-md-6\">\n" +
    "                            <div class=\"alert alert-info\">\n" +
    "                                <small>{{::vm.systemIdLabel()}}</small>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <!-- System Defined By OnlinePaymentProcessorTypeId -->\n" +
    "                    <div ng-if=\"!vm.definition.replaceDefaultScreen\"\n" +
    "                         class=\"row\"\n" +
    "                         ng-show=\"vm.data.onlinePaymentProcessorTypeId\">\n" +
    "                        <div class=\"col-md-6\">\n" +
    "                            <div class=\"alert alert-info\">\n" +
    "                                <small>{{::vm.systemIdLabel()}}</small>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div ng-if=\"vm.definition.customDetailScreen\"\n" +
    "                         ng-include=\"vm.definition.customDetailScreen\">\n" +
    "                        <!-- Container for custom detail screen -->\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-master-detail/bmp-master-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-master-detail/bmp-master-view.html",
    "<div class=\"container-fluid no-left-padding view-container\">\n" +
    "    <div class=\"modal-header modal-bmWorkspace-header master-view-modal-header\" ng-if=\"vm.masterViewModal\">\n" +
    "            <button type=\"button\" id=\"masterView.close\"\n" +
    "            data-qe-id=\"header-close-button\"\n" +
    "            class=\"btn btn-default close\"\n" +
    "            data-ng-click=\"vm.close()\"\n" +
    "            data-translate=\"Bluemoon.Practice.Common.Actions.Close\"\n" +
    "            ></button>\n" +
    "            <bm-help-dropdown class=\"help-dropdown-on-step\" location=\"/staff/#{{vm.definition.fullUrl}}\"></bm-help-dropdown>\n" +
    "            <h3 class=\"modal-title\">{{vm.definition.workspaceModeTitle | translate}}</h3>\n" +
    "    </div>\n" +
    "    <!-- Title -->\n" +
    "    <h1 class=\"no-top-margin\" data-ng-if=\"!vm.detailContext && vm.getDefinition().title\" data-qe-id=\"header-title\">{{vm.getDefinition().title | translate}}</h1>\n" +
    "    <h2 class=\"no-top-margin\" data-ng-if=\"vm.detailContext && vm.getDefinition().title\" data-qe-id=\"header-title\">{{vm.getDefinition().title | translate}}</h2>\n" +
    "    <!-- Grid -->\n" +
    "    <div class=\"row\" ng-class=\"{'modal-workspace-body master-view-modal-body': vm.masterViewModal}\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div ng-if=\"vm.definition.customListScreen\" ng-include=\"vm.definition.customListScreen\">\n" +
    "                <!-- Container for custom list screen -->\n" +
    "            </div>\n" +
    "            <div ng-if=\"!vm.definition.customListScreen\">\n" +
    "                <bmp-grid bmp-grid-definition=\"vm.getDefinition()\"\n" +
    "                          bmp-grid-service=\"vm.getService()\"\n" +
    "                          bmp-grid-context-id=\"vm.getContextId()\"\n" +
    "                          bmp-grid-before-load=\"vm.gridLoaded($sender)\"></bmp-grid>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-master-detail/bmp-modal-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-master-detail/bmp-modal-view.html",
    "<!-- Modal view -->\n" +
    "<div ng-form id=\"detailForm\" name=\"detailForm\" autocomplete=\"off\" bmp-detail-view-default-focus=\"vm.data\">\n" +
    "\n" +
    "    <!-- Header -->\n" +
    "    <div class=\"modal-header\" data-role=\"header\" data-position=\"fixed\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Title -->\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <h3 data-qe-id=\"header-title\" data-ng-hide=\"vm.detail.isLoadingData()\">{{vm.setupListLabel()}}</h3>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Body -->\n" +
    "    <div class=\"modal-body\" data-role=\"main\" bento-busy-loader=\"vm.formBusy || vm.detail.isLoadingData()\">\n" +
    "\n" +
    "        <div class=\"row\" ng-if=\"vm.initialized\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "\n" +
    "                <div class=\"hidden-lg hidden-md hidden-sm\">\n" +
    "                    <h3 data-qe-id=\"header-title\">{{vm.setupListLabel()}}</h3>\n" +
    "                </div>\n" +
    "                <item ng-repeat=\"field in vm.definition.fields\" ng-if=\"!vm.definition.replaceDefaultScreen\">\n" +
    "                    <div class=\"row\" bm-if-perm-every=\"field.requiredPermissions\">\n" +
    "\n" +
    "                        <!-- Primary / Unique -->\n" +
    "                        <div ng-if=\"field.isPrimary\" data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"{{field.data}}\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.' + vm.definition.id + '.' + field.id | translate | bmRequiredMark}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, field.data) || detailForm[field.data].errorMessage\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\"\n" +
    "                                id=\"{{field.data}}\"\n" +
    "                                name=\"{{field.data}}\"\n" +
    "                                data-qe-id=\"{{::field.data}}\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-disabled=\"vm.data.systemId\"\n" +
    "                                data-ng-required=\"true\"\n" +
    "                                data-ng-model=\"vm.data[field.data]\"\n" +
    "                                data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                                data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                data-bmp-entity-code=\"\"\n" +
    "                                data-bmp-entity-code-id=\"vm.id\"\n" +
    "                                data-bmp-entity-code-type=\"{{vm.definition.code}}\"\n" +
    "                                data-bmp-entity-code-company-id=\"vm.detail.getCurrentCompanyId()\"\n" +
    "                                data-bm-focus-on-link=\"\"\n" +
    "                                data-fef-maxlength=\"{{field.maxLength}}\"\n" +
    "                                data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- Secondary / Other -->\n" +
    "                        <div ng-if=\"!field.isPrimary && field.visible\" data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"{{field.data}}\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.' + vm.definition.id + '.' + field.id | translate | bmRequiredMark:field.required || false}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, field.data) || detailForm[field.data].errorMessage\"\n" +
    "                            class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" ng-if=\"!field.multiline\"\n" +
    "                                id=\"{{field.data}}\"\n" +
    "                                name=\"{{field.data}}\"\n" +
    "                                data-qe-id=\"{{::field.data}}\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-required=\"{{field.required}}\"\n" +
    "                                data-ng-disabled=\"vm.data.systemId\"\n" +
    "                                data-ng-model=\"vm.data[field.data]\"\n" +
    "                                data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                data-fef-maxlength=\"{{field.maxLength}}\"\n" +
    "                                data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                            <textarea rows=\"3\" ng-if=\"field.multiline\"\n" +
    "                                    id=\"{{field.data}}\"\n" +
    "                                    name=\"{{field.data}}\"\n" +
    "                                    data-qe-id=\"{{::field.data}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-required=\"{{field.required}}\"\n" +
    "                                    data-ng-disabled=\"vm.data.systemId\"\n" +
    "                                    data-ng-model=\"vm.data[field.data]\"\n" +
    "                                    data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                    data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "                        </div>\n" +
    "\n" +
    "                    </div>\n" +
    "                </item>\n" +
    "\n" +
    "                <!-- System Defined -->\n" +
    "                <div ng-if=\"!vm.definition.replaceDefaultScreen && vm.data.systemId\" class=\"row\">\n" +
    "                    <div class=\"col-md-6\">\n" +
    "                        <div class=\"alert alert-info\">\n" +
    "                            <small>{{::vm.systemIdLabel()}}</small>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div ng-if=\"vm.definition.customDetailWorkspaceBackCompatScreen\" ng-include=\"vm.definition.customDetailWorkspaceBackCompatScreen\">\n" +
    "                    <!-- Container for custom detail screen -->\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Buttons -->\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button type=\"button\" id=\"detailForm.customsave\" class=\"btn btn-primary\"\n" +
    "                    data-qe-id=\"header-custom-save-button\"\n" +
    "                    data-ng-if=\"vm.definition.customSave && !vm.definition.hideCustomSave(vm.data)\"\n" +
    "                    data-ng-click=\"vm.definition.customSave(vm.detail, vm.data)\"\n" +
    "                    data-translate=\"{{::vm.definition.customSaveText}}\"></button>\n" +
    "            <button type=\"button\" id=\"detailForm.save\" class=\"btn btn-primary\"\n" +
    "                    data-qe-id=\"header-save-button\"\n" +
    "                    data-ng-if=\"!vm.definition.hideDefaultSave(vm.data)\"\n" +
    "                    data-ng-click=\"vm.detail.save()\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.Actions.SaveAndClose\"></button>\n" +
    "            <button type=\"button\" id=\"detailForm.cancel\"\n" +
    "                    data-qe-id=\"header-cancel-button\"\n" +
    "                    class=\"btn btn-default\"\n" +
    "                    data-ng-click=\"vm.detail.cancel()\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-master-detail/bmp-workspace-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-master-detail/bmp-workspace-view.html",
    "<!-- Workspace view -->\n" +
    "<div class=\"modal-workspace-content modal-bmWorkspace modal-workspace-margin-left\" ng-form id=\"detailForm\" name=\"detailForm\" autocomplete=\"off\" bmp-detail-view-default-focus=\"vm.data\">\n" +
    "    <bmp-page-header is-in-modal=\"true\">\n" +
    "        <bmp-page-header-left-content>\n" +
    "            <h1 data-qe-id=\"header-title\" data-ng-hide=\"vm.detail.isLoadingData()\">{{vm.setupListLabel()}}</h1>\n" +
    "            <h1 ng-if=\"vm.detail.isLoadingData() && vm.setupListLabel() === ''\">\n" +
    "                {{vm.detail.busyText}}\n" +
    "            </h1>\n" +
    "        </bmp-page-header-left-content>\n" +
    "        <bmp-page-header-right-content>\n" +
    "            <button type=\"button\" id=\"detailForm.customsave\" class=\"btn btn-primary\"\n" +
    "                    data-qe-id=\"header-custom-save-button\"\n" +
    "                    data-ng-if=\"vm.definition.customSave\"\n" +
    "                    data-ng-click=\"vm.definition.customSave(vm.detail, vm.data)\"\n" +
    "                    data-translate=\"{{::vm.definition.customSaveText}}\"\n" +
    "                    ng-disabled=\"vm.detail.isLoadingData()\"></button>\n" +
    "            <button type=\"button\" id=\"detailForm.save\" class=\"btn btn-primary\"\n" +
    "                    data-qe-id=\"header-save-button\"\n" +
    "                    data-ng-click=\"vm.detail.save()\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.Actions.SaveAndClose\"\n" +
    "                    ng-disabled=\"vm.detail.isLoadingData()\"></button>\n" +
    "            <button type=\"button\" id=\"detailForm.cancel\"\n" +
    "                    data-qe-id=\"header-cancel-button\"\n" +
    "                    class=\"btn btn-default\"\n" +
    "                    data-ng-click=\"vm.detail.cancel()\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                    ng-disabled=\"vm.detail.isLoadingData()\"></button>\n" +
    "        </bmp-page-header-right-content>\n" +
    "    </bmp-page-header>\n" +
    "\n" +
    "    <!-- Body -->\n" +
    "    <div class=\"modal-workspace-body\" data-role=\"main\" bento-busy-loader=\"vm.detail.isLoadingData()\">\n" +
    "        <div class=\"row\" ng-if=\"vm.initialized\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "\n" +
    "                <div class=\"hidden-lg hidden-md hidden-sm\">\n" +
    "                    <h3 data-qe-id=\"header-title\">{{vm.setupListLabel()}}</h3>\n" +
    "                </div>\n" +
    "                <item ng-repeat=\"field in vm.definition.fields\" ng-if=\"!vm.definition.replaceDefaultScreen\">\n" +
    "                    <div class=\"row\" bm-if-perm-every=\"field.requiredPermissions\">\n" +
    "\n" +
    "                        <!-- Primary / Unique -->\n" +
    "                        <div ng-if=\"field.isPrimary\" data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"{{field.data}}\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.' + vm.definition.id + '.' + field.id | translate | bmRequiredMark}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, field.data) || detailForm[field.data].errorMessage\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\"\n" +
    "                                id=\"{{field.data}}\"\n" +
    "                                name=\"{{field.data}}\"\n" +
    "                                data-qe-id=\"{{::field.data}}\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-disabled=\"vm.data.systemId\"\n" +
    "                                data-ng-required=\"true\"\n" +
    "                                data-ng-model=\"vm.data[field.data]\"\n" +
    "                                data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                                data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                data-bmp-entity-code=\"\"\n" +
    "                                data-bmp-entity-code-id=\"vm.id\"\n" +
    "                                data-bmp-entity-code-type=\"{{vm.definition.code}}\"\n" +
    "                                data-bmp-entity-code-company-id=\"vm.detail.getCurrentCompanyId()\"\n" +
    "                                data-bm-focus-on-link=\"\"\n" +
    "                                data-fef-maxlength=\"{{field.maxLength}}\"\n" +
    "                                data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- Secondary / Other -->\n" +
    "                        <div ng-if=\"!field.isPrimary && field.visible\" data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"{{field.data}}\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.' + vm.definition.id + '.' + field.id | translate | bmRequiredMark:field.required || false}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, field.data) || detailForm[field.data].errorMessage\"\n" +
    "                            class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" ng-if=\"!field.multiline\"\n" +
    "                                id=\"{{field.data}}\"\n" +
    "                                name=\"{{field.data}}\"\n" +
    "                                data-qe-id=\"{{::field.data}}\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-required=\"{{field.required}}\"\n" +
    "                                data-ng-disabled=\"vm.data.systemId\"\n" +
    "                                data-ng-model=\"vm.data[field.data]\"\n" +
    "                                data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                data-fef-maxlength=\"{{field.maxLength}}\"\n" +
    "                                data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                            <textarea rows=\"3\" ng-if=\"field.multiline\"\n" +
    "                                    id=\"{{field.data}}\"\n" +
    "                                    name=\"{{field.data}}\"\n" +
    "                                    data-qe-id=\"{{::field.data}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-required=\"{{field.required}}\"\n" +
    "                                    data-ng-disabled=\"vm.data.systemId\"\n" +
    "                                    data-ng-model=\"vm.data[field.data]\"\n" +
    "                                    data-ng-change=\"vm.detail.clearErrorFor(vm.data, field.data)\"\n" +
    "                                    data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "                        </div>\n" +
    "\n" +
    "                    </div>\n" +
    "                </item>\n" +
    "\n" +
    "                <!-- System Defined -->\n" +
    "                <div ng-if=\"!vm.definition.replaceDefaultScreen && vm.data.systemId\" class=\"row\">\n" +
    "                    <div class=\"col-md-6\">\n" +
    "                        <div class=\"alert alert-info\">\n" +
    "                            <small>{{::vm.systemIdLabel()}}</small>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div ng-if=\"vm.definition.customDetailWorkspaceBackCompatScreen\" ng-include=\"vm.definition.customDetailWorkspaceBackCompatScreen\">\n" +
    "                    <!-- Container for custom detail screen -->\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-message-dialog/bmp-message-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-message-dialog/bmp-message-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\" ng-if=\"bmpMessageDialog.showHeader()\">\n" +
    "        <span>{{bmpMessageDialog.titleText()}}</span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body modal-confirm-body\">\n" +
    "        <i class=\"glyphicons warning_sign modal-confirm-icon\"></i>\n" +
    "        <span class=\"modal-confirm-message\">\n" +
    "            {{bmpMessageDialog.bodyText()}}\n" +
    "            <br ng-if=\"bmpMessageDialog.additionalBodyText()\" />\n" +
    "            <br ng-if=\"bmpMessageDialog.additionalBodyText()\" />\n" +
    "            {{bmpMessageDialog.additionalBodyText()}}\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button id=\"bmpMessageDialog.ok\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                data-ng-click=\"bmpMessageDialog.onOk()\"\n" +
    "                data-ng-disabled=\"bmpMessageDialog.okDisabled()\">\n" +
    "            {{bmpMessageDialog.okText()}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-modal-wizard/bmp-modal-wizard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-modal-wizard/bmp-modal-wizard.html",
    "<div bento-busy-loader=\"vm.showThrobber\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">\n" +
    "        <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "\n" +
    "    <div class=\"modal-header\">\n" +
    "        <span>{{vm.step.title}}</span>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-form name=\"modalWizardForm\">\n" +
    "\n" +
    "        <div ng-if=\"vm.step.templateUrl\" ng-include=\"vm.step.templateUrl\"></div>\n" +
    "        <div id=\"bmp-modalwizard-template-element\"></div>\n" +
    "\n" +
    "    </div><!-- end of modalWizardForm -->\n" +
    "\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button\n" +
    "            ng-if=\"!vm.isFirstStep\"\n" +
    "            type=\"button\"\n" +
    "            data-qe-id=\"bm-modalwizard-previous-button\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            ng-click=\"vm.previous()\"\n" +
    "            translate>Bluemoon.Practice.Common.Buttons.Previous\n" +
    "        </button>\n" +
    "        <button\n" +
    "            ng-if=\"!vm.isLastStep\"\n" +
    "            type=\"button\"\n" +
    "            data-qe-id=\"bm-modalwizard-next-button\"\n" +
    "            class=\"btn btn-primary\"\n" +
    "            ng-click=\"vm.next()\"\n" +
    "            translate>Bluemoon.Practice.Common.Buttons.Next\n" +
    "        </button>\n" +
    "        <button\n" +
    "            ng-if=\"vm.isLastStep\"\n" +
    "            type=\"button\"\n" +
    "            data-qe-id=\"bm-modalwizard-finish-button\"\n" +
    "            class=\"btn btn-primary\"\n" +
    "            ng-click=\"vm.next()\"\n" +
    "            translate>Bluemoon.Practice.Common.Buttons.Finish\n" +
    "        </button>\n" +
    "        <button\n" +
    "            style=\"float: right\"\n" +
    "            type=\"button\"\n" +
    "            data-qe-id=\"bm-modalwizard-cancel-button\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            ng-click=\"vm.cancel()\"\n" +
    "            translate>Bluemoon.Practice.Common.Buttons.Cancel\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-modal/bmp-modal-button.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-modal/bmp-modal-button.html",
    "<div data-ng-click=\"vm.showModal()\" ng-transclude=\"bmpModalButton\">\n" +
    "    <button class=\"btn btn-primary\"\n" +
    "        data-ng-disabled=\"vm.ngDisabled\">{{vm.labelKey | translate}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-modal/bmp-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-modal/bmp-modal.html",
    "<!-- Header -->\n" +
    "<div id=\"{{::id}}\">\n" +
    "    <div class=\"modal-header\" data-role=\"header\" data-position=\"fixed\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Title -->\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <bmp-modal-header>\n" +
    "                    <h3 data-qe-id=\"header-title\" data-ng-translate=\"labelKey\"></h3>\n" +
    "                </bmp-modal-header>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Body -->\n" +
    "    <div class=\"modal-body\" data-role=\"main\">\n" +
    "        <bmp-modal-content></bmp-modal-content>\n" +
    "        <!-- Buttons -->\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <!-- <button type=\"button\" id=\"detailForm.customsave\" class=\"btn btn-primary\"\n" +
    "                    data-qe-id=\"header-custom-save-button\"\n" +
    "                    data-ng-if=\"vm.definition.customSave\"\n" +
    "                    data-ng-click=\"vm.definition.customSave(vm.detail, vm.data)\"\n" +
    "                    data-translate=\"{{::vm.definition.customSaveText}}\"></button> -->\n" +
    "            <button type=\"button\" id=\"detailForm.save\" class=\"btn btn-primary\"\n" +
    "                    data-qe-id=\"header-save-button\"\n" +
    "                    data-ng-if=\"save\"\n" +
    "                    data-ng-click=\"save()\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.Actions.SaveAndClose\"></button>\n" +
    "            <button type=\"button\" id=\"detailForm.cancel\"\n" +
    "                    data-qe-id=\"header-cancel-button\"\n" +
    "                    class=\"btn btn-default\"\n" +
    "                    data-ng-if=\"cancel\"\n" +
    "                    data-ng-click=\"cancel()\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "            <button type=\"button\" id=\"detailForm.cancel\"\n" +
    "                    data-qe-id=\"header-cancel-button\"\n" +
    "                    class=\"btn btn-default\"\n" +
    "                    data-ng-if=\"close\"\n" +
    "                    data-ng-click=\"close()\"\n" +
    "                    data-translate=\"Bluemoon.Practice.Common.Actions.Close\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-multi-select-control/bmp-multi-select-control.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-multi-select-control/bmp-multi-select-control.html",
    "<div bento-multiselect-overlay\n" +
    "    list-data=\"listData\"\n" +
    "    ng-model=\"ngModel\"\n" +
    "    revert-selections-on-dismissal=\"revertSelectionsOnDismissal\"\n" +
    "    class=\"setup-bento-multiselect-overlay\"\n" +
    "    bento-append-to-parent=\"bentoAppendToParent\"\n" +
    "    select-button-text=\"{{selectButtonText}}\"\n" +
    "    edit-button-text=\"{{editButtonText}}\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-multi-select-tag-box/bmp-multi-select-tag-box.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-multi-select-tag-box/bmp-multi-select-tag-box.html",
    "<div bento-tags-input class=\"bmp-multi-select-tag-box\"\n" +
    "           name=\"{{::vm.name}}\"\n" +
    "           data-qe-id=\"{{::vm.name}}\"\n" +
    "           ng-disabled=\"false\"\n" +
    "           ng-model=\"vm.model\"\n" +
    "           editable=\"false\"\n" +
    "           use-operators=\"false\"\n" +
    "           disable-key-input=\"true\"\n" +
    "           tag-property-name=\"{{::vm.tagPropertyName || 'name' }}\"\n" +
    "           ng-if=\"vm.isDataValid()\">\n" +
    "</div>");
}]);

angular.module("bmp/bmp-page-header/bmp-page-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-page-header/bmp-page-header.html",
    "<div ng-if=\"pageHeader.isFixed\" class=\"bmp-page-header-spacer\">\n" +
    "</div>\n" +
    "<div class=\"row\" ng-class=\"pageHeader.headerClass()\">\n" +
    "    <div class=\"form-group col-md-8 col-sm-8 col-xs-12 bmp-page-header-truncate\">\n" +
    "        <div class=\"bmp-page-header-left-content\" ng-transclude=\"leftContent\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group col-md-4 col-sm-4 col-xs-12 bmp-page-header-right-content-container\">\n" +
    "        <bm-help-dropdown\n" +
    "            ng-if=\"pageHeader.isInModal && pageHeader.showHelp\"\n" +
    "            location=\"/staff/#{{pageHeader.location}}\"\n" +
    "            use-menu-left=\"pageHeader.useHelpDropdownLeft\">\n" +
    "        </bm-help-dropdown>\n" +
    "        <div class=\"bmp-page-header-right-content\" ng-transclude=\"rightContent\"></div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-page-header/bmp-sub-page-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-page-header/bmp-sub-page-header.html",
    "<div class=\"bmp-sub-page-header-container\">\n" +
    "    <div class=\"row bmp-sub-page-header affix-top\" data-bmp-bootstrap-affix=\"{{affix}}\" data-bmp-sub-page-header-selector>\n" +
    "        <div class=\"form-group col-md-6 col-sm-6 col-xs-12 bmp-page-header-truncate\">\n" +
    "            <div class=\"bmp-sub-page-header-left-content\" ng-transclude=\"leftContent\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group col-md-6 col-sm-6 col-xs-12 bmp-page-header-right-content-container\">\n" +
    "            <div class=\"bmp-page-header-right-content\" ng-transclude=\"rightContent\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-posted-and-approved-filters/bmp-posted-and-approved-filters.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-posted-and-approved-filters/bmp-posted-and-approved-filters.html",
    "<div class=\"bmp-posted-and-approved\">\n" +
    "    <div class=\"btn-group title-case bmp-btn-group-active\">\n" +
    "        <button type=\"button\"\n" +
    "                class=\"btn btn-default btn-toggle\"\n" +
    "                ng-model=\"ctrl.$approvedValue\"\n" +
    "                data-qe-id=\"{{ctrl.approved.qeId}}\"\n" +
    "                uib-btn-checkbox>\n" +
    "            {{ ctrl.approved.label | translate }}\n" +
    "        </button>\n" +
    "        <button type=\"button\"\n" +
    "                class=\"btn btn-default btn-toggle\"\n" +
    "                ng-model=\"ctrl.$postedValue\"\n" +
    "                data-qe-id=\"{{ctrl.posted.qeId}}\"\n" +
    "                uib-btn-checkbox>\n" +
    "            {{ ctrl.posted.label | translate }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-radio-button-group/bmp-radio-button-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-radio-button-group/bmp-radio-button-group.html",
    "<div class=\"btn-group\" role=\"radiogroup\" aria-label=\"{{::name}}-label\">\n" +
    "    <span role=\"radio\"\n" +
    "            class=\"btn btn-default btn-toggle\"\n" +
    "            ng-keydown=\"handleKeyPressed($event)\"\n" +
    "            tabindex=\"{{getTabIndex($index)}}\"\n" +
    "            ng-class=\"{'active': internalValue.id===option.id}\"\n" +
    "            ng-click=\"selectOption(option)\"\n" +
    "            ng-disabled=\"ngDisabled\"\n" +
    "            data-qe-id=\"{{::name}}-{{::option.id}}-toggle\"\n" +
    "            ng-repeat=\"option in options() track by option.id\"\n" +
    "            aria-checked=\"{{internalValue.id===option.id}}\"\n" +
    "            aria-labelledby=\"{{::name}}-label-{{option.id}}\">\n" +
    "        <label id=\"{{::name}}-label-{{option.id}}\">{{option.name}}</label>\n" +
    "</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-radio-circle-button-group/bmp-radio-circle-button-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-radio-circle-button-group/bmp-radio-circle-button-group.html",
    "<div data-toggle=\"buttons-checkbox\">\n" +
    "    <div ng-repeat=\"option in options()\">\n" +
    "        <input autocomplete=\"off\" type=\"radio\"\n" +
    "               name=\"{{name}}\"\n" +
    "               id=\"{{name}}{{option.id}}\"\n" +
    "               data-fef-tab-stop=\"tabStop()\"\n" +
    "               data-ng-value=\"option.id\"\n" +
    "               data-ng-model=\"ngModel.id\"\n" +
    "               data-ng-change=\"ngChange(ngModel.id)\">\n" +
    "        {{option.name}}\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-routable-sidenav/bmp-routable-sidenav.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-routable-sidenav/bmp-routable-sidenav.html",
    "<div class=\"bmp-routable-sidenav-container\" ng-style=\"$ctrl.tabContentDimensions\">\n" +
    "    <div\n" +
    "        ng-if=\"$ctrl.items || $ctrl._items\"\n" +
    "        bento-tree\n" +
    "        nav-mode=\"true\"\n" +
    "        class=\"sidenav\"\n" +
    "        multi-select=\"false\"\n" +
    "        tree-model=\"$ctrl.items || $ctrl._items\"\n" +
    "        node-children=\"items\"\n" +
    "        select-model=\"selected\"\n" +
    "        selectable-model=\"selectable\"\n" +
    "        tree-label=\"label\"\n" +
    "        tree-collapsed=\"false\"\n" +
    "        select-callback=\"$ctrl.itemSelect\"\n" +
    "        collapsing-callback=\"$ctrl.itemCollapse\"\n" +
    "        expanding-callback=\"$ctrl.itemExpand\"\n" +
    "    ></div>\n" +
    "\n" +
    "    <div class=\"bmp-routable-content\">\n" +
    "        <ng-transclude></ng-transclude>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-routable-tabset/bmp-routable-tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-routable-tabset/bmp-routable-tabset.html",
    "<bmp-routable-sidenav\n" +
    "    ng-if=\"!!bmpRoutableTabset.useSidenav\"\n" +
    "    bmp-routable-tabset-tabs=\"bmpRoutableTabset.tabs\"\n" +
    "    bmp-modal-state-data=\"bmpRoutableTabset.bmpModalStateData\">\n" +
    "    <ng-transclude></ng-transclude>\n" +
    "</bmp-routable-sidenav>\n" +
    "\n" +
    "<div ng-if=\"!bmpRoutableTabset.useSidenav\" bmp-responsive-tabset=\"tabs-left\" class=\"bento-tabset tabs-left bmp-routable-tabset\">\n" +
    "    <ul class=\"nav nav-tabs\" id=\"bm-responsive-tabset\" role=\"tablist\" aria-labelledby=\"menubutton\">\n" +
    "        <li id=\"tab-{{::tab.label}}\" ng-repeat=\"tab in bmpRoutableTabset.tabs()\" data-qe-id=\"tab-{{::tab.id}}\"\n" +
    "            ng-class=\"{active: bmpRoutableTabset.isTabActive(tab), disabled: tab.disabled}\" ng-init=\"tab.ariaSelected = $first\">\n" +
    "            <a href role=\"tab\" ng-keydown=\"bmpRoutableTabset.handleTabKeyNavigation($event)\" ng-click=\"bmpRoutableTabset.clickTab(tab)\" aria-selected=\"{{tab.ariaSelected}}\" tabindex=\"{{tab.ariaSelected ? '0' : '-1'}}\">{{tab.label}}</a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "    <div class=\"tab-content bmp-routable-container\" ng-style=\"bmpRoutableTabset.tabContentDimensions\" data-bmp-routable-container-selector>\n" +
    "        <ng-transclude></ng-transclude>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-select-control/bmp-filtered-select-combo.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-select-control/bmp-filtered-select-combo.html",
    "<div ng-if=\"vm.filterListType && vm.selectionListType\">\n" +
    "    <!-- FILTER BOX -->\n" +
    "    <bmp-enum-combo ng-if=\"vm.filterDataType === 'SINGLESELECTENUM'\"\n" +
    "            enum=\"{{vm.filterListType}}\"\n" +
    "            name=\"{{::vm.name + '-filter-list'}}\"\n" +
    "            ng-model=\"vm.$filterListValue\"\n" +
    "            required=\"true\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-enum-combo>\n" +
    "\n" +
    "    <!-- SELECTION BOX -->\n" +
    "    <bmp-select-combo ng-if=\"vm.selectionDataType === 'FILTEREDSINGLESELECTLIST_NAMEONLY'\"\n" +
    "            list=\"{{vm.selectionListType}}\"\n" +
    "            name=\"{{::vm.name + '-selection-list'}}\"\n" +
    "            ng-model=\"vm.model\"\n" +
    "            required=\"true\"\n" +
    "            filter=\"vm.filter()\"\n" +
    "            only-one-column=\"true\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-select-combo>\n" +
    "    <bmp-select-combo-multi-select ng-if=\"vm.selectionDataType === 'FILTEREDMULTISELECTLIST_NAMEONLY'\"\n" +
    "            list=\"{{vm.selectionListType}}\"\n" +
    "            name=\"{{::vm.name + '-multi-selection-list'}}\"\n" +
    "            model=\"vm.model\"\n" +
    "            required=\"true\"\n" +
    "            filter=\"vm.filter()\"\n" +
    "            only-one-column=\"true\"\n" +
    "            append-to-parent=\".modal-content\">\n" +
    "    </bmp-select-combo-multi-select>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-select-control/bmp-select-combo-multi-select.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-select-control/bmp-select-combo-multi-select.html",
    "<div class=\"bmp-multi-select-main\">\n" +
    "    <bmp-select-combo\n" +
    "        name=\"{{::name + '-select-combo'}}\"\n" +
    "        class=\"bmp-multi-select-combo\"\n" +
    "        list=\"{{listType}}\"\n" +
    "        filter=\"filter()\"\n" +
    "        ng-model=\"inputModel\"\n" +
    "        ng-disabled=\"isLoading\"\n" +
    "        data-select-combo>\n" +
    "    </bmp-select-combo>\n" +
    "    <bmp-multi-select-tag-box\n" +
    "        name=\"{{::name + '-tag-box'}}\"\n" +
    "        model=\"model\"\n" +
    "        input-model=\"inputModel\">\n" +
    "    </bmp-multi-select-tag-box>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-select-control/bmp-select-combo.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-select-control/bmp-select-combo.html",
    "<div bento-combobox=\"\" name=\"{{::name}}\" id=\"{{::name}}\"\n" +
    "     ng-model=\"ngModel\"\n" +
    "     ng-disabled=\"ngDisabled\"\n" +
    "     ng-readonly=\"ngReadonly\"\n" +
    "     ng-required=\"ngRequired\"\n" +
    "     revert-on-invalid-input=\"ngRequired\"\n" +
    "     searchable=\"true\"\n" +
    "     use-server=\"true\"\n" +
    "     get-data=\"ctrl.getAvailableItemsForCombo(search, page)\"\n" +
    "     on-change=\"_onChange(item)\"\n" +
    "     placeholder=\"{{placeholder}}\"\n" +
    "     data-qe-id=\"{{::name}}-combo\"\n" +
    "     controller=\"control\"\n" +
    "     footer-options=\"ctrl.footerOptions\"\n" +
    "     defer-load=\"deferLoad\"\n" +
    "     bento-flex-grid-control\n" +
    "     role=\"combobox\"\n" +
    "     aria-labelledby=\"{{name}}-label\"\n" +
    "     container-visibility-changed=\"ctrl.onContainerVisibilityChanged(visibility)\"\n" +
    "     custom-display-type=\"{{customDisplayType}}\"\n" +
    "     bmp-combobox-scroll-into-view>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-select-control/bmp-select-dropdown.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-select-control/bmp-select-dropdown.html",
    "<span data-bento-select>\n" +
    "    <select class=\"form-control\" name=\"{{::name}}\" id=\"{{::name}}\"\n" +
    "            data-ng-model=\"ngModel\"\n" +
    "            data-ng-disabled=\"ngDisabled\"\n" +
    "            data-ng-required=\"{{::required}}\"\n" +
    "            data-ng-options=\"option as option.name for option in ctrl.availableItems track by option.id\">\n" +
    "        <option value=\"\" ng-hide=\"required\"></option>\n" +
    "    </select>\n" +
    "</span>\n" +
    "");
}]);

angular.module("bmp/bmp-select-control/bmp-select-typeahead.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-select-control/bmp-select-typeahead.html",
    "<input autocomplete=\"off\" type=\"text\" name=\"{{::name}}\" id=\"{{::name}}\" class=\"form-control\"\n" +
    "       ng-model=\"ctrl.resolvedItem\"\n" +
    "       ng-blur=\"ctrl.onBlur()\"\n" +
    "       ng-disabled=\"ngDisabled\"\n" +
    "       ng-readonly=\"ngReadonly\"\n" +
    "       ng-required=\"{{::required}}\"\n" +
    "       uib-typeahead=\"item as item.name for item in ctrl.getAvailableItems($viewValue)\"\n" +
    "       typeahead-on-select=\"ctrl.onSelect($item)\"\n" +
    "       typeahead-editable=\"true\"\n" +
    "       autocomplete=\"off\" />\n" +
    "");
}]);

angular.module("bmp/bmp-slideout-filter-panel/bmp-grid-slideout-filter.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-slideout-filter-panel/bmp-grid-slideout-filter.html",
    "<div uib-accordion-group class=\"panel-default\" is-open=\"vm.isOpen\" data-qe-id=\"bmp-gridSlideout-accordion__{{vm.ctrl.title}}\">\n" +
    "    <uib-accordion-heading>\n" +
    "        <span class=\"heading-row\">\n" +
    "            <div>\n" +
    "                <span>{{ vm.ctrl.title }}</span>\n" +
    "                <span ng-if=\"!vm.filterIsEmpty()\" style=\"margin-left: 7px\" class=\"badge\">{{vm.filterCount()}}</span>\n" +
    "                <span ng-if=\"vm.exclude\"\n" +
    "                    class=\"label label-danger\"\n" +
    "                    uib-tooltip=\"{{'Bluemoon.Practice.Common.Filters.ExcludeInfo' | translate}}\"\n" +
    "                    tooltip-append-to-body=\"true\"><i class=\"bento-icon-hide\"></i></span>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "                <button type=\"button\"\n" +
    "                        class=\"btn btn-xs btn-default clear-button float-right\"\n" +
    "                        ng-if=\"!vm.filterIsEmpty() || vm.exclude\"\n" +
    "                        ng-click=\"vm.clearClicked($event)\"><i class=\"bento-icon-remove\"></i> {{ 'Bluemoon.Practice.Common.Actions.Clear' | translate }}</button>\n" +
    "            </div>\n" +
    "        </span>\n" +
    "    </uib-accordion-heading>\n" +
    "    <div bento-busy-loader=\"vm.ctrl.isLoading\">\n" +
    "        <div ng-repeat=\"$option in vm.displayOptions\">\n" +
    "            <div class=\"checkbox-row\">\n" +
    "                <input type=\"checkbox\"\n" +
    "                        class=\"bento-checkbox\"\n" +
    "                        id=\"{{ vm.ctrl.title + $index }}\"\n" +
    "                        ng-model=\"vm.checkboxModels[$index]\"\n" +
    "                        ng-model-options=\"{ getterSetter: true }\">\n" +
    "                <label for=\"myCheckbox\" ng-if=\"vm.labelTemplateUrl\"><ng-include src=\"vm.labelTemplateUrl\"/></label>\n" +
    "                <label for=\"myCheckbox\" ng-if=\"!vm.labelTemplateUrl\">{{ $option.name }}</label>\n" +
    "                <span class=\"bento-icon-hide exclude-icon float-right\"\n" +
    "                    ng-click=\"vm.excludeClicked($index)\"\n" +
    "                    uib-tooltip=\"{{'Bluemoon.Practice.Common.Actions.Exclude' | translate}}\"\n" +
    "                    tooltip-append-to-body=\"true\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"vm.displayCustomOptionTemplate()\" class=\"checkbox-row\"><ng-include src=\"vm.customOptionTemplateUrl\"/></div>\n" +
    "\n" +
    "        <span><a ng-if=\"vm.displayShowMoreToggle()\" ng-click=\"vm.toggleShowMore(true)\">{{ 'Bluemoon.Practice.Common.Actions.More' | translate}}</a></span>\n" +
    "        <span><a ng-if=\"vm.displayShowLessToggle()\" ng-click=\"vm.toggleShowMore(false)\">{{ 'Bluemoon.Practice.Common.Actions.Less' | translate}}</a></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-slideout-filter-panel/bmp-slideout-filter-panel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-slideout-filter-panel/bmp-slideout-filter-panel.html",
    "<div id=\"bmp-grid-with-optional-filter-container\">\n" +
    "    <div ng-if=\"!vm.bmpSlideoutFilterPanelHide\"\n" +
    "        bento-splitter-group\n" +
    "        left-width=\"{{vm.initialPanelWidth}}\"\n" +
    "        left-max-width=\"400px\"\n" +
    "        resizable=\"true\"\n" +
    "        is-left-collapsed=\"vm.isPanelCollapsed\"\n" +
    "        event-tracking=\"vm.trackEvent(eventName)\"\n" +
    "        id=\"bmp-slideout-filter-panel\"\n" +
    "        class=\"bmp-grid-slideout-filter-splitter-group\">\n" +
    "        <aside bento-splitter-group-left id=\"splitter-left-panel\">\n" +
    "            <div class=\"bmp-grid-slideout-filter-header\">\n" +
    "                <h3>{{ 'Bluemoon.Practice.Common.Grid.Filters' | translate }}</h3>\n" +
    "                <div class=\"bento-expand-collapse-button-group\">\n" +
    "                    <button class=\"btn btn-default btn-xs btn-icon\"\n" +
    "                            data-qe-id=\"bmp-slideoutFilterPanel-plus-button\"\n" +
    "                            ng-click=\"vm.expandAllFilters()\">\n" +
    "                        <i class=\"bento-expand-icon bento-icon-plus-plain\"></i>\n" +
    "                    </button>\n" +
    "                    <div class=\"bento-expand-divider\"></div>\n" +
    "                    <button class=\"btn btn-default btn-xs btn-icon\"\n" +
    "                            data-qe-id=\"bmp-slideoutFilterPanel-minus-button\"\n" +
    "                            ng-click=\"vm.collapseAllFilters()\">\n" +
    "                        <i class=\"bento-collapse-icon bento-icon-minus-plain\"></i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <button type=\"button\"\n" +
    "                        class=\"btn btn-xs btn-default float-right bmp-grid-slideout-filter-clear-all-button\"\n" +
    "                        ng-if=\"!vm.filterIsEmpty(vm.gridData.definition.userFilter)\"\n" +
    "                        data-qe-id=\"bmp-slideoutFilterPanel-clearAll-button\"\n" +
    "                        ng-click=\"vm.clearClicked()\"><i class=\"bento-icon-remove\"></i> {{ 'Bluemoon.Practice.Common.Actions.ClearAll' | translate}}</button>\n" +
    "            </div>\n" +
    "            <uib-accordion\n" +
    "                close-others=\"false\"\n" +
    "                class=\"bento-accordion bento-accordion-alternate\">\n" +
    "                <div ng-repeat=\"ctrl in vm.slideoutFilterControls\">\n" +
    "                    <bmp-grid-slideout-enum-filter ng-if=\"::ctrl.dataType === 'SINGLESELECTENUM'\" ctrl=\"ctrl\"></bmp-grid-slideout-enum-filter>\n" +
    "                    <bmp-grid-slideout-select-filter ng-if=\"::ctrl.dataType === 'SINGLESELECTLIST' || ctrl.dataType === 'SINGLESELECTLIST_NAMEONLY'\" ctrl=\"ctrl\"></bmp-grid-slideout-select-filter>\n" +
    "                    <bmp-grid-slideout-date-filter ng-if=\"::ctrl.dataType === 'DATE'\" ctrl=\"ctrl\"></bmp-grid-slideout-date-filter>\n" +
    "                </div>\n" +
    "                <div uib-accordion-group\n" +
    "                    class=\"panel-default\"\n" +
    "                    is-open=\"vm.advancedSlideoutFilterOpen\"\n" +
    "                    data-qe-id=\"bmp-gridWithPanel-advancedFilters-accordion\">\n" +
    "                    <uib-accordion-heading>\n" +
    "                        {{ 'Bluemoon.Practice.Common.Grid.Filters.AdvancedFilters' | translate }}<span ng-if=\"vm.advancedSlideoutFilterCount > 0\" class=\"badge bmp-grid-slideout-filter-count-badge\">{{vm.advancedSlideoutFilterCount}}</span>\n" +
    "                    </uib-accordion-heading>\n" +
    "                    <div bento-busy-loader=\"vm.loading\">\n" +
    "                        <input type=\"checkbox\"\n" +
    "                                class=\"bento-checkbox\"\n" +
    "                                id=\"{{ vm.title + 'advanced-filter' }}\"\n" +
    "                                ng-model=\"vm.useAdvancedSlideoutFilter\">\n" +
    "                        <label for=\"{{ vm.title + 'advanced-filter' }}\">{{ 'Bluemoon.Practice.Common.Grid.Filters.CustomFilter' | translate }}<a class=\"bmp-grid-slideout-filter-advanced-edit\" ng-click=\"vm.openFilterDialog()\"><span class=\"bento-icon-edit\"></span></a></label>\n" +
    "                    </div>\n" +
    "                    <span ng-if=\"!(vm.advancedSlideoutFilter.conditions.length > 0 || vm.advancedSlideoutFilter.nestedFilters.length > 0)\" translate=\"Bluemoon.Practice.Common.GridFilterPanel.NoFilter\"></span>\n" +
    "                    <div ng-if=\"vm.advancedSlideoutFilter.conditions.length > 0 || vm.advancedSlideoutFilter.nestedFilters.length > 0\" ng-repeat=\"row in vm.filterReadableRows track by $index\" class=\"bmp-grid-slideout-filter-advanced-readable-rows\">\n" +
    "                        <div class=\"filter-tag-container\" ng-repeat=\"item in row.items track by $index\">\n" +
    "                            <div class=\"filter-groupmarker\" ng-if=\"item.item.charAt(0) !== '%'\">\n" +
    "                                <span>{{item.item}}</span>\n" +
    "                                <a class=\"filter-remove\" ng-click=\"vm.removeFilterCondition(item.condition)\">\n" +
    "                                    <span class=\"bento-icon-close-circle\"></span>\n" +
    "                                </a>\n" +
    "                            </div>\n" +
    "                            <span ng-if=\"item.item.charAt(0) === '%'\">{{item.item.replace('%','')}}</span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </uib-accordion>\n" +
    "        </aside>\n" +
    "        <section bento-splitter-group-main>\n" +
    "            <ng-transclude></ng-transclude>\n" +
    "        </section>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.bmpSlideoutFilterPanelHide\">\n" +
    "        <ng-transclude></ng-transclude>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("bmp/bmp-slideout-filter-panel/date/bmp-grid-date-filter-date-range-option.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-slideout-filter-panel/date/bmp-grid-date-filter-date-range-option.html",
    "<input type=\"checkbox\"\n" +
    "        class=\"bento-checkbox\"\n" +
    "        id=\"{{ vm.ctrl.title + 'custom-option' }}\"\n" +
    "        ng-model=\"vm.useDateRangeFilter\">\n" +
    "<label for=\"myCheckbox\">{{ 'Bluemoon.Practice.Common.Grid.Filters.CustomDate' | translate }}</label>\n" +
    "<span class=\"bento-icon-hide exclude-icon float-right\"\n" +
    "    ng-click=\"vm.excludeCustomClicked()\"\n" +
    "    uib-tooltip=\"{{ 'Bluemoon.Practice.Common.Actions.Exclude' | translate}}\"\n" +
    "    tooltip-append-to-body=\"true\"></span>\n" +
    "<br>\n" +
    "<div class=\"bmp-grid-slideout-filter-date-range-container\">\n" +
    "    <div class=\"bmp-grid-slideout-filter-date-range-labels\">\n" +
    "        <!-- <span>From</span> -->\n" +
    "        <span>{{'Bluemoon.Practice.Common.DateRangeSelector.ToLabel' | translate }}</span>\n" +
    "    </div>\n" +
    "    <div class=\"bmp-grid-slideout-filter-date-range-inputs\">\n" +
    "        <bmp-bento-datepicker-wrapper ng-model=\"vm.startDate\"\n" +
    "            name=\"{{vm.ctrl.title + 'startDateSlideoutFilterDatepicker'}}\"\n" +
    "            bmp-bento-datepicker-wrapper-on-open-focus=\"false\"\n" +
    "            bmp-bento-datepicker-wrapper-append-to-body=\"true\"\n" +
    "            bmp-bento-datepicker-wrapper-select-on-focus=\"true\"\n" +
    "            bmp-bento-datepicker-wrapper-update-on=\"'blur'\">\n" +
    "        </bmp-bento-datepicker-wrapper>\n" +
    "        <div class=\"bmp-grid-slideout-filter-date-range-start-container\">\n" +
    "            <bmp-bento-datepicker-wrapper ng-model=\"vm.endDate\"\n" +
    "                name=\"{{vm.ctrl.title + 'endDateSlideoutFilterDatepicker'}}\"\n" +
    "                bmp-bento-datepicker-wrapper-on-open-focus=\"false\"\n" +
    "                bmp-bento-datepicker-wrapper-append-to-body=\"true\"\n" +
    "                bmp-bento-datepicker-wrapper-select-on-focus=\"true\"\n" +
    "                bmp-bento-datepicker-wrapper-update-on=\"'blur'\">\n" +
    "            </bmp-bento-datepicker-wrapper>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-slideout-filter-panel/enum/bmp-grid-slideout-enum-filter.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-slideout-filter-panel/enum/bmp-grid-slideout-enum-filter.html",
    "<span><a ng-if=\"vm.displayShowMoreToggle()\" ng-click=\"vm.toggleShowMore(true)\">{{ 'Bluemoon.Practice.Common.Actions.More' | translate}}</a></span>\n" +
    "<span><a ng-if=\"vm.displayShowLessToggle()\" ng-click=\"vm.toggleShowMore(false)\">{{ 'Bluemoon.Practice.Common.Actions.Less' | translate}}</a></span>");
}]);

angular.module("bmp/bmp-slideout-filter-panel/select/bmp-grid-slideout-select-filter.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-slideout-filter-panel/select/bmp-grid-slideout-select-filter.html",
    "<input type=\"checkbox\"\n" +
    "        class=\"bento-checkbox\"\n" +
    "        id=\"other-checkbox\"\n" +
    "        ng-model=\"vm.otherCheckboxModel\"\n" +
    "        ng-model-options=\"{ getterSetter: true }\">\n" +
    "<label for=\"myCheckbox\">\n" +
    "    <bmp-modal bmp-modal-label-key=\"vm.ctrl.title\" bmp-modal-save=\"vm.modalSaveClicked()\" bmp-modal-cancel=\"vm.modalCancelClicked()\">\n" +
    "        <bmp-modal-button>\n" +
    "            <span>{{ 'Bluemoon.Practice.Common.Grid.Filters.Other' | translate }} <a type=\"button\"><span class=\"bento-icon-edit\"></span></a></span>\n" +
    "        </bmp-modal-button>\n" +
    "        <bmp-modal-content class=\"bmp-slideout-filter-panel-select-modal-content\">\n" +
    "            <div style=\"max-height:50vh\">\n" +
    "                <bmp-grid bmp-grid-definition=\"vm.gridDefiniton\" bmp-grid-service=\"vm.listService\"></bmp-grid>\n" +
    "            </div>\n" +
    "            <h4>Selected</h4>\n" +
    "            <div class=\"well well-sm\" >\n" +
    "                <div bento-tags-input\n" +
    "                    ng-if=\"vm.filterItemsModal.length !== 0\"\n" +
    "                    class=\"bmp-multi-select-tag-box\"\n" +
    "                    name=\"{{::vm.ctrl.title + '-filter-panel-tabs-input'}}\"\n" +
    "                    data-qe-id=\"{{::vm.ctrl.title + '-filter-panel-tabs-input'}}\"\n" +
    "                    ng-model=\"vm.filterItemsModal\"\n" +
    "                    editable=\"false\"\n" +
    "                    use-operators=\"false\"\n" +
    "                    disable-key-input=\"true\"\n" +
    "                    tag-property-name=\"name\">\n" +
    "                </div>\n" +
    "                <span ng-if=\"vm.filterItemsModal.length === 0\">{{ 'Bluemoon.Practice.Common.GridFilterPanel.NoFilter' | translate }}</span>\n" +
    "            </div>\n" +
    "        </bmp-modal-content>\n" +
    "    </bmp-modal>\n" +
    "</label>\n" +
    "<span class=\"bento-icon-hide exclude-icon float-right\"\n" +
    "    ng-click=\"vm.excludeCustomClicked($index)\"\n" +
    "    uib-tooltip=\"{{ 'Bluemoon.Practice.Common.Actions.Exclude' | translate}}\"\n" +
    "    tooltip-append-to-body=\"true\"></span>\n" +
    "<div bento-tags-input class=\"bmp-multi-select-tag-box\"\n" +
    "    name=\"{{::vm.option.name + '-filter-panel-tabs-input'}}\"\n" +
    "    data-qe-id=\"{{::vm.option.name + '-filter-panel-tabs-input'}}\"\n" +
    "    ng-show=\"vm.filterItemsSaved.length > 0\"\n" +
    "    ng-model=\"vm.filterItemsSaved\"\n" +
    "    on-tag-removed=\"vm.recalculateFilter()\"\n" +
    "    editable=\"false\"\n" +
    "    use-operators=\"false\"\n" +
    "    disable-key-input=\"true\"\n" +
    "    tag-property-name=\"name\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-table/bmp-table.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-table/bmp-table.html",
    "<div>\n" +
    "    <!-- header row -->\n" +
    "    <div class=\"row\">\n" +
    "        <div ng-repeat=\"column in vm.columnDefinitions\">\n" +
    "            <div ng-class=\"vm.getCssClassHeaderRow($index, column)\">\n" +
    "                <span ng-class=\"vm.getCssClassHeaderSpan($index, column)\">\n" +
    "                    {{column.headerText.length === 0 ? '.' : column.headerText}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- data rows -->\n" +
    "    <div class=\"row\" ng-repeat=\"row in vm.data\">\n" +
    "\n" +
    "        <!-- for each column... ng-disabled=\"column.readonly\"-->\n" +
    "        <div ng-repeat=\"column in vm.columnDefinitions\">\n" +
    "            <div ng-class=\"vm.getCssClassDataRow($parent.$index, $index, column)\"\n" +
    "                ng-click=\"vm.onRowClicked({rowIndex:$parent.$index, columnIndex:$index, columnDefinition:column})\"\n" +
    "                class=\"bmp-table-row\">\n" +
    "\n" +
    "              <input ng-if=\"column.type === 'checkbox'\"\n" +
    "                    type=\"checkbox\"\n" +
    "                    ng-model=\"row[column.id]\">\n" +
    "\n" +
    "                <span ng-if=\"column.type === 'text'\"\n" +
    "                    ng-style=\"vm.getStyleDataRow(column)\">\n" +
    "                    {{vm.getCellText(column, $parent.$parent.$index)}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-tabset/bmp-tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-tabset/bmp-tabset.html",
    "<div class=\"bento-tabset\" ng-class=\"{ 'tabs-top': !tabCtrl.vertical, 'tabs-left': tabCtrl.vertical }\">\n" +
    "    <data-tabs ng-transclude=\"\"></data-tabs>\n" +
    "    <ul class=\"nav nav-tabs\">\n" +
    "        <li ng-repeat=\"tab in tabCtrl.tabs\"\n" +
    "            ng-class=\"{active: tabCtrl.selectedTabId===tab.id, disabled: tab.disabled()}\"\n" +
    "            data-qe-id=\"tab-{{::tab.id}}\"\n" +
    "            id=\"tab-{{::tab.id}}\">\n" +
    "            <a href=\"\" ng-click=\"tabCtrl.selectTab(tab.id)\" translate=\"{{tab.title}}\" data-qe-id=\"tab-{{::tab.id}}-link\"></a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <div class=\"tab-content\">\n" +
    "        <div ng-repeat=\"tab in tabCtrl.tabs\"\n" +
    "             class=\"tab-pane\"\n" +
    "             ng-class=\"{active: tabCtrl.selectedTabId===tab.id}\"\n" +
    "             id=\"tab-{{::tab.id}}-content\"\n" +
    "             data-qe-id=\"tab-{{::tab.id}}-content\"\n" +
    "             bento-busy-loader=\"tab.busy\"\n" +
    "             ng-include=\"tab.src\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-toolbar/bmp-toolbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-toolbar/bmp-toolbar.html",
    "<div bento-toolbar class=\"navbar navbar-default bento-toolbar\" toolbar-data=\"ctrl.bentoToolbarButtons\" template-url=\"bmp/bmp-toolbar/bmp-toolbar-bento-template.html\">\n" +
    "    <ul class=\"nav navbar-right\" role=\"group\">\n" +
    "\n" +
    "        <li ng-if=\"definition.toolbarFilterCombo.label\" class=\"bmp-toolbar-filter-combo-label\">\n" +
    "            <div style=\"float:right;\">\n" +
    "                <b><span class=\"ng-scope\">{{definition.toolbarFilterCombo.label}}</span></b>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li ng-if=\"definition.toolbarFilterCombo\" class=\"bmp-toolbar-filter-combo\">\n" +
    "            <bmp-select-combo list=\"{{definition.toolbarFilterCombo.list}}\"\n" +
    "                                ng-model=\"definition.toolbarFilterCombo.value\"\n" +
    "                                required=\"true\"\n" +
    "                                append-to-parent=\"body\"\n" +
    "                                on-change=\"ctrl.onFilterComboChanged(item)\">\n" +
    "            </bmp-select-combo>\n" +
    "        </li>\n" +
    "\n" +
    "        <li>\n" +
    "            <button\n" +
    "                ng-if=\"definition.slideoutFilterItemDefinitions\"\n" +
    "                class=\"btn btn-default btn-icon btn-toggle\"\n" +
    "                ng-class=\"{active: slidePanelOpen}\"\n" +
    "                ng-click=\"ctrl.toggleSlideoutPanel()\"\n" +
    "                data-tooltip-placement=\"bottom\"\n" +
    "                data-uib-tooltip=\"{{slidePanelOpen ? 'Bluemoon.DMS.Toolbar.Filters.Disable':'Bluemoon.DMS.Toolbar.Filters.Enable' | translate}}\"\n" +
    "                data-tooltip-append-to-body=\"true\"\n" +
    "                data-qe-id=\"bmp-toolbar-slideout-filter-button\"\n" +
    "                aria-pressed=\"{{!!slidePanelOpen}}\">\n" +
    "                <i class=\"bento-icon-filter\"></i>\n" +
    "            </button>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- Toolbox Buttons  -->\n" +
    "        <li ng-if=\"definition.filterButton\">\n" +
    "            <!-- /* i18nextract */'Bluemoon.Practice.Common.GridToolButtons.HideFilterPanel' -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.Practice.Common.GridToolButtons.ShowFilterPanel' -->\n" +
    "            <button class=\"btn btn-default btn-icon btn-toggle btn-filter-toggle\"\n" +
    "                ng-class=\"{'active': filterPanel, 'bmp-toolbar-button-has-content': filterPanelHasContent}\"\n" +
    "                ng-click=\"ctrl.toggleFilterPanel()\"\n" +
    "                tooltip-placement=\"bottom\"\n" +
    "                tooltip-append-to-body=\"true\"\n" +
    "                uib-tooltip=\"{{ (filterPanel ? 'Bluemoon.Practice.Common.GridToolButtons.HideFilterPanel' : 'Bluemoon.Practice.Common.GridToolButtons.ShowFilterPanel') | translate}}\"\n" +
    "                data-qe-id=\"{{definition.gridName}}-filter-button\"\n" +
    "                aria-pressed=\"{{!!filterPanel}}\">\n" +
    "                    <i class=\"bento-icon-filter-az\"></i>\n" +
    "            </button>\n" +
    "        </li>\n" +
    "        <li ng-if=\"definition.groupButton\">\n" +
    "            <!-- /* i18nextract */'Bluemoon.Practice.Common.GridToolButtons.HideGroupPanel' -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.Practice.Common.GridToolButtons.ShowGroupPanel' -->\n" +
    "            <button\n" +
    "                class=\"btn btn-default btn-icon btn-toggle btn-filter-toggle\"\n" +
    "                ng-class=\"{'active': groupPanel, 'bmp-toolbar-button-has-content': groupPanelHasContent}\"\n" +
    "                ng-click=\"ctrl.toggleGroupPanel()\"\n" +
    "                role=\"button\"\n" +
    "                aria-pressed=\"{{!!groupPanel}}\"\n" +
    "                tooltip-placement=\"bottom\"\n" +
    "                tooltip-append-to-body=\"true\"\n" +
    "                uib-tooltip=\"{{ (groupPanel ? 'Bluemoon.Practice.Common.GridToolButtons.HideGroupPanel' : 'Bluemoon.Practice.Common.GridToolButtons.ShowGroupPanel') | translate}}\"\n" +
    "                data-qe-id=\"{{definition.gridName}}-group-button\">\n" +
    "                    <i class=\"bento-icon-tree\"></i>\n" +
    "            </button>\n" +
    "        </li>\n" +
    "        <li class=\"dropdown bento-dropdown\"\n" +
    "        uib-dropdown\n" +
    "        on-toggle=\"ctrl.toggleDropdown(open)\"\n" +
    "        is-open=\"{{isDropdownOpen}}\"\n" +
    "        keyboard-nav\n" +
    "        ng-hide=\"hasColumnPicker === false\">\n" +
    "            <button role=\"button\"\n" +
    "                class=\"btn btn-default btn-icon dropdown-toggle btn-filter-toggle\"\n" +
    "                id=\"simple-btn-keyboard-nav\"\n" +
    "                uib-dropdown-toggle=\"\"\n" +
    "                tooltip-placement=\"bottom\"\n" +
    "                tooltip-append-to-body=\"true\"\n" +
    "                uib-tooltip=\"{{'Bluemoon.Practice.Common.GridToolButtons.ShowHideColumns' | translate}}\"\n" +
    "                data-qe-id=\"{{definition.gridName}}-columnselector-button\">\n" +
    "                    <i class=\"bento-icon-cog\"></i>\n" +
    "                    <i class=\"bento-icon-arrow-down2\"></i>\n" +
    "            </button>\n" +
    "            <ul class=\"dropdown-menu pull-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"simple-btn-keyboard-nav\" >\n" +
    "                <li ng-repeat=\"column in definition.columns | filter: { title: '!!', cellType: '!hierarchy' }\" class=\"small\" role=\"menuitem\">\n" +
    "                    <a ng-click=\"gridData.toggleColumnVisibility(column.dataProperty); $event.stopPropagation();\"\n" +
    "                        role=\"checkbox\"\n" +
    "                        tabindex=\"0\"\n" +
    "                        ng-keydown=\"ctrl.handleKeyboard($event, column.dataProperty)\"\n" +
    "                        aria-checked=\"{{gridData.columnVisibility(column.dataProperty)}}\"\n" +
    "                    >\n" +
    "                        <i ng-class=\"{false: 'bento-icon-checkbox', true: 'bento-icon-checkbox-filled', undefined: 'bento-icon-checkbox'}[gridData.columnVisibility(column.dataProperty)]\"></i>\n" +
    "                        <span translate=\"{{::column.title}}\"></span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- Search  -->\n" +
    "        <li ng-if=\"hasSearch !== false\" ng-form=\"\" data-qe-id=\"search-container\" role=\"search\" class=\"bmp-toolbar-search\" ng-class=\"{'hidden-xs': definition.toolbarFilterCombo}\">\n" +
    "                <label class=\"sr-only ng-binding\" for=\"toolbarSearch\" data-translate=\"Bluemoon.Practice.Common.Label.Search\"></label>\n" +
    "                <i class=\"bento-icon-search\"></i>\n" +
    "                <input autocomplete=\"off\" bento-reset=\"\"\n" +
    "                        class=\"form-control\"\n" +
    "                        type=\"text\"\n" +
    "                        placeholder=\"{{'Bluemoon.Practice.Common.Placeholder.Search' | translate}}\"\n" +
    "                        ng-model=\"ctrl.searchTerm\"\n" +
    "                        ng-model-options=\"{ debounce: 400 }\"\n" +
    "                        ng-keydown=\"ctrl.searchKeydown($event)\"\n" +
    "                        ng-disabled=\"searchDisabled()\"\n" +
    "                        ng-click=\"searchClicked()\"\n" +
    "                        bm-focus-on-event=\"searchFocusEventName\"\n" +
    "                        data-qe-id=\"{{definition.gridName}}-toolbar-search\"\n" +
    "                        aria-label=\"{{'Bluemoon.Practice.Common.Label.ToolbarSearch' | translate}}\"\n" +
    "                        ng-change=\"onSearch({$searchTerm: ctrl.searchTerm})\" />\n" +
    "        </li>\n" +
    "\n" +
    "    </ul>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("bmp/bmp-view-mode-tabset/bmp-view-mode-tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-view-mode-tabset/bmp-view-mode-tabset.html",
    "<div bmp-responsive-tabset=\"tabs-left\" class=\"view-mode-tabset bento-tabset tabs-left\">\n" +
    "    <ul class=\"nav nav-tabs\" id=\"bm-responsive-tabset\">\n" +
    "        <li ng-repeat=\"tab in viewModeTabset.tabs()\" ng-class=\"{active: tab.active(), disabled: viewModeTabset.getDisabled(tab)}\">\n" +
    "            <a data-qe-id=\"{{tab.qeId}}\" ng-click=\"viewModeTabset.clickTab(tab)\">{{tab.label}}</a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "    <div class=\"tab-content\" ng-style=\"viewModeTabset.tabContentWidth()\">\n" +
    "        <ng-transclude></ng-transclude>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-wait/bmp-wait.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wait/bmp-wait.html",
    "<div>\n" +
    "    <div class=\"modal-header\">{{'Bluemoon.Practice.Common.PleaseWait' | translate}}</div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-3 col-sm-3 col-xs-3\" style=\"min-height: 35px;\" bento-busy-loader=\"true\"></div>\n" +
    "            <div class=\"col-md-9 col-sm-9 col-xs-9\">{{waitDialog.waitText}}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-wijmo-table-hierarchy/bmp-wijmo-table-hierarchy.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table-hierarchy/bmp-wijmo-table-hierarchy.html",
    "<a class=\"btn-link\" ng-click=\"refreshHierarchy()\"><span class=\"bento-icon-expand\"></span></a>");
}]);

angular.module("bmp/bmp-wijmo-table/bmp-wijmo-table.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/bmp-wijmo-table.html",
    "<div class=\"bmp-wijmo-table-container bmp-grid-footer-for-multi-grid\" ng-mouseleave=\"vm.hoverRow = undefined; vm.hoverCol = undefined\">\n" +
    "    <bmp-grid-filter-panel data-ng-show=\"vm.bmpWijmoTableFilterPanelVisible\"\n" +
    "                           data-ng-if=\"vm.bmpWijmoTableFilterPanelOptions\"\n" +
    "                           data-filter=\"vm.bmpWijmoTableFilter\"\n" +
    "                           data-filter-changed=\"vm.bmpWijmoTableChangeFilter({$filter: $filter})\"\n" +
    "                           data-filter-options=\"vm.bmpWijmoTableFilterPanelOptions\"\n" +
    "                           data-filter-modal-header-text=\"vm.bmpWijmoTableFilterModalHeaderText\"\n" +
    "                           filter-focus-event=\"vm.editFilterFocusEventName\">\n" +
    "    </bmp-grid-filter-panel>\n" +
    "\n" +
    "    <!--TODO: Create function for mouseleave-->\n" +
    "    <div class=\"grouping-panel\" data-ng-show=\"vm.bmpWijmoTableGroupPanelVisible\">\n" +
    "        <span class=\"grouping-label\" translate=\"Bluemoon.Practice.Common.GroupSort.Label\"></span>\n" +
    "        <wj-group-panel grid=\"vm.ctx.flexGrid\"\n" +
    "                        placeholder=\"{{'Bluemoon.Practice.Common.Grid.GroupPanel.Placeholder' | translate}}\"\n" +
    "                        data-qe-id=\"{{vm.bmpWijmoTableName}}-group-panel-area\"\n" +
    "                        tabindex=\"-1\">\n" +
    "        </wj-group-panel>\n" +
    "    </div>\n" +
    "    <!--JOH - Work in progress for detail row scroll bar*/-->\n" +
    "    <!--ng-class=\"vm.shouldScrollbarShow() ? '' : 'bmp-wijmo-table-turn-off-vertical-scroll'\"-->\n" +
    "\n" +
    "    <div class=\"bmp-wijmo-table\" role=\"table\" aria-label=\"{{vm.bmpWijmoTableCaption | translate}}\">\n" +
    "     <wj-flex-grid id=\"{{vm.bmpWijmoTableName}}-masterGrid\"\n" +
    "                  ng-if=\"vm.bmpWijmoTableName\"\n" +
    "                  class=\"bento-flex-grid bmp-list-grid\"\n" +
    "                  ng-class=\"vm.getClass()\"\n" +
    "                  initialized=\"vm.initGrid(s,e)\"\n" +
    "                  control=\"vm.ctx.flexGrid\"\n" +
    "                  items-source=\"vm.dataCollectionView\"\n" +
    "                  selection-mode=\"{{vm.bmpWijmoTableEditable ? 'Cell' : 'CellRange'}}\"\n" +
    "                  headers-visibility=\"All\"\n" +
    "                  allow-dragging=\"Columns\"\n" +
    "                  is-read-only=\"true\"\n" +
    "                  items-source-changed=\"itemsSourceChanged(s,e)\"\n" +
    "                  scroll-position-changed=\"onScrollPositionChanged()\"\n" +
    "                  bmp-set-height=\"\"\n" +
    "                  bmp-set-height-pause=\"vm.datepickerContainerVisible || vm.comboboxContainerVisible\"\n" +
    "                  bmp-set-height-fill-vertical-height=\"vm.bmpWijmoTableFillVerticalHeight\"\n" +
    "                  bmp-set-height-fill-vertical-height-other-height=\"vm.bmpWijmoTableFillVerticalHeightOtherHeight\"\n" +
    "                  bmp-set-height-min-height=\"200\"\n" +
    "                  bmp-set-height-max-height=\"vm.bmpWijmoTableSetHeightMaxHeight\"\n" +
    "                  selection-changing=\"vm.selectionChanging(s,e)\"\n" +
    "                  beginning-edit=\"vm.cellEditBeginning(s,e)\"\n" +
    "                  row-added=\"vm.rowAdded(s,e)\"\n" +
    "                  row-edit-ending=\"vm.rowEditEnding(s,e)\"\n" +
    "                  cell-edit-ended=\"vm.cellEditEnding(s,e)\"\n" +
    "                  bmp-scroll-container=\"\"\n" +
    "                  selection-changed=\"vm.selectionChanged(s,e)\"\n" +
    "                  key-action-enter=\"None\"\n" +
    "                  key-action-tab=\"None\"\n" +
    "                  ng-keydown=\"vm.gridKeydown($event)\"\n" +
    "                  ng-keyup=\"vm.gridKeyup($event)\"\n" +
    "                  ng-keypress=\"vm.gridKeypress($event)\"\n" +
    "                  headers-focusability =\"All\">\n" +
    "        <!-- END: NEW BENTO SELECTOR -->\n" +
    "        <wj-flex-grid-column ng-if=\"vm.bmpWijmoTableActionsColumnVisible\"\n" +
    "            name=\"_actions\"\n" +
    "            header=\"{{ 'Bluemoon.Practice.Common.Actions' | translate}}\"\n" +
    "            binding=\"\"\n" +
    "            width=\"{{vm.bmpWijmoTableActionsColumnMoreActions ? '120' : '87'}}\"\n" +
    "            align=\"left\"\n" +
    "            allow-sorting=\"false\"\n" +
    "            allow-dragging=\"false\"\n" +
    "            allow-resizing=\"true\"\n" +
    "            is-read-only=\"true\">\n" +
    "        </wj-flex-grid-column>\n" +
    "        <wj-flex-grid-column ng-repeat=\"col in vm.columns1\"\n" +
    "                             width=\"{{col.width}}\"\n" +
    "                             min-width=\"{{col.minWidth}}\"\n" +
    "                             binding=\"{{col.fieldId}}\"\n" +
    "                             header=\"{{col.label ? (col.label | translate | bmRequiredMark:col.showRequiredMark) : ' '}}\"\n" +
    "                             data-type=\"{{col.dataType}}\"\n" +
    "                             format=\"{{col.format}}\"\n" +
    "                             is-read-only=\"{{col.isReadOnly}}\"\n" +
    "                             align=\"{{col.align}}\"\n" +
    "                             visible=\"{{col.visible()}}\"\n" +
    "                             aggregate=\"{{col.aggregate}}\"\n" +
    "                             allow-sorting=\"{{col.sortable}}\"\n" +
    "                             allow-dragging=\"{{col.allowDragging}}\">\n" +
    "                <!-- NO CELL TEMPLATES. ADD TEMPLATES TO COLUMN2 -->\n" +
    "        </wj-flex-grid-column>\n" +
    "        <wj-flex-grid-column ng-repeat=\"col in vm.columns2\"\n" +
    "                             width=\"{{col.width}}\"\n" +
    "                             min-width=\"{{col.minWidth}}\"\n" +
    "                             binding=\"{{col.fieldId}}\"\n" +
    "                             header=\"{{col.label ? (col.label | translate | bmRequiredMark:col.showRequiredMark) : ' '}}\"\n" +
    "                             data-type=\"{{col.dataType}}\"\n" +
    "                             format=\"{{col.format}}\"\n" +
    "                             is-read-only=\"{{!col.editControl}}\"\n" +
    "                             align=\"{{col.align}}\"\n" +
    "                             visible=\"{{col.visible()}}\"\n" +
    "                             aggregate=\"{{col.aggregate}}\"\n" +
    "                             allow-dragging=\"{{col.allowDragging}}\"\n" +
    "                             allow-sorting=\"{{col.sortable}}\">\n" +
    "            <!-- TODO: Move these into utility methods and call in the cell factory -->\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.cellType ==='text' && col.format !== 'timestamp' && col.format !== 'timeOfDay'\">\n" +
    "                <div class=\"bmp-grid-overflow\" data-qe-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{col.value($item)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{col.value($item)}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.cellType ==='link'\">\n" +
    "                <a data-ng-href=\"{{col.href($item)}}\" ng-attr-target=\"{{ col.hrefNewTab ? '_blank' : undefined }}\" data-qe-id=\"{{getCellId($row, col)}}\" data-ng-click=\"vm.linkClicked(col ,$row)\" class=\"link-alt bmp-grid-link\" style=\"cursor: pointer;\"\n" +
    "                    uib-tooltip=\"{{col.value($item)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">{{col.value($item)}}</a>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <!-- icon with hover text -->\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.cellType ==='icon'\">\n" +
    "                <span class=\"glyphicon glyphicon-{{col.icon($item)}}\" title=\"{{col.value($item)}}\"></span>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <!-- Custom -->\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.cellType ==='custom'\">\n" +
    "                <bmp-wijmo-custom-cell contents=\"col.value($item)\" data-qe-id=\"{{getCellId($row, col)}}\"></bmp-wijmo-custom-cell>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "        <wj-flex-grid-column ng-repeat=\"col in vm.columns3\"\n" +
    "                             width=\"{{col.width}}\"\n" +
    "                             min-width=\"{{col.minWidth}}\"\n" +
    "                             binding=\"{{col.fieldId}}\"\n" +
    "                             header=\"{{col.label ? (col.label | translate | bmRequiredMark:col.showRequiredMark) : ' '}}\"\n" +
    "                             data-type=\"{{col.dataType}}\"\n" +
    "                             format=\"{{col.format}}\"\n" +
    "                             is-read-only=\"{{col.isReadOnly}}\"\n" +
    "                             align=\"{{col.align}}\"\n" +
    "                             visible=\"{{col.visible()}}\"\n" +
    "                             aggregate=\"{{col.aggregate}}\"\n" +
    "                             allow-sorting=\"{{col.sortable}}\"\n" +
    "                             allow-dragging=\"{{col.allowDragging}}\">\n" +
    "                <!-- NO CELL TEMPLATES. ADD TEMPLATES TO COLUMN2 -->\n" +
    "        </wj-flex-grid-column>\n" +
    "     </wj-flex-grid>\n" +
    "     <div tabindex=\"-1\" class=\"bmp-wijmo-table-last visuallyHidden\"></div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-wijmo-table/cells/actions/bmp-actions-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/actions/bmp-actions-cell.html",
    "<div ng-class=\"bmpWijmoTableEditable ? 'bmp-cell' : ''\">\n" +
    "    <span>\n" +
    "        <a ng-if=\"bmpWijmoTableRowDetailTemplateSrc\"\n" +
    "            data-qe-id=\"{{::bmpWijmoTableName}}-actions-detail-icon-{{$row.index}}\"\n" +
    "            class=\"bmp-wijmo-table-actions-column-icon-item\"\n" +
    "            role=\"link\" aria-label=\"Info Icon\"\n" +
    "            ng-click=\"vm.toggleDetail($row)\" >\n" +
    "            <span\n" +
    "                class=\"grid-action-icon bento-icon-info\"\n" +
    "                data-tooltip-placement=\"top\"\n" +
    "                data-tooltip-trigger=\"mouseenter\"\n" +
    "                data-uib-tooltip=\"{{vm.toggleDetailTooltip($row)}}\"\n" +
    "                data-tooltip-append-to-body=\"true\">\n" +
    "            </span>\n" +
    "        </a>\n" +
    "        <a  ng-if=\"vm.actionsColumnIconsVisible()\"\n" +
    "            ng-repeat=\"actionIcon in bmpWijmoTableActionsColumnIcons\"\n" +
    "            data-qe-id=\"{{::bmpWijmoTableName}}-actions-{{::actionIcon.id}}-icon-{{$row.index}}\"\n" +
    "            class=\"bmp-wijmo-table-actions-column-icon-item\"\n" +
    "            role=\"link\" aria-label=\"{{::actionIcon.label | translate}}\"\n" +
    "            ng-class=\"{'disabled': actionIcon.isDisabled($item)}\"\n" +
    "            ng-click=\"actionIcon.isDisabled($item) || actionIcon.onClick($item)\"\n" +
    "            ng-href=\"{{vm.actionsColumnItemHref(actionIcon, $item)}}\">\n" +
    "            <span\n" +
    "                class=\"grid-action-icon {{::actionIcon.icon}}\"\n" +
    "                data-tooltip-placement=\"top\"\n" +
    "                data-tooltip-trigger=\"mouseenter\"\n" +
    "                data-uib-tooltip=\"{{::actionIcon.label | translate}}\"\n" +
    "                data-tooltip-append-to-body=\"true\">\n" +
    "            </span>\n" +
    "        </a>\n" +
    "    </span>\n" +
    "\n" +
    "    <span ng-if=\"vm.actionsColumnMoreButtonVisible()\"\n" +
    "        class=\"dropdown grid-dropdown bmp-wijmo-table-actions-column-more-button\"\n" +
    "        uib-dropdown\n" +
    "        bmp-grid-dropdown\n" +
    "        bento-dropdown-append-to-parent\n" +
    "        bento-append-to-parent=\"body\">\n" +
    "        <button\n" +
    "            class=\"btn btn-default btn-xs dropdown-toggle\"\n" +
    "            uib-dropdown-toggle>\n" +
    "            {{ 'Bluemoon.Practice.Common.Actions.More' | translate }}\n" +
    "            <i class=\"bento-icon-arrow-down2\"></i>\n" +
    "        </button>\n" +
    "        <ul class=\"dropdown-menu grid-dropdown\">\n" +
    "            <li ng-repeat=\"action in bmpWijmoTableActionsColumnMoreActions\"\n" +
    "                data-qe-id=\"{{::bmpWijmoTableName}}-actions={{::action.id}}\"\n" +
    "                ng-click=\"action.isDisabled($item) || action.onClick($item)\"\n" +
    "                ng-class=\"{'disabled': action.isDisabled($item)}\">\n" +
    "                <a ng-href=\"{{vm.actionsColumnItemHref(action, $item)}}\"\n" +
    "                role=\"link\" aria-label=\"{{::action.label | translate}}\"\n" +
    "            >\n" +
    "                    {{::action.label | translate}}\n" +
    "                </a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-wijmo-table/cells/bmp-wijmo-table-custom-column-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/bmp-wijmo-table-custom-column-header.html",
    "<bmp-wijmo-custom-cell contents=\"col.headerFunction()\" data-qe-id=\"{{getCellId($row, col)}}\"></bmp-wijmo-custom-cell>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/bmp-wijmo-table-non-editable-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/bmp-wijmo-table-non-editable-cell.html",
    "<div ng-if=\"::(col.editControl.type === 'date'  || (col.format && col.format === 'date'))\" class=\"bmp-non-editable-cell\">\n" +
    "    {{vm.bmpGridEffects.formatDate(vm.getModelParent($item, col.fieldId)[vm.getModelLeaf(col.fieldId)])}}\n" +
    "</div>\n" +
    "<div ng-if=\"::(col.editControl.type === 'timespan'  || (col.format && col.format === 'timespan'))\" class=\"bmp-non-editable-cell\">\n" +
    "    {{vm.bmpGridEffects.formatTimespan(vm.getModelParent($item, col.fieldId)[vm.getModelLeaf(col.fieldId)])}}\n" +
    "</div>\n" +
    "<div ng-if=\"::(col.editControl.type === 'timeOfDay'  || (col.format && col.format === 'timeOfDay'))\" class=\"bmp-non-editable-cell\">\n" +
    "    {{vm.bmpGridEffects.formatTimeOfDay(vm.getModelParent($item, col.fieldId)[vm.getModelLeaf(col.fieldId)])}}\n" +
    "</div>\n" +
    "<div ng-if=\"::(col.editControl.type === 'number' || (col.format && col.format !== 'date'))\" class=\"bmp-non-editable-cell\">\n" +
    "\n" +
    "    {{vm.bmpGridEffects.formatNumber(vm.getModelParent($item, col.fieldId)[vm.getModelLeaf(col.fieldId)], col)}}\n" +
    "</div>\n" +
    "<div ng-if=\"::((col.editControl.type === 'select' || col.editControl.type === 'enum' || vm.isObject(col.fieldId)) && !col.format)\" class=\"bmp-non-editable-cell\">\n" +
    "    {{vm.getModelParent($item, col.fieldId)[vm.getModelLeaf(col.fieldId)]}}\n" +
    "</div>\n" +
    "<div ng-if=\"::(col.editControl.type !== 'date' && col.editControl.type !== 'timespan' && col.editControl.type !== 'timeOfDay' && col.editControl.type !== 'number' && col.editControl.type !== 'select' && col.editControl.type !== 'enum' && !col.format && !vm.isObject(col.fieldId))\"\n" +
    "class=\"bmp-non-editable-cell\">\n" +
    "    {{vm.getModelParent($item, col.fieldId)[vm.getModelLeaf(col.fieldId)]}}\n" +
    "</div>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/display/bmo-wijmo-table-icon-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/display/bmo-wijmo-table-icon-cell.html",
    "<span class=\"glyphicon glyphicon-{{col.icon($item)}}\" title=\"{{col.value($item)}}\"></span>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-boolean-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-boolean-cell.html",
    "<div style=\"text-align:center\">\n" +
    "    <span ng-if=\"col.value($item)===true\" class=\"bento-icon-checkmark\" data-qe-id=\"{{getCellId($row, col)}}\"></span>\n" +
    "    <span ng-if=\"col.value($item)===false\" class=\"bento-icon-minus-plain\" data-qe-id=\"{{getCellId($row, col)}}\"></span>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-button-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-button-cell.html",
    "<div style=\"text-align:center\">\n" +
    "    <a data-ng-if=\"col.cellVisible($item)\" class=\"btn btn-default btn-sm\" data-qe-id=\"{{getCellId($row, col)}}\" data-ng-href=\"{{col.href($item)}}\" ng-attr-target=\"{{ col.hrefNewTab ? '_blank' : undefined }}\" data-ng-click=\"col.cellClick($item)\" title=\"{{col.value($item)}}\">\n" +
    "        <span data-ng-if=\"col.icon($item)\" class=\"glyphicon glyphicon-{{col.icon($item)}} bmp-wijmo-table-button-icon\"></span>\n" +
    "        <span data-ng-if=\"!col.icon($item)\">{{col.value($item)}}</span>\n" +
    "    </a>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-custom-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-custom-cell.html",
    "<bmp-wijmo-custom-cell contents=\"col.value($item)\" data-qe-id=\"{{getCellId($row, col)}}\"></bmp-wijmo-custom-cell>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-link-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/display/bmp-wijmo-table-link-cell.html",
    "<a data-ng-href=\"{{col.href($item)}}\"\n" +
    "    ng-attr-target=\"{{ col.hrefNewTab ? '_blank' : undefined }}\"\n" +
    "    data-qe-id=\"{{getCellId($row, col)}}\"\n" +
    "    data-ng-click=\"vm.linkClicked(col ,$row)\"\n" +
    "    class=\"link-alt bmp-grid-link\"\n" +
    "    style=\"cursor: pointer;\"\n" +
    "    uib-tooltip=\"{{col.value($item)}}\"\n" +
    "    tooltip-placement=\"top\"\n" +
    "    tooltip-append-to-body=\"true\"\n" +
    "    tooltip-enable=\"showTooltip($row, col)\">{{col.value($item)}}</a>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/edit/bmp-editable-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/edit/bmp-editable-cell.html",
    "<div ng-class=\"vm.getCellStyle($item, $row, col)\">\n" +
    "    <div ng-mouseenter=\"vm.setHoverState($row.index, $col.index)\" style=\"height: 100%\">\n" +
    "        <!-- Info icon -->\n" +
    "        <span ng-if=\"col.getInfoIconToolTip($item)\"\n" +
    "            ng-class=\"col.align === 'right' ? 'bmp-wijmo-table-info-icon-align-left': 'bmp-wijmo-table-info-icon-align-right'\"\n" +
    "            class=\"bento-icon-info bmp-wijmo-table-info-icon\"\n" +
    "            data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-tooltip-append-to-body=\"true\"\n" +
    "            data-uib-tooltip=\"{{col.getInfoIconToolTip($item) | translate }}\"/>\n" +
    "\n" +
    "        <div ng-if=\"vm.displayEditControl($row, $col, col)\">\n" +
    "            <div ng-include=\"::vm.editControlSrcs[col.editControl.type]\"></div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"!vm.displayEditControl($row, $col, col)\" class=\"bmp-cell\">\n" +
    "            <!--TODO: Binding this way runs every digest cycle and might cause performance issues.\n" +
    "                        We should consider binding to an external model that is updated only when the underlying value changes. -->\n" +
    "            <div ng-include=\"'bmp/bmp-wijmo-table/cells/bmp-wijmo-table-non-editable-cell.html'\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-bento-select.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-bento-select.html",
    "<span data-bento-select bento-busy-loader=\"!col.editControl.options()\" bento-busy-loader-size=\"small\">\n" +
    "    <select name=\"{{col.fieldId}}\"\n" +
    "            data-ng-model=\" vm.getModelParent($item, $col)[vm.getModelLeaf($col)]\"\n" +
    "            data-ng-options=\"option as option.name for option in col.editControl.options() track by option.id\">\n" +
    "        <option ng-if=\"col.editControl.emptyLabel\" value=\"\">{{ col.editControl.emptyLabel() }}</option>\n" +
    "    </select>\n" +
    "</span>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-date.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-date.html",
    "<bmp-bento-datepicker-wrapper class=\"bmp-wijmo-table-date\"\n" +
    "                        name=\"{{col.fieldId}}\"\n" +
    "                        data-ng-required=\"true\"\n" +
    "                        bmp-bento-datepicker-wrapper-on-open-focus=\"false\"\n" +
    "                        bmp-bento-datepicker-wrapper-append-to-body=\"true\"\n" +
    "                        bmp-bento-datepicker-wrapper-select-on-focus=\"true\"\n" +
    "                        bmp-bento-datepicker-wrapper-update-on=\"'blur'\"\n" +
    "                        bmp-bento-datepicker-wrapper-container-visibility-changed=\"vm.datepickerVisibilityChanged(visibility)\">\n" +
    "</bmp-bento-datepicker-wrapper>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-enum.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-enum.html",
    "<bmp-enum-combo enum=\"{{vm.listNameTypePick($item, col)}}\"\n" +
    "                name=\"{{col.fieldId}}\"\n" +
    "                append-to-parent=\"wj-flex-grid\"\n" +
    "                custom-items=\"col.editControl.options()\"\n" +
    "                defer-load=\"true\"\n" +
    "                container-visibility-changed=\"vm.comboboxVisibilityChanged(visibility)\">\n" +
    "</bmp-enum-combo>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-number.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-number.html",
    "<input style=\"text-align: right; font-size: inherit; height: 100%; width: 100%\"\n" +
    "    name=\"{{col.fieldId}}\"\n" +
    "    type=\"text\"\n" +
    "    class=\"input-sm\"\n" +
    "    ng-model-options=\"{ updateOn: 'bmpGridUpdateCellModel' }\"\n" +
    "    data-bmp-clear-value=\"{{col.editControl.default ? col.editControl.default : undefined}}\"\n" +
    "    data-bmp-big-number=\"'{{col.format}}'\"\n" +
    "    data-bmp-big-number-range-validator>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-select.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-select.html",
    "<bmp-select-combo list=\"{{vm.listNameTypePick($item, col)}}\"\n" +
    "                aotf-default=\"col.aotfDefault\"\n" +
    "                aotf=\"col.aotfParams($row)\"\n" +
    "                aotf-on-open=\"vm.onAotfOpen()\"\n" +
    "                aotf-on-close=\"vm.onAotfClose(item)\"\n" +
    "                aotf-update-ng-model=\"false\"\n" +
    "                name=\"{{col.fieldId}}\"\n" +
    "                filter=\"col.editControl.filter($item)\"\n" +
    "                user-filter=\"col.editControl.userFilter\"\n" +
    "                user-filter-label=\"{{col.editControl.userFilterLabel}}\"\n" +
    "                append-to-parent=\"body\"\n" +
    "                context=\"col.editControl.context($item)\"\n" +
    "                defer-load=\"true\"\n" +
    "                container-visibility-changed=\"vm.comboboxVisibilityChanged(visibility)\"\n" +
    "                ng-required=\"col.editControl.required\">\n" +
    "</bmp-select-combo>\n" +
    "");
}]);

angular.module("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/edit/bmp-wijmo-table-text.html",
    "<input style=\"font-size: inherit; height: 100%; width: 100%\"\n" +
    "    type=\"text\"\n" +
    "    class=\"input-sm\"\n" +
    "    name=\"{{col.fieldId}}\"\n" +
    "    ng-model-options=\"{ updateOn: 'bmpGridUpdateCellModel' }\"\n" +
    "    label=\"{{col.title | translate}}\"/>\n" +
    "");
}]);

angular.module("bmp/bmp-wijmo-table/cells/select/bmp-wijmo-table-select-row-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/select/bmp-wijmo-table-select-row-header.html",
    "<i class=\"bento-flex-grid-checkbox\"\n" +
    "    ng-if=\"$item && !$item.$isRowDirty\"\n" +
    "    ng-click=\"$item._selected = !$item._selected;vm.ctx.onCheckBoxChange({ item: $item, event: $event });\"\n" +
    "    ng-class=\"{'bento-icon-checkmark':$item._selected === true,'disabled':$item.disabled === true,'bento-icon-minus-plain':$item._selected === vm.ctx.CHECKBOX_INDETERMINATE}\">\n" +
    "</i>\n" +
    "<i class=\"bento-icon-remove\" style=\"cursor: pointer;\"\n" +
    "    ng-if=\"$item && $item.$isRowDirty\"\n" +
    "    ng-click=\"vm.revertChanges($item)\"\n" +
    "    tooltip-placement=\"top\"\n" +
    "    tooltip-trigger=\"mouseenter\"\n" +
    "    uib-tooltip=\"{{::'Bluemoon.Practice.Common.Grid.RevertChangesToolTip' | translate}}\"\n" +
    "    tooltip-append-to-body=\"true\">\n" +
    "</i>");
}]);

angular.module("bmp/bmp-wijmo-table/cells/select/bmp-wijmo-table-select-top-left.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-wijmo-table/cells/select/bmp-wijmo-table-select-top-left.html",
    "<div class=\"col-select\">\n" +
    "    <i class=\"bento-flex-grid-checkbox\"\n" +
    "        ng-click=\"vm.ctx.onHeaderCheckBoxChange()\"\n" +
    "        ng-class=\"{'bento-icon-checkmark':vm.ctx.headerCheckBoxMode === vm.ctx.CHECKBOX_SELECTED,'bento-icon-minus-plain':vm.ctx.headerCheckBoxMode === vm.ctx.CHECKBOX_INDETERMINATE}\">\n" +
    "    </i>\n" +
    "</div>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/accounting.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/accounting.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#397C2B\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M7.028,4.008L4.124,12H5.9l0.576-1.764h3.047L10.1,12h1.776L8.973,4.008H7.028z M6.956,8.771L8,5.58\n" +
    "	l1.044,3.191H6.956z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/activity-statements.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/activity-statements.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 viewBox=\"0 0 80 80\" style=\"enable-background:new 0 0 80 80;\" xml:space=\"preserve\">\n" +
    "<style type=\"text/css\">\n" +
    "	.st0{fill:#0072A8;}\n" +
    "</style>\n" +
    "<g>\n" +
    "	<polygon class=\"st0\" points=\"18.5,44.4 29.5,44.4 23.9,29.5 	\"/>\n" +
    "	<path class=\"st0\" d=\"M68.6,0.1H11.4C5.1,0.1,0.1,5.2,0.1,11.5v57.2C0.1,74.9,5.1,80,11.4,80h57.2c6.3,0,11.3-5.1,11.3-11.3V11.5\n" +
    "		C79.9,5.2,74.9,0.1,68.6,0.1z M35.6,60.4l-3.5-9.1H16l-3.3,9.1H4l15.7-40.3h8.6l16.1,40.3H35.6z M74.2,55.1c-1.3,2-3.1,3.5-5.4,4.5\n" +
    "		c-2.3,1-5.3,1.5-8.8,1.5c-5.1,0-9-1.2-11.7-3.5c-2.7-2.4-4.4-5.8-4.9-10.3l7.9-0.8c0.5,2.7,1.4,4.6,2.9,5.8\n" +
    "		c1.5,1.2,3.4,1.9,5.9,1.9c2.6,0,4.6-0.6,5.9-1.7c1.3-1.1,2-2.4,2-3.9c0-1-0.3-1.8-0.8-2.4c-0.6-0.7-1.5-1.2-2.9-1.7\n" +
    "		c-1-0.3-3.1-0.9-6.5-1.8c-4.4-1.1-7.4-2.4-9.2-4c-2.5-2.2-3.7-4.9-3.7-8.1c0-2,0.6-4,1.7-5.8c1.2-1.8,2.8-3.1,5-4.1\n" +
    "		c2.2-0.9,4.8-1.4,7.9-1.4c5.1,0,8.9,1.1,11.4,3.3c2.6,2.2,3.9,5.2,4,8.9L66.8,32c-0.3-2.1-1.1-3.6-2.2-4.5\n" +
    "		c-1.1-0.9-2.9-1.4-5.1-1.4c-2.4,0-4.2,0.5-5.5,1.5c-0.9,0.6-1.3,1.5-1.3,2.5c0,1,0.4,1.8,1.2,2.4c1,0.9,3.5,1.8,7.5,2.7\n" +
    "		c4,0.9,6.9,1.9,8.8,2.9c1.9,1,3.4,2.4,4.4,4.1c1.1,1.7,1.6,3.9,1.6,6.4C76.1,50.9,75.4,53.1,74.2,55.1z\"/>\n" +
    "</g>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/advisory.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/advisory.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#0099CA\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M7.028,4.008L4.124,12H5.9l0.576-1.764h3.047L10.1,12h1.776L8.973,4.008H7.028z M6.956,8.771L8,5.58\n" +
    "	l1.044,3.191H6.956z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/amnesty-forgiveness.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/amnesty-forgiveness.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#FF8000\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M11.066,9.636c0-0.392-0.059-0.722-0.174-0.989c-0.117-0.269-0.287-0.495-0.511-0.679\n" +
    "	c-0.224-0.184-0.5-0.338-0.827-0.462C9.227,7.382,8.846,7.268,8.414,7.164c-0.32-0.072-0.586-0.14-0.798-0.204\n" +
    "	c-0.212-0.064-0.382-0.132-0.51-0.204C6.978,6.684,6.886,6.6,6.83,6.504c-0.056-0.096-0.084-0.22-0.084-0.372\n" +
    "	c0-0.336,0.108-0.56,0.324-0.672c0.216-0.112,0.544-0.168,0.984-0.168c0.424,0,0.846,0.05,1.266,0.15s0.802,0.226,1.146,0.378\n" +
    "	l0.312-1.392c-0.407-0.184-0.829-0.324-1.266-0.42C9.076,3.912,8.582,3.864,8.03,3.864c-0.448,0-0.856,0.04-1.224,0.12\n" +
    "	c-0.368,0.08-0.688,0.214-0.96,0.402c-0.272,0.188-0.482,0.44-0.63,0.756s-0.222,0.71-0.222,1.182c0,0.376,0.06,0.7,0.18,0.972\n" +
    "	C5.294,7.568,5.47,7.8,5.702,7.992c0.232,0.192,0.516,0.35,0.852,0.474C6.89,8.59,7.278,8.695,7.718,8.784\n" +
    "	c0.296,0.063,0.546,0.124,0.75,0.18c0.204,0.056,0.37,0.124,0.498,0.204S9.184,9.342,9.236,9.45c0.052,0.108,0.078,0.237,0.078,0.39\n" +
    "	c0,0.328-0.129,0.555-0.385,0.678c-0.256,0.125-0.604,0.187-1.043,0.187c-0.384,0-0.794-0.052-1.23-0.156\n" +
    "	c-0.436-0.104-0.858-0.235-1.266-0.396l-0.372,1.404c0.424,0.176,0.892,0.317,1.404,0.426c0.512,0.107,1.004,0.162,1.476,0.162\n" +
    "	c1.016,0,1.797-0.219,2.346-0.654C10.792,11.055,11.066,10.436,11.066,9.636z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/ar-income-tax.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/ar-income-tax.svg",
    "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
    "<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
    "    <title>GananciasSVG</title>\n" +
    "    <g id=\"GananciasSVG\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n" +
    "        <rect id=\"Rectangle\" fill=\"#005885\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"2\"></rect>\n" +
    "        <text id=\"G\" font-family=\"ArialMT, Arial\" font-size=\"13\" font-weight=\"normal\" fill=\"#FFFFFF\">\n" +
    "            <tspan x=\"2.9440918\" y=\"13\">G</tspan>\n" +
    "        </text>\n" +
    "    </g>\n" +
    "</svg>");
}]);

angular.module("bmp/bmp-icons/svg/checkpoint-engage.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/checkpoint-engage.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#A00000\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M1.442,8.004c0,0.648,0.096,1.23,0.288,1.746s0.462,0.95,0.81,1.302c0.348,0.353,0.768,0.622,1.26,0.81\n" +
    "	c0.492,0.188,1.034,0.283,1.626,0.283c0.528,0,0.99-0.049,1.386-0.145s0.71-0.204,0.942-0.324l-0.264-1.38\n" +
    "	c-0.232,0.097-0.502,0.177-0.81,0.24c-0.308,0.063-0.598,0.096-0.87,0.096c-0.856,0-1.506-0.214-1.95-0.642\n" +
    "	C3.416,9.562,3.194,8.9,3.194,8.004c0-0.896,0.222-1.558,0.666-1.986C4.304,5.59,4.954,5.376,5.81,5.376\n" +
    "	c0.272,0,0.562,0.032,0.87,0.096c0.308,0.064,0.578,0.144,0.81,0.24l0.264-1.38c-0.232-0.12-0.546-0.228-0.942-0.324\n" +
    "	C6.416,3.912,5.954,3.864,5.426,3.864c-0.592,0-1.134,0.094-1.626,0.282c-0.492,0.188-0.912,0.458-1.26,0.81S1.922,5.742,1.73,6.258\n" +
    "	C1.538,6.774,1.442,7.356,1.442,8.004z M8.882,4.008V12h5.496v-1.512h-3.744V8.664h3.505V7.152h-3.505V5.52h3.744V4.008H8.882z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/combined-shape.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/combined-shape.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#397C2B\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M10.4,9.564L8.84,4.008H7.172L5.6,9.564L4.304,4.008H2.792L4.892,12h1.404l1.716-6.348L9.704,12h1.403\n" +
    "	l2.088-7.992h-1.512L10.4,9.564z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/company-formations.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/company-formations.svg",
    "<svg version=\"1.1\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\">\n" +
    "<path fill=\"#FF8000\" d=\"M-0.001,0v100h100.002V0H-0.001z M37.836,67.061c3.383,0,7.416-0.865,10.367-2.018l1.369,7.129\n" +
    "c-2.881,1.368-7.705,2.664-13.682,2.664c-14.4,0-23.834-9.434-23.834-24.842c0-15.409,9.434-24.842,23.834-24.842\n" +
    "c5.977,0,10.801,1.296,13.682,2.664l-1.369,7.129c-2.951-1.152-6.984-2.017-10.367-2.017c-10.802,0-16.778,5.833-16.778,17.065\n" +
    "C21.058,61.225,27.034,67.061,37.836,67.061z M88.811,33.793H65.842v13.249h21.457v7.849H65.842v19.082H56.84V26.016h31.971V33.793z\n" +
    "\"/>\n" +
    "</svg>");
}]);

angular.module("bmp/bmp-icons/svg/cuentasde-inversion.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/cuentasde-inversion.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"Combined-Shape\" fill=\"#FF8000\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M1.604,8.004c0,0.648,0.096,1.23,0.288,1.746s0.462,0.95,0.81,1.302c0.348,0.353,0.768,0.622,1.26,0.81\n" +
    "	c0.492,0.188,1.034,0.283,1.626,0.283c0.528,0,0.99-0.049,1.386-0.145s0.71-0.204,0.942-0.324l-0.264-1.38\n" +
    "	c-0.232,0.097-0.502,0.177-0.81,0.24c-0.308,0.063-0.598,0.096-0.87,0.096c-0.856,0-1.506-0.214-1.95-0.642S3.356,8.9,3.356,8.004\n" +
    "	c0-0.896,0.222-1.558,0.666-1.986c0.444-0.428,1.094-0.642,1.95-0.642c0.272,0,0.562,0.032,0.87,0.096\n" +
    "	c0.308,0.064,0.578,0.144,0.81,0.24l0.264-1.38C7.684,4.212,7.37,4.104,6.974,4.008C6.578,3.912,6.116,3.864,5.588,3.864\n" +
    "	c-0.592,0-1.134,0.094-1.626,0.282C3.47,4.334,3.05,4.604,2.702,4.956c-0.348,0.352-0.618,0.786-0.81,1.302\n" +
    "	C1.7,6.774,1.604,7.356,1.604,8.004z M9.044,4.008V12h1.752V8.928h3.456V7.416h-3.456V5.52h3.696V4.008H9.044z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/fixed-assets.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/fixed-assets.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#621F95\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M1.808,4.008V12H3.56V8.928h3.456V7.416H3.56V5.52h3.696V4.008H1.808z M10.064,4.008L7.16,12h1.775\n" +
    "	l0.576-1.764h3.049L13.137,12h1.775l-2.904-7.992H10.064z M9.992,8.771l1.044-3.191l1.044,3.191H9.992z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/gross-income-tax.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/gross-income-tax.svg",
    "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
    "<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
    "    <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->\n" +
    "    <title>IngresosBrutosSVG</title>\n" +
    "    <desc>Created with Sketch.</desc>\n" +
    "    <g id=\"IngresosBrutosSVG\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n" +
    "        <rect id=\"Rectangle\" fill=\"#FF8000\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"2\"></rect>\n" +
    "        <path d=\"M4.13671875,12.5898438 L4.13671875,4 L3,4 L3,12.5898438 L4.13671875,12.5898438 Z M9.25664062,12.5898438 C9.80351562,12.5898438 10.2654297,12.5419922 10.6423828,12.4462891 C11.0193359,12.3505859 11.3328125,12.2089844 11.5828125,12.0214844 C11.8328125,11.8339844 12.0427734,11.5673828 12.2126953,11.2216797 C12.3826172,10.8759766 12.4675781,10.5019531 12.4675781,10.0996094 C12.4675781,9.59960938 12.3279297,9.16601562 12.0486328,8.79882812 C11.7693359,8.43164062 11.3699219,8.171875 10.8503906,8.01953125 C11.2527344,7.8203125 11.5535156,7.55859375 11.7527344,7.234375 C11.9519531,6.91015625 12.0515625,6.56445312 12.0515625,6.19726562 C12.0515625,5.80273438 11.9392578,5.42480469 11.7146484,5.06347656 C11.4900391,4.70214844 11.1794922,4.43457031 10.7830078,4.26074219 C10.3865234,4.08691406 9.86015625,4 9.20390625,4 L9.20390625,4 L5.98125,4 L5.98125,12.5898438 L9.25664062,12.5898438 Z M8.97539062,7.609375 L7.11796875,7.609375 L7.11796875,5.01367188 L8.83476562,5.01367188 C9.45195312,5.01367188 9.8875,5.05371094 10.1414062,5.13378906 C10.3953125,5.21386719 10.590625,5.36230469 10.7273437,5.57910156 C10.8640625,5.79589844 10.9324219,6.046875 10.9324219,6.33203125 C10.9324219,6.6328125 10.8591797,6.8828125 10.7126953,7.08203125 C10.5662109,7.28125 10.3484375,7.42382812 10.059375,7.50976562 C9.840625,7.57617188 9.47929687,7.609375 8.97539062,7.609375 L8.97539062,7.609375 Z M9.25664062,11.5761719 L7.11796875,11.5761719 L7.11796875,8.62304688 L9.10429687,8.62304688 C9.65117187,8.62304688 10.0701172,8.67089844 10.3611328,8.76660156 C10.6521484,8.86230469 10.8796875,9.02832031 11.04375,9.26464844 C11.2078125,9.50097656 11.2898437,9.77929688 11.2898437,10.0996094 C11.2898437,10.3730469 11.2332031,10.6142578 11.1199219,10.8232422 C11.0066406,11.0322266 10.8621094,11.1914062 10.6863281,11.3007812 C10.5105469,11.4101562 10.2917969,11.4882812 10.0300781,11.5351562 C9.88164062,11.5625 9.62382812,11.5761719 9.25664062,11.5761719 L9.25664062,11.5761719 Z\" id=\"IB\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"></path>\n" +
    "    </g>\n" +
    "</svg>");
}]);

angular.module("bmp/bmp-icons/svg/investment-accounts.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/investment-accounts.svg",
    "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
    "<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
    "    <defs></defs>\n" +
    "    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n" +
    "        <g id=\"investment-accounts\" fill=\"#FF8000\" fill-rule=\"nonzero\">\n" +
    "            <path d=\"M37.7487961,35.0898375 C36.2479936,33.6962727 34.2315409,33 31.7024478,33 L20,33 L20,49 L31.7024478,49 C34.2315409,49 36.2479936,48.2853775 37.7487961,46.8551131 C39.2495987,45.4248487 40,43.4369544 40,40.890411 C40,38.4182861 39.2495987,36.4834024 37.7487961,35.0898375 Z\" id=\"Shape\"></path>\n" +
    "            <path d=\"M0,12 L0,88 C8.11624501e-16,94.627417 5.372583,100 12,100 L88,100 C94.627417,100 100,94.627417 100,88 L100,12 C100,5.372583 94.627417,-1.21743675e-15 88,0 L12,0 C5.372583,1.21743675e-15 -8.11624501e-16,5.372583 0,12 Z M40.09,74.107 L28.567,55.937 L19.588,55.937 L19.588,74.107 L10.538,74.107 L10.538,25.892 L32.632,25.892 C37.628,25.892 41.534,27.259 44.351,29.993 C47.168,32.727 48.576,36.379 48.576,40.951 C48.576,44.221 47.674,47.114 45.871,49.624 C44.068,52.137 41.611,53.93 38.501,55.002 L51.439,74.107 L40.09,74.107 Z M89.463,33.705 L66.344,33.705 L66.344,47.031 L87.943,47.031 L87.943,54.844 L66.344,54.844 L66.344,74.108 L57.295,74.108 L57.295,25.892 L89.463,25.892 L89.463,33.705 Z\" id=\"Shape\"></path>\n" +
    "        </g>\n" +
    "    </g>\n" +
    "</svg>");
}]);

angular.module("bmp/bmp-icons/svg/no-app.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/no-app.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"Combined-Shape\" opacity=\"0.7365\" fill=\"#B2B2B8\" stroke=\"#B2B2B8\" enable-background=\"new    \" d=\"M2.5,0.5h11\n" +
    "	c1.104,0,2,0.896,2,2v11c0,1.104-0.896,2-2,2h-11c-1.104,0-2-0.896-2-2v-11C0.5,1.396,1.396,0.5,2.5,0.5z\"/>\n" +
    "<path id=\"Line-2\" fill=\"none\" stroke=\"#EBF7FA\" stroke-linecap=\"square\" d=\"M15.5,0.5l-15,15\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/onvio.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/onvio.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"Combined-Shape\" fill=\"#FF8000\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M4.172,8.004c0,0.592,0.078,1.143,0.234,1.65c0.156,0.508,0.392,0.945,0.708,1.313\n" +
    "	c0.316,0.368,0.714,0.656,1.194,0.864S7.352,12.145,8,12.145c0.648,0,1.212-0.104,1.691-0.312c0.48-0.208,0.879-0.496,1.195-0.864\n" +
    "	c0.315-0.368,0.551-0.806,0.707-1.313s0.234-1.059,0.234-1.65s-0.078-1.142-0.234-1.65s-0.392-0.946-0.707-1.314\n" +
    "	c-0.316-0.368-0.715-0.656-1.195-0.864C9.212,3.968,8.648,3.864,8,3.864c-0.648,0-1.212,0.104-1.692,0.312S5.43,4.672,5.114,5.04\n" +
    "	C4.798,5.408,4.562,5.846,4.406,6.354C4.25,6.862,4.172,7.412,4.172,8.004z M8,10.656c-0.368,0-0.682-0.064-0.942-0.192\n" +
    "	c-0.26-0.128-0.474-0.31-0.642-0.546s-0.292-0.516-0.372-0.84s-0.12-0.682-0.12-1.074s0.04-0.75,0.12-1.074\n" +
    "	c0.08-0.324,0.204-0.602,0.372-0.834S6.798,5.682,7.058,5.55C7.318,5.418,7.632,5.352,8,5.352S8.682,5.418,8.941,5.55\n" +
    "	c0.261,0.132,0.475,0.314,0.643,0.546s0.292,0.51,0.372,0.834c0.08,0.324,0.12,0.682,0.12,1.074s-0.04,0.75-0.12,1.074\n" +
    "	s-0.204,0.604-0.372,0.84s-0.382,0.418-0.643,0.546C8.682,10.592,8.368,10.656,8,10.656z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/secretarial.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/secretarial.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"Combined-Shape\" fill=\"#FF8000\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M11.066,9.636c0-0.392-0.059-0.722-0.174-0.989c-0.117-0.269-0.287-0.495-0.511-0.679\n" +
    "	c-0.224-0.184-0.5-0.338-0.827-0.462C9.227,7.382,8.846,7.268,8.414,7.164c-0.32-0.072-0.586-0.14-0.798-0.204\n" +
    "	c-0.212-0.064-0.382-0.132-0.51-0.204C6.978,6.684,6.886,6.6,6.83,6.504c-0.056-0.096-0.084-0.22-0.084-0.372\n" +
    "	c0-0.336,0.108-0.56,0.324-0.672c0.216-0.112,0.544-0.168,0.984-0.168c0.424,0,0.846,0.05,1.266,0.15s0.802,0.226,1.146,0.378\n" +
    "	l0.312-1.392c-0.407-0.184-0.829-0.324-1.266-0.42C9.076,3.912,8.582,3.864,8.03,3.864c-0.448,0-0.856,0.04-1.224,0.12\n" +
    "	c-0.368,0.08-0.688,0.214-0.96,0.402c-0.272,0.188-0.482,0.44-0.63,0.756s-0.222,0.71-0.222,1.182c0,0.376,0.06,0.7,0.18,0.972\n" +
    "	C5.294,7.568,5.47,7.8,5.702,7.992c0.232,0.192,0.516,0.35,0.852,0.474C6.89,8.59,7.278,8.695,7.718,8.784\n" +
    "	c0.296,0.063,0.546,0.124,0.75,0.18c0.204,0.056,0.37,0.124,0.498,0.204S9.184,9.342,9.236,9.45c0.052,0.108,0.078,0.237,0.078,0.39\n" +
    "	c0,0.328-0.129,0.555-0.385,0.678c-0.256,0.125-0.604,0.187-1.043,0.187c-0.384,0-0.794-0.052-1.23-0.156\n" +
    "	c-0.436-0.104-0.858-0.235-1.266-0.396l-0.372,1.404c0.424,0.176,0.892,0.317,1.404,0.426c0.512,0.107,1.004,0.162,1.476,0.162\n" +
    "	c1.016,0,1.797-0.219,2.346-0.654C10.792,11.055,11.066,10.436,11.066,9.636z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/tax-amnesty.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/tax-amnesty.svg",
    "<svg version=\"1.1\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\">\n" +
    "<path fill=\"#FF8000\" d=\"M0,0v100h100.001V0H0z M49.644,74.838c-5.688,0-12.169-1.441-17.138-3.529l1.944-7.271\n" +
    "c4.824,2.018,10.369,3.384,15.121,3.384c5.761,0,9.434-1.655,9.434-6.119c0-4.393-2.81-5.762-10.514-7.418\n" +
    "c-10.656-2.231-16.129-6.048-16.129-14.473c0-10.656,7.2-14.258,17.857-14.258c6.408,0,11.449,1.152,16.131,3.312l-1.656,7.201\n" +
    "c-4.104-1.801-9.289-3.168-14.33-3.168c-5.905,0-9.001,1.367-9.001,5.977c0,4.031,2.808,5.184,10.657,7.128\n" +
    "c10.297,2.521,16.058,5.473,16.058,14.689C68.077,69.438,61.236,74.838,49.644,74.838z\"/>\n" +
    "</svg>");
}]);

angular.module("bmp/bmp-icons/svg/tax.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/tax.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#005885\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M8.876,5.52h2.231V4.008H4.892V5.52h2.232V12h1.752V5.52z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/trial-balance-estudio-contable.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/trial-balance-estudio-contable.svg",
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\">\n" +
    "<path fill=\"#397C2B\" d=\"M0,0v100h100V0H0z M13.64,25.999h32.256v7.776H22.64v11.664h21.744v7.775H22.64v12.96h23.256v7.776H13.64\n" +
    "V25.999z M51.656,49.975c0-3.839,0.562-7.295,1.691-10.367c1.127-3.071,2.735-5.676,4.823-7.812c2.088-2.135,4.597-3.78,7.524-4.932\n" +
    "c2.927-1.152,6.191-1.728,9.791-1.728c3.023,0,5.699,0.277,8.027,0.828c2.328,0.552,4.213,1.164,5.652,1.836l-1.367,7.128\n" +
    "c-1.488-0.575-3.168-1.055-5.041-1.44c-1.871-0.383-3.648-0.575-5.328-0.575c-5.424,0-9.574,1.429-12.455,4.284\n" +
    "s-4.32,7.117-4.32,12.779c0,5.666,1.439,9.926,4.32,12.78c2.881,2.856,7.031,4.284,12.455,4.284c1.68,0,3.457-0.191,5.328-0.576\n" +
    "c1.873-0.384,3.553-0.863,5.041-1.439l1.367,7.129c-1.439,0.673-3.324,1.283-5.652,1.836c-2.328,0.551-5.004,0.828-8.027,0.828\n" +
    "c-3.6,0-6.864-0.576-9.791-1.729c-2.93-1.151-5.438-2.795-7.524-4.932c-2.088-2.136-3.696-4.739-4.823-7.812\n" +
    "C52.221,57.271,51.656,53.816,51.656,49.975z\"/>\n" +
    "        '</svg>");
}]);

angular.module("bmp/bmp-icons/svg/trial-balance.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/trial-balance.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#397C2B\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M5.168,5.52H7.4V4.008H1.184V5.52h2.232V12h1.752V5.52z M8.444,4.008V12h3.708\n" +
    "	c0.392,0,0.746-0.055,1.062-0.162s0.586-0.258,0.81-0.449c0.225-0.193,0.396-0.423,0.517-0.69c0.12-0.269,0.181-0.566,0.181-0.894\n" +
    "	c0-0.545-0.154-0.971-0.463-1.279c-0.308-0.308-0.71-0.513-1.206-0.617c0.48-0.168,0.835-0.422,1.062-0.762\n" +
    "	c0.229-0.34,0.343-0.734,0.343-1.182c0-0.608-0.202-1.086-0.606-1.434c-0.404-0.348-0.978-0.522-1.722-0.522H8.444z M11.66,7.308\n" +
    "	h-1.488V5.376h1.452c0.376,0,0.653,0.08,0.834,0.24c0.181,0.16,0.271,0.38,0.271,0.66c0,0.272-0.084,0.512-0.252,0.72\n" +
    "	S12.036,7.308,11.66,7.308z M11.912,10.632h-1.74V8.676h1.656c0.376,0,0.664,0.084,0.863,0.252c0.201,0.168,0.301,0.4,0.301,0.696\n" +
    "	c0,0.304-0.088,0.548-0.264,0.731C12.552,10.54,12.279,10.632,11.912,10.632z\"/>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/ultra-tax.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/ultra-tax.svg",
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n" +
    "<svg\n" +
    "   xmlns:dc=\"http://purl.org/dc/elements/1.1/\"\n" +
    "   xmlns:cc=\"http://creativecommons.org/ns#\"\n" +
    "   xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"\n" +
    "   xmlns:svg=\"http://www.w3.org/2000/svg\"\n" +
    "   xmlns=\"http://www.w3.org/2000/svg\"\n" +
    "   viewBox=\"0 0 48 48\"\n" +
    "   enable-background=\"new 0 0 48 48\"\n" +
    "   version=\"1.1\"\n" +
    "   id=\"svg3528\"\n" +
    "   height=\"100%\"\n" +
    "   width=\"100%\"\n" +
    "   xml:space=\"preserve\">\n" +
    "  <defs\n" +
    "     id=\"defs3530\" />\n" +
    "  <metadata\n" +
    "     id=\"metadata3533\">\n" +
    "    <rdf:RDF>\n" +
    "      <cc:Work\n" +
    "         rdf:about=\"\">\n" +
    "        <dc:format>image/svg+xml</dc:format>\n" +
    "        <dc:type\n" +
    "           rdf:resource=\"http://purl.org/dc/dcmitype/StillImage\" />\n" +
    "        <dc:title></dc:title>\n" +
    "      </cc:Work>\n" +
    "    </rdf:RDF>\n" +
    "  </metadata>\n" +
    "  <g\n" +
    "     id=\"layer1\">\n" +
    "    <rect\n" +
    "       y=\"0\"\n" +
    "       x=\"0.14285715\"\n" +
    "       height=\"48\"\n" +
    "       width=\"47.857143\"\n" +
    "       id=\"rect3540\"\n" +
    "       style=\"fill:#004683;fill-opacity:0.82914573;opacity:1;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none\" />\n" +
    "    <text\n" +
    "       transform=\"scale(1.0457621,0.95624043)\"\n" +
    "       id=\"text3542\"\n" +
    "       y=\"45.534565\"\n" +
    "       x=\"15.451201\"\n" +
    "       style=\"font-style:normal;font-weight:normal;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n" +
    "       xml:space=\"preserve\"><tspan\n" +
    "         style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:44.00321198px;line-height:1.25;font-family:Arial;-inkscape-font-specification:Arial\"\n" +
    "         y=\"45.534565\"\n" +
    "         x=\"15.451201\"\n" +
    "         id=\"tspan3544\">S</tspan></text>\n" +
    "    <rect\n" +
    "       y=\"5.1428571\"\n" +
    "       x=\"29.214287\"\n" +
    "       height=\"42.714287\"\n" +
    "       width=\"5.1428571\"\n" +
    "       id=\"rect3546\"\n" +
    "       style=\"fill:#ffffff\" />\n" +
    "    <text\n" +
    "       id=\"text4420\"\n" +
    "       y=\"27.142857\"\n" +
    "       x=\"6.1428571\"\n" +
    "       style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;line-height:0%;font-family:'Times New Roman';-inkscape-font-specification:'Times New Roman, ';letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n" +
    "       xml:space=\"preserve\"><tspan\n" +
    "         style=\"font-size:40px;line-height:1.25\"\n" +
    "         y=\"27.142857\"\n" +
    "         x=\"6.1428571\"\n" +
    "         id=\"tspan4422\"> </tspan></text>\n" +
    "    <text\n" +
    "       id=\"text4424\"\n" +
    "       y=\"20.714287\"\n" +
    "       x=\"9.7142859\"\n" +
    "       style=\"font-style:normal;font-weight:normal;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n" +
    "       xml:space=\"preserve\"><tspan\n" +
    "         style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:40px;line-height:1.25;font-family:Arial;-inkscape-font-specification:Arial\"\n" +
    "         y=\"20.714287\"\n" +
    "         x=\"9.7142859\"\n" +
    "         id=\"tspan4426\"> </tspan></text>\n" +
    "    <rect\n" +
    "       y=\"-20.857143\"\n" +
    "       x=\"84\"\n" +
    "       height=\"0.85714287\"\n" +
    "       width=\"0.2857143\"\n" +
    "       id=\"rect4682\"\n" +
    "       style=\"opacity:0.94214119;fill:#0000ff;fill-opacity:0.94117647;stroke:#005598;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0\" />\n" +
    "  </g>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("bmp/bmp-icons/svg/vat.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/vat.svg",
    "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 79.86 79.86\"><defs><style>.cls-1{fill:#0072a8;}</style></defs><title>Asset 2</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M68.52,0H11.34A11.34,11.34,0,0,0,0,11.34V68.52A11.34,11.34,0,0,0,11.34,79.86H68.52A11.34,11.34,0,0,0,79.86,68.52V11.34A11.34,11.34,0,0,0,68.52,0ZM44.24,60.34H35.53L21.09,19.93h8.84L40.16,49.84l9.9-29.91h8.65Z\"/></g></g></svg>");
}]);

angular.module("bmp/bmp-icons/svg/workpapers.svg", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("bmp/bmp-icons/svg/workpapers.svg",
    "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
    "<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n" +
    "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "	 width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n" +
    "<path id=\"path-1_1_\" fill=\"#397C2B\" d=\"M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2\n" +
    "	C0,0.896,0.896,0,2,0z M10.607,9.557L9.048,4H7.38L5.808,9.557L4.512,4H3l2.1,7.992h1.404L8.22,5.644l1.692,6.348h1.404L13.404,4\n" +
    "	h-1.512L10.607,9.557z\"/>\n" +
    "</svg>\n" +
    "");
}]);
